import {Dimensions} from 'react-native';

import { bf } from './bf';
import { ic } from './ic';
import { iv } from './iv';
import { cf } from './cf';
import { ce } from './ce';
import { cp } from './cp';

//export class ip { // individual call
export class ip { // individual call

  static $ip_load_cm1i = (pd={
    b_clr: false,
    mode: 'set',
    cm10_key: '',
  }) => new Promise( _o_end1 => { // 利用者追加情報
    if (pd.b_clr == true) {
      global.c?.setState({ 
        s_cm1ii110: '',
      }, ()=>{
        _o_end1(null);
      })
    }
    else {
      let _cnd = bf.q('[cm1ib11k]="{}"'.f(
        pd.cm10_key,
        global.c?.state.sgcd_pageCmns?.cm10_key,
      ));
      cf.myCB_call_slc({
        ctr: 'nlm', 
        elm: 'cm1i', 
        n_dms: 2, 
        cnd: _cnd
      })
      .then((_d_cm1is) => {
        //
        if (_d_cm1is) {
          global.c?.setState({ 
            s_cm1ii110: _d_cm1is.cm1ii110,
          }, ()=>{
            _o_end1(_d_cm1is);
          })
        }
        else {
          global.c?.setState({ 
            s_cm1ii110: '',
          }, ()=>{
            _o_end1(null);
          })
        };
      })
    };
  });

  static $ip_load_cm2i = (pd={ // 利用者グループ属性情報#i
    mode: 'set',
    b_clr: false,
    cnd: '',
    cm20_key: '',
  }) => new Promise( _o_end1 => {

    let _cnd = '';

    if (bf.f(pd.cnd)) {
      _cnd = pd.cnd;
    }
    else if (bf.f(pd.cm20_key)) {
      _cnd = bf.q('[cm2ib11k]="{}"'.f(
        pd.cm20_key,
      ));
    };

//bf.l('74: {}'.f(_cnd))
    if (pd.mode == 'set') {
      new Promise( _o_end2 => {
        if (pd.b_clr == true) {
          _o_end2(null);
        }
        else {
          cf.myCB_call_slc({
            ctr: 'nlm', 
            elm: 'cm2i', 
            n_dms: 2, 
            cnd: _cnd
          })
          .then( _d_cm2is => {
            _o_end2(_d_cm2is);
          });
        };
      })
      .then( _d_cm2is => {
//bf.l('87:{}, {}'.f(_cnd, _d_cm2is));
        if (bf.f(_d_cm2is)) {
          global.c?.setState({
            s_cm2i_key: _d_cm2is._KEY,
            s_cm2ii110: _d_cm2is.cm2ii110 || '0',
            s_cm2ii210: _d_cm2is.cm2ii210 || '0',
            s_cm2ii220: _d_cm2is.cm2ii220 || '0',
            s_cm2ii310: _d_cm2is.cm2ii310 || '0',
            s_cm2ii320: _d_cm2is.cm2ii320 || '0',
          }, ()=>{
//bf.l('97:{}'.f(global.c?.state.s_cm2ii320));
            _o_end1(_d_cm2is);
          });
        }
        else {
          global.c?.setState({
            s_cm2i_key: '',
            s_cm2ii110: '0',
            s_cm2ii210: '0',
            s_cm2ii220: '0',
            s_cm2ii310: '0',
            s_cm2ii320: '0',
          }, ()=>{
            _o_end1(_d_cm2is);
          });
        };
      })
    };
  });

  static $ip_ups_cm2i = (pd={}) => new Promise( _o_end1 => {
    let _d_vals = {
      cm2ib11k: global.c?.state.sgcd_pageCmns?.cm20_key,
      cm2ii110: global.c?.state.s_cm2ii110 || '',
      cm2ii210: global.c?.state.s_cm2ii210 || '',
      cm2ii220: global.c?.state.s_cm2ii220 || '',
      cm2ii310: global.c?.state.s_cm2ii310 || '',
      cm2ii320: global.c?.state.s_cm2ii320 || '',
    }
    let _cnd = bf.q('[cm2ib11k]="{}"'.f(global.c?.state.sgcd_pageCmns?.cm20_key))
    cf.myCB_call_iud({
      ctr: 'ups', 
      elm: 'cm2i', 
      d_vals: _d_vals, 
      cnd: _cnd
    })
    .then( () => {
      _o_end1();
    });
  });

  static $ip_load_cm5i = pd =>  new Promise( _o_end1 => { // 商品追加情報#i

    let _cnd = '';

    if (bf.f(pd.cm50_key)) {
      _cnd = bf.q('[cm5ib11k]="{}"'.f(
        pd.cm50_key
      ));
    };

    if (pd.mode == 'get') {
        if (pd.b_clr == true) {
          _o_end1(null);
        }
        else {
          cf.myCB_call_slc({
            ctr: 'nlm', 
            elm: 'cm5i', 
            n_dms: 2, 
            cnd: _cnd
          })
          .then( _d_cm5is => {
            if (bf.f(_d_cm5is)) {
              _o_end1(_d_cm5is);
            }
            else {
              _o_end1(null);
            };
          });
        };
    };

    if (pd.mode == 'set') {
      new Promise( _o_end2 => {
        if (pd.b_clr == true) {
          _o_end2(null);
        }
        else {
          cf.myCB_call_slc({
            ctr: 'nlm', 
            elm: 'cm5i', 
            n_dms: 2, 
            cnd: _cnd
          })
          .then( _d_cm5is => {
            _o_end2(_d_cm5is);
          });
        };
      })
      .then( _d_cm5is => {
        if (bf.f(_d_cm5is)) {
          global.c?.setState({ 
            s_cm5ii110: _d_cm5is.cm5ii110 || '0',
            s_cm5ii210: _d_cm5is.cm5ii210 || '0',
            s_cm5ii220: _d_cm5is.cm5ii220 || '0',
            s_cm5ii310: _d_cm5is.cm5ii310 || '0',
            s_cm5ii410: _d_cm5is.cm5ii410 || '2900',
          }, ()=>{
            _o_end1(_d_cm5is);
          });
        }
        else {
          global.c?.setState({ 
            s_cm5ii110: '0',
            s_cm5ii210: '0',
            s_cm5ii220: '0',
            s_cm5ii310: '0',
            s_cm5ii410: '2900',
          }, ()=>{
            _o_end1(null);
          });
        };
      });
    };
  });

  static $ip_ups_cm5i = (pd={}) => new Promise( _o_end1 => { // 商品属性情報#i の反映
    let _d_vals = {
      cm5ib11k: global.c?.state.sgcd_pageCmns?.cm50_key,
      cm5ii110: global.c?.state.s_cm5ii110 || '0',
      cm5ii210: global.c?.state.s_cm5ii210 || '0',
      cm5ii220: global.c?.state.s_cm5ii220 || '0',
      cm5ii310: global.c?.state.s_cm5ii310 || '0',
      cm5ii410: global.c?.state.s_cm5ii410 || '2900',
    };
    let _cnd = bf.q('[cm5ib11k]="{}"'.f(global.c?.state.sgcd_pageCmns?.cm50_key));
    cf.myCB_call_iud({
      ctr: 'ups', 
      elm: 'cm5i', 
      d_vals: _d_vals, 
      cnd: _cnd
    })
    .then(()=>{
      _o_end1();
    });
  });

  static $ip_load_im10 = (pd={
    cnd: '',
  }) => new Promise( _o_end1 => { // バインダ情報

    let _cnd = '';

    if (bf.f(pd.cnd)) {
      _cnd = pd.cnd;
    }
    else {
      if (bf.f(pd.im10_key)) {
        _cnd = bf.q('[_KEY]={}'.f(
          pd.im10_key
        ));
      }
      else if (bf.f(pd.cm20_key)) {
        _cnd = bf.q('[im10b11k]="{}"'.f(
          pd.cm20_key,
        ));
      };
    };

/*
    if (pd.b_withDlt == false) {
      if (bf.f(_cnd)) {
        _cnd += bf.q(' AND ');
      };
      _cnd += bf.q(' IFNULL([im10cz10],"10")<>"0"')
    };
*/

    if (pd.mode == 'set') {
      new Promise( _o_end2 => {
        if (pd.b_clr == true) {
          _o_end2(null);
        }
        else {
          cf.myCB_call_slc({
            ctr: 'nlm', 
            elm: 'im10', 
            n_dms: 2, 
            cnd: _cnd
          })
          .then(_d_im10s => {
            _o_end2(_d_im10s);
          });
        };
      })
      .then( _d_im10s => {
        if (bf.f(_d_im10s)) {
          global.c.setState({
            s_im10_key: _d_im10s._KEY,
            s_im10c310: _d_im10s.im10c310,
            s_im10cz10: _d_im10s.im10cz10 || '10',
          }, ()=>{
            _o_end1(_d_im10s);
          });
        }
        else {
          global.c.setState({
            s_im10_key: '',
            s_im10c310: '',
            s_im10cz10: '10',
          }, ()=>{
            _o_end1(null);
          });
        };
      });
    }
    else if (pd.mode == 'items') {
      cf.myCB_set_items({
        ctr: 'nlm',
        elm: 'im10', 
        n_dms: 3,
        state: pd.state, 
        cnd: _cnd,
        o_fnc: _d_im10s => {
          return {
            pfx: '{}'.f(_d_im10s.im10c310),
            spf: '{}'.f(_d_im10s.im10cz10),
            b_dlt: (pd.b_wotDlt == true && _d_im10s.im10cz10 == '0') ? true : false, // b_wotDlt == true かつ cz10 == '0'
          };
        },
        dld_pcksss: {
          im10cz10:[
            {key: '0', pfx:'表示しない'},
            {key: '10', pfx:'表示する'},
          ],
        },
        ld_sortss: [
          {fld:'im10cz10', dtn:'desc', mode:'str'}, 
          {fld:'_KEY', dtn:'asc', mode:'nmb'}
        ],

      })
      .then( _ld_im10ss => {
        _o_end1(_ld_im10ss);
      });
    };
  });

  static $ip_ins_im10 = pd => new Promise( _o_end1 => {
    let _d_vals = {
      im10b11k: global.c?.state.sgcd_pageCmns?.cm20_key,
      im10c310: global.c?.state.s_im10c310,
      im10cz10: '10',
    };
    let _cnd = '';
    cf.myCB_call_iud({
      ctr: 'ins', 
      elm: 'im10', 
      d_vals: _d_vals
    })
    .then( _d_im10s =>{
      cf.myRN_setCmns({
        im10_key: _d_im10s._KEY,
      })
      .then(() => {
        _o_end1(_d_im10s);
      });
    });
  });

  static $ip_upd_im10 = pd => new Promise( _o_end1 => { // バインダ情報の更新
    let _d_vals = {
      im10c310: global.c?.state.s_im10c310,
      im10cz10: global.c?.state.s_im10cz10 || '10',
    };
    let _cnd = bf.q('[_KEY]={}'.f(global.c.state.sgcd_pageCmns?.im10_key))
    cf.myCB_call_iud({
      ctr: 'upd', 
      elm: 'im10', 
      d_vals: _d_vals, 
      cnd: _cnd,
    })
    .then(()=>{
      _o_end1();
    });
  });

  static $ip_hlr_it10 = (pd={
    mode: 'get/set/itemss/clds',
    b_clr: false, // get, set
    state: '', // items, clds
    d_vals: {}, // ins/upd
    cnd: '',    
    ld_sortss: [{fld:'_KEY', dtn:'asc/desc'}],
  }) => new Promise( async _o_end1 => {
//bf.l('509:here')

    let _cnd = '';

    if (pd.cnd) {
      _cnd = pd.cnd;
    }
    else {
      if (bf.f(pd.it10_key)) { // 入店情報が指定されている場合
        _cnd = bf.q('[_KEY]={}'.f(
          pd.it10_key,
        ));
      };
      if (bf.f(pd.it50_key)) { // 入店情報が指定されている場合
        _cnd = bf.q('[it10b31k]="{}"'.f(
          pd.it50_key,
        ));
      };
    };


//bf.l('518:{}'.f(_cnd))
    cf.myCB_hlr({
      elm: 'it10',
      mode: pd.mode,
      b_clr: pd.b_clr,
      state: pd.state,
      d_vals: pd.d_vals,
      cnd: _cnd,
      ld_sortss: pd.ld_sortss,
      b_withCnd: false,
      do_rfrs: {
        im10: (_d_is) => bf.f(_d_is.it10b21k) ? bf.q('[_KEY]={}'.f(_d_is.it10b21k)) : null,
      },
      dld_pcksss: {
        it10t110:[ // 入店区分
          {key:'10', pfx: '新規'},
          {key:'20', pfx: '出戻り'},
        ],
        it10s110:[ // 接客状況
          {key:'0', pfx: '接客前'}, // 未サービス
          {key:'10', pfx: '接客中'}, // サービス中
          {key:'20', pfx: '接客済'}, // 支払済
        ]
      },
    })
    .then( _a_rs => {
//bf.l('544:here')
      _o_end1(_a_rs);
    })
  });

static op_loadAll = (pd={
  b_clr: true,
  cnd: '',
}) => new Promise( async _o_end1 => {

  new Promise( _o_end3 => {
    if (pd.b_clr == true) { // it10 において it50_key を設定するために必要
      let _cnd = bf.q(`
        [it50b11k]="{}" AND 
        [it50s110]="10"
      `.f(
        global.c?.state.sgcd_pageCmns.cm20_key
      ));
      cf.myCB_call_slc({
        ctr: 'nlm',
        elm :'it50',
        n_dms: 2,
        cnd: _cnd
      })
      .then( _d_it50s => {
        cf.myRN_setCmns({ // 別店舗の店舗運営者が注文情報を登録する場合に対応するため、入店情報の店舗と同期を取る
          it50_key: _d_it50s._KEY,
        })
        .then(() => {
//bf.l('464: {}, {}'.f(global.c?.state.sgcd_pageCmns.it50_key, _cnd))
          _o_end3();
        });
      })
    }
    else {
      _o_end3();
    }
  })
  .then(() => {
  //bf.l('445: here')
    ip.$ip_load_it10({ // 入店情報
      mode: 'set',
  //    b_clr: (global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName] == 'new') ? true : false,
  //    cnd: bf.q(`[_KEY]={}`.f(global.c?.state.sgcd_pageCmns?.it10_key)),
      b_clr: pd.b_clr ?? false,
      cnd: pd.cnd ?? '',
    })
    .then( _d_it10s => {
      cf.myRN_setCmns({ // 別店舗の店舗運営者が注文情報を登録する場合に対応するため、入店情報の店舗と同期を取る
        cm20_key: bf.f(_d_it10s) ? _d_it10s.it10b11k : global.c?.state.sgcd_pageCmns.cm20_key,
      })
      .then(() => {
        let _cnd = bf.q(`
          [cm10b21k]="{}" AND 
          [cm10i110]=(
            SELECT
              [cm10i110]
            FROM
              [t_cm10]
            WHERE
              [_KEY]={}
          ) AND
          IFNULL([cm10cz10],"10")<>"0"
        `.f(
          global.c?.state.sgcd_pageCmns.cm20_key,
          global.c?.state.sgcd_pageCmns.cm10_key,
        ));
//bf.l('503: {}'.f(_cnd))
        cp.$cp_load_cm10({ // ユーザ情報の設定
          mode: 'set',
          cnd: _cnd,
        })
        .then( _d_cm10s => {
          if (bf.f(_d_cm10s) == false) { // ユーザ情報を確認できなかった場合
            alert('入店時刻情報が紐づく店舗において、ユーザを確認できませんでした。');
            let _d_pageInfs =  iv.get_iniPageInfs(global.c?.state.sgcd_pageModes.user_key, global.c?.state.sgcd_pageModes.userc410);
            cf.myLS_setStt('sgcd_pageModes', bf.p(global.c?.state.sgcd_pageModes, _next => {
              _next[_d_pageInfs.sgc_pageName] = 'show';
            }))
            .then(() => {
              cf.myRN_move_fwd(_d_pageInfs)
              .then(() => {
                _o_end1(-1);
              });
            });
          }
          else { // ユーザ情報を確認できた場合
            cf.myRN_setCmns({ // 入店情報の店舗のユーザと同期を取る
              cm10_key: _d_cm10s._KEY,
            })
            .then(() => {
              Promise.all([
                ip.$ip_load_it50({ // 日別情報 myCB_callQrys にて it60_key の設定に必要
                  mode: 'set',
                  cnd: bf.q(`
                    [it50b11k]="{}" AND 
                    [it50s110]="10"
                  `.f(
                    global.c?.state.sgcd_pageCmns.cm20_key
                  )),
                }),
                ip.$ip_load_cm2i({ // 利用者グループ属性情報＃i
                  mode: 'set',
                  cnd: bf.q('[cm2ib11k]="{}"'.f(
                    global.c?.state.sgcd_pageCmns?.cm20_key,
                  )),
                }),
                cp.$cp_load_cm50({ // コース用 商品情報
                  mode: 'items',
                  b_wotDlt: true,
                  state: 'sld_cm50ss',
                  cnd: bf.q(`
                    [cm50b11k]="{}" AND 
                    [cm50t110] LIKE "1__" AND 
                    IFNULL([cm50cz10],"10")<>"0"
                  `.f(
                    global.c?.state.sgcd_pageCmns?.cm20_key
                  )),
                }),
                new Promise( _o_end2 => {
                  cp.$cp_load_cm10({ // スタッフ情報
                    mode: 'items',
                    b_wotDlt: true,
                    state: 'sld_cm10ss',
                    cnd: bf.q('[_KEY]>0'), // 他店舗や過去履歴の社員を表示するために必要
                  })
                  .then(() => {
                    global.c?.setState({
                      sld_cm10ss: bf.p(global.c?.state.sld_cm10ss, _next => {
                        _next
                        .map( (_d_cm10s, _idx) => {
                          if (
                            bf.n(_d_cm10s.val.cm10b21k) != bf.n(global.c?.state.sgcd_pageCmns?.cm20_key) ||
                            bf.n(_d_cm10s.val.cm10cz10) != 10
                          ) {
                            _d_cm10s.b_hide = true;
                          }
                          else {
                            _d_cm10s.b_hide = false;
                          }
                        })
                      }),
                    }, () => {
                      _o_end2();
                    });
                  })
                }),
                cp.$cp_load_cm50({ // 注文用 商品情報
                  mode: 'items',
                  b_wotDlt: true,
                  state: 'sld_cm50ss2',
                  cnd: bf.q(`
                    [cm50b11k]="{}" AND 
                    [cm50t110] NOT LIKE "1__" AND 
                    IFNULL([cm50cz10],"10")<>"0"
                  `.f(
                    global.c?.state.sgcd_pageCmns?.cm20_key,
                  )),
                }),
                ip.$ip_load_im10({ // バインダ情報
                  mode: 'items',
                  b_wotDlt: true,
                  state: 'sld_im10ss',
                  cnd: bf.q(`
                    [im10b11k]="{}" AND 
                    IFNULL([im10cz10],"10")<>"0"
                  `.f(
                    global.c?.state.sgcd_pageCmns?.cm20_key
                  )),
                }),
                new Promise( _o_end2 => { // _onChgIt30i110 において使用
                  cf.myCB_call_slc({
                    ctr: 'nlm',
                    elm: 'cm50',
                    n_dms: 3,
                    cnd: bf.q('[cm50b11k]="{}"'.f(
                      global.c?.state.sgcd_pageCmns.cm20_key,
                    )),
                    do_rfrs: {
                      cm5i: _d_is => bf.q('[cm5ib11k]="{}"'.f(_d_is._KEY)),
                    }
                  })
                  .then( _ld_cm50ss => {
                    let _d = {};
                    _ld_cm50ss
                    .map( _d_cm50s => {
                      _d[_d_cm50s._KEY] = _d_cm50s;
                    });
                    global.c?.setState({
                      sdd_cm50ss: _d,
                    }, () => {
                      _o_end2();       
                    });
                  })
                }),
                ip.$ip_load_it11({ // 外販担当者
                  mode: 'clds',      
    //              b_clr: (global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName] == 'new') ? true : false,
                  b_clr: pd.b_clr ?? false,
                  state: 'sld_it11ss',
    //              it10_key: global.c?.state.sgcd_pageCmns?.it10_key,
                  cnd: bf.q(`
                    [it11b11k]="{}"
                  `.f(
                    global.c?.state.sgcd_pageCmns?.it10_key
                  )),
                }),
                ip.$ip_load_it30({ // 注文情報の反映 // エラーが発生した場合は t_it31 が生成されていることを確認
                  mode: 'clds',
                  b_clr: pd.b_clr ?? false,
                  state: 'sld_it30ss',
                  cnd: bf.q(`
                    [it30b11k]="{}"
                  `.f(
                    global.c?.state.sgcd_pageCmns?.it10_key
                  )),
                }),
              ])
              .then(() => {
//bf.l('655: {}'.f(global.c?.state.sld_it30ss))
                _o_end1(bf.f(_d_it10s) ? 1 : -2); // 1: 入店時刻情報が存在した場合, -2: 入店時刻情報が存在しなかった場合
              });
            });
          };
        })
      })
    });
  });
});

  static $ip_load_it10 = (pd={
    mode: 'set',
    b_clr: false,
    it10_key: '',
    im10_key: '',
    cm20_key: '',
    dtm: '',
    ld_sortss: [{fld:'_KEY', dtn:'asc'}],
    cnd: '',
  }) => new Promise( _o_end1 => { // 顧客情報の反映

    let _cnd = '';

    if (bf.f(pd.cnd)) { // 入店情報が指定されている場合
      _cnd = pd.cnd;
    }
    else {
      if (bf.f(pd.it10_key)) { // 入店情報が指定されている場合
        _cnd = bf.q('[_KEY]={}'.f(
          pd.it10_key,
        ));
      }
      else if (bf.f(pd.cm20_key)) { // 店舗情報が指定されている場合
        _cnd = bf.q('[it10b11k]="{}"'.f(
          pd.cm20_key,
        ));
      }
      else if (bf.f(pd.it50_key)) { // 日別情報が指定されている場合
        _cnd = bf.q('[it10b31k]="{}"'.f(
          pd.it50_key,
        ));
      }
      else if (bf.f(pd.im10_key) && bf.f(pd.dtm)) { // バインダが指定されている場合
        _cnd = bf.q('[it10b21k]="{}" AND [it10d110]<="{}" AND [it10d120]>="{}"'.f(
          pd.im10_key,
          pd.dtm,
          pd.dtm,
        ));
      }
    };

//bf.l('458:{}'.f(_cnd))
    if (pd.mode == 'get') {
      if (pd.b_clr == true) {
        _o_end1(null);
      }
      else {
        cf.myCB_call_slc({
          ctr: 'nlm', 
          elm: 'it10', 
          n_dms: 2, 
          cnd: _cnd
        })
        .then( _d_it10s => {
          _o_end1(_d_it10s);
        });
      };
    }
    else if (pd.mode == 'set') {
      new Promise( _o_end2 => {
        if (pd.b_clr == true) {
          _o_end2(null);
        }
        else {
          cf.myCB_call_slc({
            ctr: 'nlm', 
            elm: 'it10', 
            n_dms: 2, 
            cnd: _cnd
          })
          .then( _d_it10s => {
            _o_end2(_d_it10s);
          });
        }
      })
      .then( _d_it10s => {
        if (bf.f(_d_it10s)) {
//alert('1165:{}'.f(_cnd, _d_it10s));
          cf.myRN_setCmns({
            it10_key: _d_it10s._KEY,
            it50_key: _d_it10s.it10b31k,
          })
          .then(() => {
            global.c?.setState({
              s_it10_key: _d_it10s._KEY,
              s_it10b11k: _d_it10s.it10b11k,
              s_it10b21k: _d_it10s.it10b21k,
              s_it10b31k: _d_it10s.it10b31k,
              s_it10t110: _d_it10s.it10t110 || '-1',
              s_it10s110: _d_it10s.it10s110 || '-1',
              s_it10s210: _d_it10s.it10s210 || '-1',
              s_it10d110: _d_it10s.it10d110,
              s_it10d120: _d_it10s.it10d120,
              s_it10d130: _d_it10s.it10d130,
              s_it10d140: _d_it10s.it10d140,
              s_it10c310: _d_it10s.it10c310,
              s_it10i110: _d_it10s.it10i110,
              s_it10i210: _d_it10s.it10i210 || '0',
              s_it10i220: _d_it10s.it10i220 || '0',
              s_it10i2a0: _d_it10s.it10i2a0 || '0',
              s_it10i2b0: _d_it10s.it10i2b0 || '0',
              s_it10i310: _d_it10s.it10i310 || '0',
              s_it10i320: _d_it10s.it10i320 || '0',
              s_it10i330: _d_it10s.it10i330 || '0',
              s_it10i340: _d_it10s.it10i340 || '0',
              s_it10i350: _d_it10s.it10i350 || '0',
              s_it10i360: _d_it10s.it10i360 || '0',
              s_it10i410: _d_it10s.it10i410 || '',
              s_it10i510: _d_it10s.it10i510 || '0',
              s_it10i520: _d_it10s.it10i520 || '0',
              s_it10i530: _d_it10s.it10i530 || '0',
              s_it10i610: _d_it10s.it10i610 || '0',
              s_it10i620: _d_it10s.it10i620 || '0',
              s_it10i640: _d_it10s.it10i640 || '0',
              s_it10i720: _d_it10s.it10i720 || '0',
              s_it10i730: _d_it10s.it10i730 || '0',
              s_it10ia10: _d_it10s.it10ia10 || '0',
              s_it10ia20: _d_it10s.it10ia20 || '0',
              s_it10ia30: _d_it10s.it10ia30 || '0',
              s_it10ia40: _d_it10s.it10ia40 || '0',
              s_it10ia50: _d_it10s.it10ia50 || '0',
              s_it10ia60: _d_it10s.it10ia60 || '0',
              s_it10ia70: _d_it10s.it10ia70 || '0',
              s_it10ib10: _d_it10s.it10ib10 || '0',
              s_it10ib20: _d_it10s.it10ib20 || '0',
              s_it10cy30: _d_it10s.it10cy30 || '0',
            }, ()=>{
              _o_end1(_d_it10s);
            })
          });
        }
        else {
          cf.myRN_setCmns({
            it10_key: '',
//            it50_key: pd.it50_key,
          })
          .then(() => {
            global.c?.setState({
              s_it10_key: '',
              s_it10b11k: '',
              s_it10b21k: '-1',
//              s_it10b31k: pd.it50_key,
              s_it10b31k: global.c?.state.sgcd_pageCmns.it50_key,
              s_it10t110: '-1',
              s_it10s110: '0',
              s_it10s210: '0',
              s_it10d110: bf.maxDtm,
              s_it10d120: bf.maxDtm,
              s_it10d130: bf.maxDtm,
              s_it10d140: bf.maxDtm,
              s_it10c310: '',
              s_it10i110: '0',
              s_it10i210: '0',
              s_it10i220: '0',
              s_it10i2a0: '0',
              s_it10i2b0: '0',
              s_it10i310: '0',
              s_it10i320: '0',
              s_it10i330: '0',
              s_it10i340: '0',
              s_it10i350: '0',
              s_it10i360: '0',
              s_it10i410: 'その他',
              s_it10i510: '0',
              s_it10i520: '0',
              s_it10i530: '0',
              s_it10i610: '0',
              s_it10i620: '0',
              s_it10i640: '0',
              s_it10i720: '0',
              s_it10i730: '0',
              s_it10ia10: '0',
              s_it10ia20: '0',
              s_it10ia30: '0',
              s_it10ia40: '0',
              s_it10ia50: '0',
              s_it10ia60: '0',
              s_it10ia70: '0',
              s_it10ib10: '0',
              s_it10ib20: '0',
              s_it10cy30: '1900-01-01 00:00:00',
            }, ()=>{
              _o_end1(null);
            })
          });
        };
      });
    }
    else if (pd.mode == 'items') {
      cf.myCB_set_items({
        ctr: 'nlm',
        elm: 'it10', 
        n_dms: 3,
        state: pd.state, 
        cnd: _cnd, 
        do_rfrs: {
          im10: (_d_vals) => {
            if (bf.f(_d_vals.it10b21k)) {
              return bf.q('[_KEY]={}'.f(_d_vals.it10b21k));
            }
            else {
              return null;
            };
          },
        },
        dld_pcksss: {
          it10t110:[ // 入店区分
            {key:'10', pfx: '新規'},
            {key:'20', pfx: '出戻り'},
          ],
          it10s110:[ // 接客状況
            {key:'0', pfx: '接客前'}, // 未サービス
            {key:'10', pfx: '接客中'}, // サービス中
            {key:'20', pfx: '接客済'}, // 支払済
          ]
        },
        ld_sortss: pd.ld_sortss,
        o_fnc: _d_it10s => {
          _d_it10s.im10c310 = _d_it10s.im10c310 || '未選択';
          _d_it10s.it10ia70 = _d_it10s.it10ia70 || '0';
          let _sos = (_d_it10s.it10s210 == '10') ? 'SOS' : '';
          return {
            pfx:'{}：{}（{}円）{}'.f(
              _d_it10s.im10c310,
              _d_it10s.it10s110,
              bf.myCM_cnv('cmm', _d_it10s.it10ia70),
              _sos,
              ),
            spf:'{}人 {}〜{}'.f(
              _d_it10s.it10i330,
              _d_it10s.it10d110.slice(-8).slice(0,5),
              _d_it10s.it10d120.slice(-8).slice(0,5),
            ),
          };
        }
      })
      .then( () => {
          _o_end1();
      });
    };
  });

/*
  static $ip_upd_it10 = (pd={
    it10_key: '',
  }) => new Promise( _o_end1 => {
    let _d_vals = {
      it10b21k: global.c?.state.s_it10b21k || '',
      it10d110: global.c?.state.s_it10d110 || '',
      it10d120: global.c?.state.s_it10d120 || '',
      it10d130: global.c?.state.s_it10d130 || '',
      it10d140: global.c?.state.s_it10d140 || '',
      it10t110: global.c?.state.s_it10t110 || '-1',
      it10s110: global.c?.state.s_it10s110 || '-1',
      it10s210: global.c?.state.s_it10s210 || '-1',
      it10c310: global.c?.state.s_it10c310 || '',
      it10i110: global.c?.state.s_it10i110 || '',
      it10i210: bf.n(global.c?.state.s_it10i210) || 0,
      it10i220: global.c?.state.s_it10i220 || '0',
      it10i2a0: global.c?.state.s_it10i2a0 || '0',
      it10i2b0: global.c?.state.s_it10i2b0 || '0',
      it10i310: bf.n(global.c?.state.s_it10i310) || 0,
      it10i320: bf.n(global.c?.state.s_it10i320) || 0,
      it10i330: bf.n(global.c?.state.s_it10i330) || 0,
      it10i360: bf.n(global.c?.state.s_it10i360) || 0,
      it10i410: global.c?.state.s_it10i410 || 'その他',
      it10i510: global.c?.state.s_it10i510 || '0',
      it10i520: global.c?.state.s_it10i520 || '0',
      it10i530: global.c?.state.s_it10i530 || '0',
      it10i720: bf.n(global.c?.state.s_it10i720) || '0',
      it10i730: bf.n(global.c?.state.s_it10i730) || '0',
      it10ia20: bf.n(global.c?.state.s_it10ia20) || '0',
      it10ia50: bf.n(global.c?.state.s_it10ia50) || '0',
      it10ia60: bf.n(global.c?.state.s_it10ia60) || '0',
      it10cy30: bf.myDT_get_now() || '',
      it10cy40: global.c?.state.sgcd_pageCmns?.cm10_key || '',
    };
    let _cnd = bf.q('[_KEY]={}'.f(
      pd.it10_key,
    ));
    cf.myCB_call_iud({
      ctr: 'upd', 
      elm: 'it10', 
      d_vals: _d_vals, 
      cnd: _cnd
    })
    .then( () => { // 同一情報は同一画面上で処理することが望ましい
      cf.myRN_pll([
        // 顧客情報の更新、延長客数は注文登録時に更新
        ip.$ip_upd_it10d120(), // it10d120: 終了日時
        ip.$ip_updIt10i340(), // it10i340: 外販客数
        ip.$ip_updIt50i920(), // 新規客数・反響率
        ip.$ip_updIt10i350(), // it10i350: 延長客数
        ip.$ip_updIt10ia70(), // it10i640: 総コース料金
        cf.myCB_call_iud({
          ctr: 'qrys', 
          elm: '--', 
          l_qrys: [
          // 日別情報 カード売上
          bf.q(`
            UPDATE 
              [t_it50] 
            SET 
              [it50i220]=(
                SELECT 
                  SUM(IFNULL([it10i730],"0")::NUMERIC::INTEGER)::TEXT
                FROM 
                  [t_it10] 
                WHERE 
                  [it10b31k]=[t_it50].[_KEY]::TEXT
              )
            WHERE 
              [t_it50].[_KEY]={}
          `.f(
            global.c?.state.s_it10b31k,
          )),
          // 日別情報 当日レジ金
          bf.q(`
            UPDATE 
              [t_it50] 
            SET 
              [it50i520]=(
                REPLACE(IFNULL([it50i510],"0"),"None","0")::NUMERIC::INTEGER
                + REPLACE(IFNULL([it50i210],"0"),"None","0")::NUMERIC::INTEGER
                - REPLACE(IFNULL([it50i220],"0"),"None","0")::NUMERIC::INTEGER
                - REPLACE(IFNULL([it50i310],"0"),"None","0")::NUMERIC::INTEGER
                - REPLACE(IFNULL([it50i320],"0"),"None","0")::NUMERIC::INTEGER
                - REPLACE(IFNULL([it50i410],"0"),"None","0")::NUMERIC::INTEGER
              )::TEXT
            WHERE 
              [t_it50].[_KEY]={}
          `.f(
            global.c?.state.s_it10b31k,
          )),
          // 日別情報 総客数 ※出戻りは対象外
          bf.q(`
            UPDATE 
              [t_it50] 
            SET 
              [it50i810]=(
                SELECT 
                  SUM(IFNULL([it10i330], "0")::NUMERIC::INTEGER)::TEXT 
                FROM 
                  [t_it10] 
                WHERE 
                  [it10b31k]=[t_it50].[_KEY]::TEXT AND [it10s110] IN ("10","20") AND [it10t110] IN ("10")
              )
            WHERE 
              [t_it50].[_KEY]={}
          `.f(
            global.c?.state.s_it10b31k,
          )),
          // 日別情報 客単価
          bf.q(`
            UPDATE 
              [t_it50] 
            SET 
              [it50i820]=(
                SELECT CASE
                  WHEN
                    REPLACE(IFNULL([it50i810],"0"),"None","0")::NUMERIC::INTEGER = 0
                  THEN
                    0
                  ELSE
                    REPLACE(IFNULL([it50i210],"0"),"None","0")::NUMERIC::INTEGER / REPLACE(IFNULL([it50i810],"0"),"None","0")::NUMERIC::INTEGER
                  END
              )::TEXT
            WHERE 
              [t_it50].[_KEY]={}
          `.f(
            global.c?.state.s_it10b31k,
          )),
          // 日別情報 総組数 ※出戻りは対象外
          bf.q(`
            UPDATE 
              [t_it50] 
            SET 
              [it50i870]=(
                SELECT 
                  COUNT(*)::TEXT
                FROM 
                  [t_it10] 
                WHERE 
                  [it10b31k]=[t_it50].[_KEY]::TEXT AND [it10s110] IN ("10","20") AND [it10t110] IN ("10")
              )
            WHERE 
              [t_it50].[_KEY]={}
          `.f(
            global.c?.state.s_it10b31k,
          )),
          // 日別情報 組単価
          bf.q(`
            UPDATE 
              [t_it50] 
            SET 
              [it50i880]=(
                SELECT CASE
                  WHEN
                    REPLACE(IFNULL([it50i870],"0"),"None","0")::NUMERIC::INTEGER = 0
                  THEN
                    0
                  ELSE
                    REPLACE(IFNULL([it50i210],"0"),"None","0")::NUMERIC::INTEGER / REPLACE(IFNULL([it50i870],"0"),"None","0")::NUMERIC::INTEGER
                  END
              )::TEXT
            WHERE 
              [t_it50].[_KEY]={}
          `.f(
            global.c?.state.s_it10b31k,
          )),
          // 日別情報 現在組数
          bf.q(`
            UPDATE 
              [t_it50] 
            SET 
              [it50i850]=(
                SELECT 
                  COUNT(*)::TEXT
                FROM 
                  [t_it10] 
                WHERE 
                  [it10b31k]=[t_it50].[_KEY]::TEXT AND [it10s110]="10"
              )
            WHERE 
              [t_it50].[_KEY]={}
          `.f(
            global.c?.state.s_it10b31k,
          )),
          // 日別情報 現在客数
          bf.q(`
            UPDATE 
              [t_it50] 
            SET 
              [it50i860]=(
                SELECT 
                  SUM(IFNULL([it10i330], "0")::NUMERIC::INTEGER)::TEXT 
                FROM 
                  [t_it10] 
                WHERE 
                  [it10b31k]=[t_it50].[_KEY]::TEXT AND [it10s110]="10"
              )
            WHERE 
              [t_it50].[_KEY]={}
          `.f(
            global.c?.state.s_it10b31k,
          )),
          // 日別情報 登録日時
          bf.q(`
            UPDATE 
              [t_it50] 
            SET 
              [it50cy10]="{}"
            WHERE 
              [t_it50].[_KEY]={}
          `.f(
            bf.myDT_get_now(), // クライアントの現在時刻の影響を受けることに注意
            global.c?.state.s_it10b31k,
          )),
          // 月別情報 総組数
          bf.q(`
            UPDATE [t_it60] SET 
              [it60i870]=(
                SELECT 
                  SUM(IFNULL([it50i870],"0")::NUMERIC::INTEGER)::TEXT 
                FROM 
                  [t_it50]
                WHERE 
                  [it50b21k]=[t_it60].[_KEY]::TEXT
              )
            WHERE 
              [t_it60].[_KEY]=(
                SELECT [it50b21k]::NUMERIC::INTEGER FROM [t_it50] WHERE [t_it50].[_KEY]={}
              )
          `.f(
            global.c?.state.s_it10b31k,
          )),
          // 月別情報 組単価
          bf.q(`
            UPDATE 
              [t_it60] 
            SET 
              [it60i8b0]=(
                SELECT CASE
                  WHEN
                    REPLACE(IFNULL([it60i870],"0"),"None","0")::NUMERIC::INTEGER = 0
                  THEN
                    0
                  ELSE
                    REPLACE(IFNULL([it60i210],"0"),"None","0")::NUMERIC::INTEGER / REPLACE(IFNULL([it60i870],"0"),"None","0")::NUMERIC::INTEGER
                  END
              )::TEXT
            WHERE 
              [t_it60].[_KEY]=(
                SELECT [it50b21k]::NUMERIC::INTEGER FROM [t_it50] WHERE [t_it50].[_KEY]={}
              )
          `.f(
            global.c?.state.s_it10b31k,
          )),
          // 月別情報 総客数
          bf.q(`
            UPDATE [t_it60] SET 
              [it60i810]=(
                SELECT 
                  SUM(IFNULL([it50i810],"0")::NUMERIC::INTEGER)::TEXT 
                FROM 
                  [t_it50]
                WHERE 
                  [it50b21k]=[t_it60].[_KEY]::TEXT
              )
            WHERE 
              [t_it60].[_KEY]=(
                SELECT [it50b21k]::NUMERIC::INTEGER FROM [t_it50] WHERE [t_it50].[_KEY]={}
              )
          `.f(
            global.c?.state.s_it10b31k,
          )),
          // 月別情報 平日客数
          bf.q(`
            UPDATE 
              [t_it60] 
            SET 
              [it60i8c0]=(
                SELECT 
                  SUM(IFNULL([it50i810],"0")::NUMERIC::INTEGER)::TEXT
                FROM 
                  [t_it50] 
                WHERE 
                  [it50b21k]=[t_it60].[_KEY]::TEXT AND IFNULL([it50t110],"0")="10"
              )::TEXT
            WHERE 
              [t_it60].[_KEY]=(
                SELECT [it50b21k]::NUMERIC::INTEGER FROM [t_it50] WHERE [t_it50].[_KEY]={}
              )
          `.f(
            global.c?.state.s_it10b31k,
          )),
          // 月別情報 休日前客数
          bf.q(`
            UPDATE 
              [t_it60] 
            SET 
              [it60i8d0]=(
                SELECT 
                  SUM(IFNULL([it50i810],"0")::NUMERIC::INTEGER)::TEXT
                FROM 
                  [t_it50] 
                WHERE 
                  [it50b21k]=[t_it60].[_KEY]::TEXT AND IFNULL([it50t110],"0")="20"
              )::TEXT
            WHERE 
              [t_it60].[_KEY]=(
                SELECT [it50b21k]::NUMERIC::INTEGER FROM [t_it50] WHERE [t_it50].[_KEY]={}
              )
          `.f(
            global.c?.state.s_it10b31k,
          )),
          // 月別情報 休日客数
          bf.q(`
            UPDATE 
              [t_it60] 
            SET 
              [it60i8e0]=(
                SELECT 
                  SUM(IFNULL([it50i810],"0")::NUMERIC::INTEGER)::TEXT
                FROM 
                  [t_it50] 
                WHERE 
                  [it50b21k]=[t_it60].[_KEY]::TEXT AND IFNULL([it50t110],"0")="30"
              )::TEXT
            WHERE 
              [t_it60].[_KEY]=(
                SELECT [it50b21k]::NUMERIC::INTEGER FROM [t_it50] WHERE [t_it50].[_KEY]={}
              )
          `.f(
            global.c?.state.s_it10b31k,
          )),
          // 月別情報 客単価
          bf.q(`
            UPDATE 
              [t_it60] 
            SET 
              [it60i820]=(
                SELECT CASE
                  WHEN
                    REPLACE(IFNULL([it60i810],"0"),"None","0")::NUMERIC::INTEGER = 0
                  THEN
                    0
                  ELSE
                    REPLACE(IFNULL([it60i210],"0"),"None","0")::NUMERIC::INTEGER / REPLACE(IFNULL([it60i810],"0"),"None","0")::NUMERIC::INTEGER
                  END
              )::TEXT
            WHERE 
              [t_it60].[_KEY]=(
                SELECT [it50b21k]::NUMERIC::INTEGER FROM [t_it50] WHERE [t_it50].[_KEY]={}
              )
          `.f(
            global.c?.state.s_it10b31k,
          )),
          // 月別情報 平均客数
          bf.q(`
            UPDATE 
              [t_it60] 
            SET 
              [it60i850]=(
                SELECT CASE
                  WHEN
                    REPLACE(IFNULL([it60i310],"0"),"None","0")::NUMERIC::INTEGER = 0
                  THEN
                    0.00
                  ELSE
                    ROUND(REPLACE(IFNULL([it60i810],"0"),"None","0")::NUMERIC::REAL * 100.00 / REPLACE(IFNULL([it60i310],"0"),"None","0")::NUMERIC::REAL) / 100.00
                  END
              )::TEXT
            WHERE 
              [t_it60].[_KEY]=(
                SELECT [it50b21k]::NUMERIC::INTEGER FROM [t_it50] WHERE [t_it50].[_KEY]={}
              )
          `.f(
            global.c?.state.s_it10b31k,
          )),

          // 月別情報 平均平日客数
          bf.q(`
            UPDATE 
              [t_it60] 
            SET 
              [it60i8f0]=(
                SELECT CASE
                  WHEN
                    REPLACE(IFNULL([it60i320],"0"),"None","0")::NUMERIC::INTEGER = 0
                  THEN
                    0
                  ELSE
                    REPLACE(IFNULL([it60i8c0],"0"),"None","0")::NUMERIC::INTEGER / REPLACE(IFNULL([it60i320],"0"),"None","0")::NUMERIC::INTEGER
                  END
              )::TEXT
            WHERE 
              [t_it60].[_KEY]=(
                SELECT [it50b21k]::NUMERIC::INTEGER FROM [t_it50] WHERE [t_it50].[_KEY]={}
              )
          `.f(
            global.c?.state.s_it10b31k,
          )),
          // 月別情報 平均休日前客数
          bf.q(`
            UPDATE 
              [t_it60] 
            SET 
              [it60i8g0]=(
                SELECT CASE
                  WHEN
                    REPLACE(IFNULL([it60i330],"0"),"None","0")::NUMERIC::INTEGER = 0
                  THEN
                    0
                  ELSE
                    REPLACE(IFNULL([it60i8d0],"0"),"None","0")::NUMERIC::INTEGER / REPLACE(IFNULL([it60i330],"0"),"None","0")::NUMERIC::INTEGER
                  END
              )::TEXT
            WHERE 
              [t_it60].[_KEY]=(
                SELECT [it50b21k]::NUMERIC::INTEGER FROM [t_it50] WHERE [t_it50].[_KEY]={}
              )
          `.f(
            global.c?.state.s_it10b31k,
          )),
          // 月別情報 平均休日客数
          bf.q(`
            UPDATE 
              [t_it60] 
            SET 
              [it60i8h0]=(
                SELECT CASE
                  WHEN
                    REPLACE(IFNULL([it60i340],"0"),"None","0")::NUMERIC::INTEGER = 0
                  THEN
                    0
                  ELSE
                    REPLACE(IFNULL([it60i8e0],"0"),"None","0")::NUMERIC::INTEGER / REPLACE(IFNULL([it60i340],"0"),"None","0")::NUMERIC::INTEGER
                  END
              )::TEXT
            WHERE 
              [t_it60].[_KEY]=(
                SELECT [it50b21k]::NUMERIC::INTEGER FROM [t_it50] WHERE [t_it50].[_KEY]={}
              )
          `.f(
            global.c?.state.s_it10b31k,
          )),

          // 月別情報 客数予測 it60i860
          bf.q(`
            UPDATE 
              [t_it60] 
            SET 
              [it60i860]=(
                REPLACE(IFNULL([it60i850],"0"),"None","0")::NUMERIC::INTEGER * REPLACE(IFNULL([it60i510],"0"),"None","0")::NUMERIC::INTEGER
              )::TEXT
            WHERE 
              [t_it60].[_KEY]=(
                SELECT [it50b21k]::NUMERIC::INTEGER FROM [t_it50] WHERE [t_it50].[_KEY]={}
              )
          `.f(
            global.c?.state.s_it10b31k,
          )),
          // 月別情報 総新規客数
          bf.q(`
            UPDATE [t_it60] SET 
              [it60i880]=(
                SELECT 
                  SUM(IFNULL([it50i920],"0")::NUMERIC::INTEGER)::TEXT 
                FROM 
                  [t_it50]
                WHERE 
                  [it50b21k]=[t_it60].[_KEY]::TEXT
              )
            WHERE 
              [t_it60].[_KEY]=(
                SELECT [it50b21k]::NUMERIC::INTEGER FROM [t_it50] WHERE [t_it50].[_KEY]={}
              )
          `.f(
            global.c?.state.s_it10b31k,
          )),
          // 月別情報 平均新規客数
          bf.q(`
            UPDATE 
              [t_it60] 
            SET 
              [it60i890]=(
                SELECT CASE
                  WHEN
                    REPLACE(IFNULL([it60i310],"0"),"None","0")::NUMERIC::INTEGER = 0
                  THEN
                    0.00
                  ELSE
                    ROUND(REPLACE(IFNULL([it60i880],"0"),"None","0")::NUMERIC::REAL * 100.00 / REPLACE(IFNULL([it60i310],"0"),"None","0")::NUMERIC::REAL) / 100.00
                  END
              )::TEXT
            WHERE 
              [t_it60].[_KEY]=(
                SELECT [it50b21k]::NUMERIC::INTEGER FROM [t_it50] WHERE [t_it50].[_KEY]={}
              )
          `.f(
            global.c?.state.s_it10b31k,
          )),
          // 月別情報 新規客数予測 it60i860
          bf.q(`
            UPDATE 
              [t_it60] 
            SET 
              [it60i8a0]=(
                REPLACE(IFNULL([it60i890],"0"),"None","0")::NUMERIC::INTEGER * REPLACE(IFNULL([it60i510],"0"),"None","0")::NUMERIC::INTEGER
              )::TEXT
            WHERE 
              [t_it60].[_KEY]=(
                SELECT [it50b21k]::NUMERIC::INTEGER FROM [t_it50] WHERE [t_it50].[_KEY]={}
              )
          `.f(
            global.c?.state.s_it10b31k,
          )),
          // 日別時間帯別入店客数の更新 ※出戻りを除く
          bf.q(`
            UPDATE 
              [t_it51] 
            SET 
              [it51i110]=(
                SELECT 
                  IFNULL(SUM(REPLACE(IFNULL([it10i330],"0"),"None","0")::NUMERIC::INTEGER),0)
                FROM 
                  [t_it10]
                WHERE 
                  [it10b11k]=[it51b11k] AND SUBSTRING([it10d110],1,13)=SUBSTRING([it51d310],1,13) AND [it10t110]="10"
              )::TEXT
            WHERE 
              [it51b11k]="{}" AND [it51d310]>="{} 00:00:00" AND [it51d310]<="{} 23:59:59" 
          `.f(
            global.c?.state.s_it10b11k,
            bf.myDT_add_date(global.c?.state.s_it10d110, -1), // 入れ替えを考慮し前後2日を更新
            bf.myDT_add_date(global.c?.state.s_it10d110, 1), // 入れ替えを考慮し前後2日を更新
          )),
          // 月別時間帯別 総入店客数の更新
          bf.q(`
            UPDATE 
              [t_it61] 
            SET 
              [it61i110]=(
                SELECT 
                  SUM(REPLACE(REPLACE(IFNULL([C].[it51i110],"0"),"None","0"),"","0")::NUMERIC::INTEGER) 
                FROM 
                  [t_it51] AS [C]
                WHERE 
                  [C].[it51d210]=[it61d210] AND 
                  [C].[it51b21k] IN (
                    SELECT [A].[_KEY]::TEXT FROM [t_it50] AS [A] WHERE [A].[it50b21k]=[it61b21k]
                  )
              ) 
            WHERE 
              [it61b21k]=(
                SELECT [B].[it50b21k] FROM [t_it50] AS [B] WHERE [B].[_KEY]={}
              )
          `.f(
            global.c?.state.s_it10b31k,
          )),
          // 月別時間帯別 平日入店客数の更新
          bf.q(`
            UPDATE 
              [t_it61] 
            SET 
              [it61i120]=(
                SELECT 
                  SUM(REPLACE(REPLACE(IFNULL([C].[it51i110],"0"),"None","0"),"","0")::NUMERIC::INTEGER) 
                FROM 
                  [t_it51] AS [C]
                WHERE 
                  [C].[it51d210]=[t_it61].[it61d210] AND 
                  [C].[it51b21k] IN (
                    SELECT [A].[_KEY]::TEXT FROM [t_it50] AS [A] WHERE [A].[it50b21k]=[t_it61].[it61b21k] AND IFNULL([A].[it50t110],"0")="10"
                  )
              ) 
            WHERE 
              [t_it61].[it61b21k]=(
                SELECT [B].[it50b21k] FROM [t_it50] AS [B] WHERE [B].[_KEY]={}
              )
          `.f(
            global.c?.state.s_it10b31k,
          )),
          // 月別時間帯別 休日前入店客数の更新
          bf.q(`
            UPDATE 
              [t_it61] 
            SET 
              [it61i130]=(
                SELECT 
                  SUM(REPLACE(REPLACE(IFNULL([C].[it51i110],"0"),"None","0"),"","0")::NUMERIC::INTEGER) 
                FROM 
                  [t_it51] AS [C]
                WHERE 
                  [C].[it51d210]=[t_it61].[it61d210] AND 
                  [C].[it51b21k] IN (
                    SELECT [A].[_KEY]::TEXT FROM [t_it50] AS [A] WHERE [A].[it50b21k]=[t_it61].[it61b21k] AND IFNULL([A].[it50t110],"0")="20"
                  )
              ) 
            WHERE 
              [t_it61].[it61b21k]=(
                SELECT [B].[it50b21k] FROM [t_it50] AS [B] WHERE [B].[_KEY]={}
              )
          `.f(
            global.c?.state.s_it10b31k,
          )),
          // 月別時間帯別 休日入店客数の更新
          bf.q(`
            UPDATE 
              [t_it61] 
            SET 
              [it61i140]=(
                SELECT 
                  SUM(REPLACE(REPLACE(IFNULL([C].[it51i110],"0"),"None","0"),"","0")::NUMERIC::INTEGER) 
                FROM 
                  [t_it51] AS [C]
                WHERE 
                  [C].[it51d210]=[t_it61].[it61d210] AND 
                  [C].[it51b21k] IN (
                    SELECT [A].[_KEY]::TEXT FROM [t_it50] AS [A] WHERE [A].[it50b21k]=[t_it61].[it61b21k] AND IFNULL([A].[it50t110],"0")="30"
                  )
              ) 
            WHERE 
              [t_it61].[it61b21k]=(
                SELECT [B].[it50b21k] FROM [t_it50] AS [B] WHERE [B].[_KEY]={}
              )
          `.f(
            global.c?.state.s_it10b31k,
          )),
          // 月別時間帯別 総経過日数の更新
          bf.q(`
            UPDATE 
              [t_it61] 
            SET 
              [it61i210]=(
                SELECT 
                  REPLACE(IFNULL([A].[it60i310],"0"), "None", "0") 
                FROM 
                  [t_it60] AS [A] 
                WHERE 
                  [A].[_KEY]=[t_it61].[it61b21k]::NUMERIC::INTEGER
              )::TEXT
            WHERE 
              [t_it61].[it61b21k]=(
                SELECT [B].[it50b21k] FROM [t_it50] AS [B] WHERE [B].[_KEY]={}
              )
          `.f(
            global.c?.state.s_it10b31k,
          )),
          // 月別時間帯別 平日経過日数の更新
          bf.q(`
            UPDATE 
              [t_it61] 
            SET 
              [it61i220]=(
                SELECT 
                  REPLACE(IFNULL([A].[it60i320],"0"), "None", "0") 
                FROM 
                  [t_it60] AS [A] 
                WHERE 
                  [A].[_KEY]=[t_it61].[it61b21k]::NUMERIC::INTEGER
              )::TEXT
            WHERE 
              [t_it61].[it61b21k]=(
                SELECT [B].[it50b21k] FROM [t_it50] AS [B] WHERE [B].[_KEY]={}
              )
          `.f(
            global.c?.state.s_it10b31k,
          )),
          // 月別時間帯別 休日前経過日数の更新
          bf.q(`
            UPDATE 
              [t_it61] 
            SET 
              [it61i230]=(
                SELECT 
                  REPLACE(IFNULL([A].[it60i330],"0"), "None", "0") 
                FROM 
                  [t_it60] AS [A] 
                WHERE 
                  [A].[_KEY]=[t_it61].[it61b21k]::NUMERIC::INTEGER
              )::TEXT
            WHERE 
              [t_it61].[it61b21k]=(
                SELECT [B].[it50b21k] FROM [t_it50] AS [B] WHERE [B].[_KEY]={}
              )
          `.f(
            global.c?.state.s_it10b31k,
          )),
          // 月別時間帯別 休日経過日数の更新
          bf.q(`
            UPDATE 
              [t_it61] 
            SET 
              [it61i240]=(
                SELECT 
                  REPLACE(IFNULL([A].[it60i340],"0"), "None", "0") 
                FROM 
                  [t_it60] AS [A] 
                WHERE 
                  [A].[_KEY]=[t_it61].[it61b21k]::NUMERIC::INTEGER
              )::TEXT
            WHERE 
              [t_it61].[it61b21k]=(
                SELECT [B].[it50b21k] FROM [t_it50] AS [B] WHERE [B].[_KEY]={}
              )
          `.f(
            global.c?.state.s_it10b31k,
          )),
          // 月別時間帯別 平均総入店客数の更新
          bf.q(`
            UPDATE 
              [t_it61] 
            SET 
              [it61i310]=(
                SELECT CASE
                  WHEN
                    REPLACE(IFNULL([it61i210],"0"),"None","0")::NUMERIC::INTEGER = 0
                  THEN
                    0.00
                  ELSE
                    ROUND(REPLACE(IFNULL([it61i110],"0"),"None","0")::NUMERIC::REAL * 100.0 / REPLACE(IFNULL([it61i210],"0"),"None","0")::NUMERIC::REAL) / 100.0
                  END
              )::TEXT
            WHERE 
              [t_it61].[it61b21k]=(
                SELECT [B].[it50b21k] FROM [t_it50] AS [B] WHERE [B].[_KEY]={}
              )
          `.f(
            global.c?.state.s_it10b31k,
          )),
          // 月別時間帯別 平均平日入店客数の更新
          bf.q(`
            UPDATE 
              [t_it61] 
            SET 
              [it61i320]=(
                SELECT CASE
                  WHEN
                    REPLACE(IFNULL([it61i220],"0"),"None","0")::NUMERIC::INTEGER = 0
                  THEN
                    0.00
                  ELSE
                    ROUND(REPLACE(IFNULL([it61i120],"0"),"None","0")::NUMERIC::REAL * 100.0 / REPLACE(IFNULL([it61i220],"0"),"None","0")::NUMERIC::REAL) / 100.0
                  END
              )::TEXT
            WHERE 
              [t_it61].[it61b21k]=(
                SELECT [B].[it50b21k] FROM [t_it50] AS [B] WHERE [B].[_KEY]={}
              )
          `.f(
            global.c?.state.s_it10b31k,
          )),
          // 月別時間帯別 平均休日前入店客数の更新
          bf.q(`
            UPDATE 
              [t_it61] 
            SET 
              [it61i330]=(
                SELECT CASE
                  WHEN
                    REPLACE(IFNULL([it61i230],"0"),"None","0")::NUMERIC::INTEGER = 0
                  THEN
                    0.00
                  ELSE
                    ROUND(REPLACE(IFNULL([it61i130],"0"),"None","0")::NUMERIC::REAL * 100.0 / REPLACE(IFNULL([it61i230],"0"),"None","0")::NUMERIC::REAL) / 100.0
                  END
              )::TEXT
            WHERE 
              [t_it61].[it61b21k]=(
                SELECT [B].[it50b21k] FROM [t_it50] AS [B] WHERE [B].[_KEY]={}
              )
          `.f(
            global.c?.state.s_it10b31k,
          )),
          // 月別時間帯別 平均休日入店客数の更新
          bf.q(`
            UPDATE 
              [t_it61] 
            SET 
              [it61i340]=(
                SELECT CASE
                  WHEN
                    REPLACE(IFNULL([it61i240],"0"),"None","0")::NUMERIC::INTEGER = 0
                  THEN
                    0.00
                  ELSE
                    ROUND(REPLACE(IFNULL([it61i140],"0"),"None","0")::NUMERIC::REAL * 100.0 / REPLACE(IFNULL([it61i240],"0"),"None","0")::NUMERIC::REAL) / 100.0
                  END
              )::TEXT
            WHERE 
              [t_it61].[it61b21k]=(
                SELECT [B].[it50b21k] FROM [t_it50] AS [B] WHERE [B].[_KEY]={}
              )
          `.f(
            global.c?.state.s_it10b31k,
          )),
        ]}), // その他
      ])
      .then(()=>{
        _o_end1();
      });
    });
  });
*/

  /**********************************************************************************************************************

  計算の流れ

  　・パターン：（顧客別、日別、月別）x （合計、平均、予測） x （合計金額、合計金額、単価） x （全体、平日、休日前、休日）
  　・パラメータ： 売上、（原価）、利益、客数、客単価、組数、組単価、延長客数、（延長客単価）、延長率、外販客数、新規客数、反響率

    顧客別
      売上
    　客数
      　客単価
    　外販客数
    　延長客数
    　新規客数
    日別
      売上
      利益
    　客数
      　客単価
    　外販客数
    　延長客数
    　　（総客数->）延長率
    　新規客数
    　　（総客数->）反響率
    　時間帯別客数
    　組数
      　（売上->）組単価
    月別
      経過日数
      売上の合計・平均・予測
      利益の合計・平均・予測
      客数の合計・平均・予測
        客単価の平均・分散
      外販客数の合計・平均・予測
    　延長客数の合計・平均・予測
        延長率の平均・分散
    　新規客数の合計・平均・予測
    　　反響率の平均・分散
    　時間帯別客数の合計・平均・予測
    　組数の合計・平均・予測
        組単価の平均・分散
  　　
  *********************************************************************************************************************** */
  static $ip_upd_it10 = (pd={
    it10_key: '',
  }) => new Promise( _o_end1 => {
    let _d_vals = {
      it10b21k: global.c?.state.s_it10b21k || '',
      it10d110: global.c?.state.s_it10d110 || '',
      it10d120: global.c?.state.s_it10d120 || '',
      it10d130: global.c?.state.s_it10d130 || '',
      it10d140: global.c?.state.s_it10d140 || '',
      it10t110: global.c?.state.s_it10t110 || '-1',
      it10s110: global.c?.state.s_it10s110 || '-1',
      it10s210: global.c?.state.s_it10s210 || '-1',
      it10c310: global.c?.state.s_it10c310 || '',
      it10i110: global.c?.state.s_it10i110 || '',
      it10i210: bf.n(global.c?.state.s_it10i210) || 0,
      it10i220: global.c?.state.s_it10i220 || '0',
      it10i2a0: global.c?.state.s_it10i2a0 || '0',
      it10i2b0: global.c?.state.s_it10i2b0 || '0',
      it10i310: bf.n(global.c?.state.s_it10i310) || 0,
      it10i320: bf.n(global.c?.state.s_it10i320) || 0,
      it10i330: bf.n(global.c?.state.s_it10i330) || 0,
      it10i360: bf.n(global.c?.state.s_it10i360) || 0,
      it10i410: global.c?.state.s_it10i410 || 'その他',
      it10i510: global.c?.state.s_it10i510 || '0',
      it10i520: global.c?.state.s_it10i520 || '0',
      it10i530: global.c?.state.s_it10i530 || '0',
      it10i720: bf.n(global.c?.state.s_it10i720) || '0',
      it10i730: bf.n(global.c?.state.s_it10i730) || '0',
      it10ia20: bf.n(global.c?.state.s_it10ia20) || '0',
      it10ia50: bf.n(global.c?.state.s_it10ia50) || '0',
      it10ia60: bf.n(global.c?.state.s_it10ia60) || '0',
      it10cy30: bf.myDT_get_now() || '',
      it10cy40: global.c?.state.sgcd_pageCmns?.cm10_key || '',
    };
    let _cnd = bf.q('[_KEY]={}'.f(
      pd.it10_key,
    ));
    cf.myCB_call_iud({
      ctr: 'upd', 
      elm: 'it10', 
      d_vals: _d_vals, 
      cnd: _cnd
    })
    .then( () => { // 同一情報は同一画面上で処理することが望ましい
      cf.myRN_pll([
        // 顧客情報の更新、延長客数は注文登録時に更新
//        ip.$ip_upd_it10d120(), // it10d120: 終了日時
//        ip.$ip_updIt10i340(), // it10i340: 外販客数
//        ip.$ip_updIt50i920(), // 新規客数・反響率
//        ip.$ip_updIt10i350(), // it10i350: 延長客数
//        ip.$ip_updIt10ia70(), // it10i640: 総コース料金
        cf.myCB_call_iud({
          ctr: 'qrys', 
          elm: '--', 
          l_qrys: [
/*
          // it10i340 顧客情報 外販客数 it10i330
          bf.q(`
            UPDATE 
              [t_it10] 
            SET 
              [it10i340]=(
                SELECT 
                  CASE 
                    WHEN 
                      (SELECT COUNT(*) FROM [t_it11] WHERE [it11b11k]=[t_it10].[_KEY]::TEXT AND IFNULL([it11cz10],"10")<>"0") > 0 
                    THEN 
                      [it10i330]
                    ELSE
                      "0" 
                    END
              )
            WHERE
              [_KEY]={}
          `.f(
            global.c?.state.sgcd_pageCmns?.it10_key,
          )),
*/
/*
          // it10i530 顧客情報 延長客数 it10i330
          bf.q(`
            UPDATE 
              [t_it10] 
            SET 
              [it10i350]=(
                SELECT CASE
                  WHEN 
                    [it10i520]::NUMERIC::INTEGER > 0
                  THEN
                    [it10i330]
                  ELSE
                    "0"
                  END
              )
            WHERE 
              [_KEY]={}
          `.f(
            pd.it10_key,
          )),
          // 日別情報 カード売上
          bf.q(`
            UPDATE 
              [t_it50] 
            SET 
              [it50i220]=(
                SELECT 
                  SUM(IFNULL([it10i730],"0")::NUMERIC::INTEGER)::TEXT
                FROM 
                  [t_it10] 
                WHERE 
                  [it10b31k]=[t_it50].[_KEY]::TEXT
              )
            WHERE 
              [t_it50].[_KEY]={}
          `.f(
            global.c?.state.s_it10b31k,
          )),
          // 日別情報 当日レジ金
          bf.q(`
            UPDATE 
              [t_it50] 
            SET 
              [it50i520]=(
                REPLACE(IFNULL([it50i510],"0"),"None","0")::NUMERIC::INTEGER
                + REPLACE(IFNULL([it50i210],"0"),"None","0")::NUMERIC::INTEGER
                - REPLACE(IFNULL([it50i220],"0"),"None","0")::NUMERIC::INTEGER
                - REPLACE(IFNULL([it50i310],"0"),"None","0")::NUMERIC::INTEGER
                - REPLACE(IFNULL([it50i320],"0"),"None","0")::NUMERIC::INTEGER
                - REPLACE(IFNULL([it50i410],"0"),"None","0")::NUMERIC::INTEGER
              )::TEXT
            WHERE 
              [t_it50].[_KEY]={}
          `.f(
            global.c?.state.s_it10b31k,
          )),
          // 日別情報 現在組数
          bf.q(`
            UPDATE 
              [t_it50] 
            SET 
              [it50i850]=(
                SELECT 
                  COUNT(*)::TEXT
                FROM 
                  [t_it10] 
                WHERE 
                  [it10b31k]=[t_it50].[_KEY]::TEXT AND [it10s110]="10"
              )
            WHERE 
              [t_it50].[_KEY]={}
          `.f(
            global.c?.state.s_it10b31k,
          )),
          // 日別情報 現在客数
          bf.q(`
            UPDATE 
              [t_it50] 
            SET 
              [it50i860]=(
                SELECT 
                  SUM(IFNULL([it10i330], "0")::NUMERIC::INTEGER)::TEXT 
                FROM 
                  [t_it10] 
                WHERE 
                  [it10b31k]=[t_it50].[_KEY]::TEXT AND [it10s110]="10"
              )
            WHERE 
              [t_it50].[_KEY]={}
          `.f(
            global.c?.state.s_it10b31k,
          )),
*/
          // 日別情報 登録日時
          bf.q(`
            UPDATE 
              [t_it50] 
            SET 
              [it50cy10]="{}"
            WHERE 
              [t_it50].[_KEY]={}
          `.f(
            bf.myDT_get_now(), // クライアントの現在時刻の影響を受けることに注意
            global.c?.state.s_it10b31k,
          )),
        ]}), // その他
      ])
      .then(()=>{
        _o_end1();
      });
    });
  });

/*
  static $ip_upd_it10d120 = () => new Promise( _o_end1 => { // コース終了時刻
    cf.myCB_call_iud({
      ctr: 'qrys', 
      elm: '---', 
      l_qrys: [
        // 延長時間
        bf.q(`
          UPDATE [t_it10] SET 
            [it10i520]=(
              SELECT
                SUM(
                  CASE
                    WHEN
                      [it30i220]::NUMERIC::INTEGER>0
                    THEN
                      IFNULL([it30i410],"0")::NUMERIC::INTEGER
                    WHEN
                      [it30i220]::NUMERIC::INTEGER<0
                    THEN
                      IFNULL([it30i410],"0")::NUMERIC::INTEGER * -1
                    ELSE
                      0
                    END                      
                )
              FROM
                [t_it30]
              WHERE
                [it30b11k]=[t_it10].[_KEY]::TEXT
            )
          WHERE
            [_KEY]={}
        `.f(
          global.c?.state.sgcd_pageCmns?.it10_key,
        )),
        // 総時間
        bf.q(`
          UPDATE [t_it10] SET 
            [it10i530]=(IFNULL([it10i510],"0")::NUMERIC::INTEGER+IFNULL([it10i520],"0")::NUMERIC::INTEGER)
          WHERE
            [_KEY]={}
        `.f(
          global.c?.state.sgcd_pageCmns?.it10_key,
        )),
        // 終了時刻
        bf.q(`
          UPDATE [t_it10] SET 
            [it10d120]=TO_CHAR((
              SELECT TO_TIMESTAMP([it10d110], "YYYY-MM-DD HH24:MI:00") + ([it10i530] || " minutes")::INTERVAL 
            ), "YYYY-MM-DD HH24:MI:SS")
          WHERE
            [_KEY]={}
        `.f(
          global.c?.state.sgcd_pageCmns?.it10_key,
        )),
      ],
    })
    .then(() => {
      _o_end1();
    })
  });
*/

  static dd_qryss = {


    it50i850: { // 日別 現在組数
      pfx: '日別 現在組数',
      l_trgs: ['it10i330'], // 客数は関係ないが、便宜的に it10i330 をトリガとする
      lo_qrys: [
        _d_vals => bf.q(`
            UPDATE 
              [t_it50] 
            SET 
              [it50i850]=(
                SELECT 
                  COUNT(*)::TEXT
                FROM 
                  [t_it10] 
                WHERE 
                  [it10b31k]=[t_it50].[_KEY]::TEXT AND [it10s110]="10"
              )
            WHERE 
              [t_it50].[_KEY]={}
          `.f(
            _d_vals.it50_key,
          )),
      ],
    },

    it50i860: { // 日別 現在客数
      pfx: '日別 現在客数',
      l_trgs: ['it10i330'],
      lo_qrys: [
        _d_vals => bf.q(`
            UPDATE 
              [t_it50] 
            SET 
              [it50i860]=(
                SELECT 
                  SUM(IFNULL([it10i330], "0")::NUMERIC::INTEGER)::TEXT 
                FROM 
                  [t_it10] 
                WHERE 
                  [it10b31k]=[t_it50].[_KEY]::TEXT AND [it10s110]="10"
              )
            WHERE 
              [t_it50].[_KEY]={}
          `.f(
            _d_vals.it50_key,
          )),
      ],
    },

    it10d120: { 
      pfx: '顧客情報 終了時刻',
      l_trgs: [],
      lo_qrys: [
        // 顧客情報 延長時間
        _d_vals => bf.q(`
          UPDATE [t_it10] SET 
            [it10i520]=(
              SELECT
                SUM(
                  CASE
                    WHEN
                      [it30i220]::NUMERIC::INTEGER>0
                    THEN
                      IFNULL([it30i410],"0")::NUMERIC::INTEGER
                    WHEN
                      [it30i220]::NUMERIC::INTEGER<0
                    THEN
                      IFNULL([it30i410],"0")::NUMERIC::INTEGER * -1
                    ELSE
                      0
                    END                      
                )
              FROM
                [t_it30]
              WHERE
                [it30b11k]=[t_it10].[_KEY]::TEXT
            )
          WHERE
            [_KEY]={}
        `.f(
          _d_vals.it10_key,
        )),
        // 顧客情報 総時間
        _d_vals => bf.q(`
          UPDATE [t_it10] SET 
            [it10i530]=(IFNULL([it10i510],"0")::NUMERIC::INTEGER+IFNULL([it10i520],"0")::NUMERIC::INTEGER)
          WHERE
            [_KEY]={}
        `.f(
          _d_vals.it10_key,
        )),
        // 顧客情報 終了時刻
        _d_vals => bf.q(`
          UPDATE [t_it10] SET 
            [it10d120]=TO_CHAR((
              SELECT TO_TIMESTAMP([it10d110], "YYYY-MM-DD HH24:MI:00") + ([it10i530] || " minutes")::INTERVAL 
            ), "YYYY-MM-DD HH24:MI:SS")
          WHERE
            [_KEY]={}
        `.f(
          _d_vals.it10_key,
        )),
      ],
    },

    it10i350: { // 顧客情報 延長客数 it10i330
      pfx: '顧客情報 延長客数',
      l_trgs: ['it10i330'],
      lo_qrys: [
        _d_vals => bf.q(`
          UPDATE 
            [t_it10] 
          SET 
            [it10i350]=(
              SELECT CASE
                WHEN 
                  [it10i520]::NUMERIC::INTEGER > 0
                THEN
                  [it10i330]
                ELSE
                  "0"
                END
            )
          WHERE 
            [_KEY]={}
        `.f(
          _d_vals.it10_key,
        )),
      ],
    },

    it10i340: { // it10i340 顧客情報 外販客数 it10i330
      pfx: '顧客情報 外販客数',
      l_trgs: ['it10i330'],
      lo_qrys: [
        _d_vals => bf.q(`
          UPDATE 
            [t_it10] 
          SET 
            [it10i340]=(
              SELECT 
                CASE 
                  WHEN 
                    (SELECT COUNT(*) FROM [t_it11] WHERE [it11b11k]=[t_it10].[_KEY]::TEXT AND IFNULL([it11cz10],"10")<>"0") > 0 
                  THEN 
                    [it10i330]
                  ELSE
                    "0" 
                  END
            )
          WHERE
            [_KEY]={}
        `.f(
          _d_vals.it10_key,
        )),
      ],
    },

    it50i220: { // 日別情報 カード売上
      pfx: '日別 カード売上',
      l_trgs: ['it10i730'],
      lo_qrys: [
        _d_vals => bf.q(`
            UPDATE 
              [t_it50] 
            SET 
              [it50i220]=(
                SELECT 
                  SUM(IFNULL([it10i730],"0")::NUMERIC::INTEGER)::TEXT
                FROM 
                  [t_it10] 
                WHERE 
                  [it10b31k]=[t_it50].[_KEY]::TEXT
              )
            WHERE 
              [t_it50].[_KEY]={}
          `.f(
            global.c?.state.s_it10b31k,
          )),
      ],
    },

    // 日別情報 当日レジ金
    it50i520: {
      pfx: '日別 当日レジ金',
      l_trgs: ['it50i510', 'it50i210', 'it50i220', 'it50i310', 'it50i320', 'it50i410'],
      lo_qrys: [
        _d_vals => bf.q(`
          UPDATE 
            [t_it50] 
          SET 
            [it50i520]=(
              REPLACE(IFNULL([it50i510],"0"),"None","0")::NUMERIC::INTEGER
              + REPLACE(IFNULL([it50i210],"0"),"None","0")::NUMERIC::INTEGER
              - REPLACE(IFNULL([it50i220],"0"),"None","0")::NUMERIC::INTEGER
              - REPLACE(IFNULL([it50i310],"0"),"None","0")::NUMERIC::INTEGER
              - REPLACE(IFNULL([it50i320],"0"),"None","0")::NUMERIC::INTEGER
              - REPLACE(IFNULL([it50i410],"0"),"None","0")::NUMERIC::INTEGER
            )::TEXT
          WHERE 
            [t_it50].[_KEY]={}
        `.f(
          _d_vals.it50_key,
        )),
      ],
    },

    it50i870: { // 日別情報 総組数 ※出戻りは対象外
      pfx: '日別 組数',
      l_trgs: ['it10i330'], // 客数は関係ないが、便宜的に it10i330 をトリガとする
      lo_qrys: [
        _d_vals => bf.q(`
          UPDATE 
            [t_it50] 
          SET 
            [it50i870]=(
              SELECT 
                COUNT(*)::TEXT
              FROM 
                [t_it10] 
              WHERE 
                [it10b31k]=[t_it50].[_KEY]::TEXT AND [it10s110] IN ("10","20") AND [it10t110] IN ("10")
            )
          WHERE 
            [t_it50].[_KEY]={}
        `.f(
          _d_vals.it50_key,
        )),
      ],
    },
    // 日別情報 組単価
    it50i880: {
      pfx: '日別 組単価',
      l_trgs: ['it50i210', 'it50i870'],
      lo_qrys: [
        _d_vals => bf.q(`
          UPDATE 
            [t_it50] 
          SET 
            [it50i880]=(
              SELECT CASE
                WHEN
                  REPLACE(IFNULL([it50i870],"0"),"None","0")::NUMERIC::INTEGER = 0
                THEN
                  0
                ELSE
                  REPLACE(IFNULL([it50i210],"0"),"None","0")::NUMERIC::INTEGER / REPLACE(IFNULL([it50i870],"0"),"None","0")::NUMERIC::INTEGER
                END
            )::TEXT
          WHERE 
            [t_it50].[_KEY]={}
        `.f(
          _d_vals.it50_key,
        )),
      ],
    },
    // 月別情報 総組数
    it60i870: {
      pfx: '月別 組数',
      l_trgs: ['it50i870'],
      lo_qrys: [
        _d_vals => bf.q(`
          UPDATE [t_it60] SET 
            [it60i870]=(
              SELECT 
                SUM(IFNULL([it50i870],"0")::NUMERIC::INTEGER)::TEXT 
              FROM 
                [t_it50]
              WHERE 
                [it50b21k]=[t_it60].[_KEY]::TEXT
            )
          WHERE 
            [t_it60].[_KEY]={}
        `.f(
          _d_vals.it60_key,
        )),
      ],
    },
    // 月別情報 組単価
    it60i8b0: {
      pfx: '月別 組単価',
      l_trgs: ['it60i210', 'it60i870'],
      lo_qrys: [
        _d_vals => bf.q(`
          UPDATE 
            [t_it60] 
          SET 
            [it60i8b0]=(
              SELECT CASE
                WHEN
                  REPLACE(IFNULL([it60i870],"0"),"None","0")::NUMERIC::INTEGER = 0
                THEN
                  0
                ELSE
                  REPLACE(IFNULL([it60i210],"0"),"None","0")::NUMERIC::INTEGER / REPLACE(IFNULL([it60i870],"0"),"None","0")::NUMERIC::INTEGER
                END
            )::TEXT
          WHERE 
            [t_it60].[_KEY]={}
        `.f(
          _d_vals.it60_key,
        )),
      ],
    },
    // 日別の時間帯別客数 ※出戻りを除く
    it51i110: {
      pfx: '日別 時間帯別合計客数',
      l_trgs: ['it10i330'],
      lo_qrys: [
        _d_vals => bf.q(`
          UPDATE 
            [t_it51] 
          SET 
            [it51i110]=(
              SELECT 
                IFNULL(SUM(REPLACE(IFNULL([it10i330],"0"),"None","0")::NUMERIC::INTEGER),0)
              FROM 
                [t_it10]
              WHERE 
                [it10b11k]=[it51b11k] AND SUBSTRING([it10d110],1,13)=SUBSTRING([it51d310],1,13) AND [it10t110]="10"
            )::TEXT
          WHERE 
            [it51b11k]="{}" AND [it51d310]>="{} 00:00:00" AND [it51d310]<="{} 23:59:59" 
        `.f(
          global.c?.state.s_it10b11k,
          bf.myDT_add_date(global.c?.state.s_it10d110, -1), // 入れ替えを考慮し前後2日を更新
          bf.myDT_add_date(global.c?.state.s_it10d110, 1), // 入れ替えを考慮し前後2日を更新
        )),
      ],
    },
    // 月別の時間帯別客数
    it61i110: {
      pfx: '月別 時間帯別合計客数',
      l_trgs: ['it51i110'],
      lo_qrys: [
        // 総客数
        _d_vals => bf.q(`
          UPDATE 
            [t_it61] 
          SET 
            [it61i110]=(
              SELECT 
                SUM(REPLACE(REPLACE(IFNULL([C].[it51i110],"0"),"None","0"),"","0")::NUMERIC::INTEGER) 
              FROM 
                [t_it51] AS [C]
              WHERE 
                [C].[it51d210]=[it61d210] AND 
                [C].[it51b21k] IN (
                  SELECT [A].[_KEY]::TEXT FROM [t_it50] AS [A] WHERE [A].[it50b21k]=[it61b21k]
                )
            ) 
          WHERE 
            [it61b21k]="{}"
        `.f(
          _d_vals.it60_key,
        )),
        // 平日客数
        _d_vals => bf.q(`
          UPDATE 
            [t_it61] 
          SET 
            [it61i120]=(
              SELECT 
                SUM(REPLACE(REPLACE(IFNULL([C].[it51i110],"0"),"None","0"),"","0")::NUMERIC::INTEGER) 
              FROM 
                [t_it51] AS [C]
              WHERE 
                [C].[it51d210]=[t_it61].[it61d210] AND 
                [C].[it51b21k] IN (
                  SELECT [A].[_KEY]::TEXT FROM [t_it50] AS [A] WHERE [A].[it50b21k]=[t_it61].[it61b21k] AND IFNULL([A].[it50t110],"0")="10"
                )
            ) 
          WHERE 
            [it61b21k]="{}"
        `.f(
          _d_vals.it60_key,
        )),
        // 休日前客数
        _d_vals => bf.q(`
          UPDATE 
            [t_it61] 
          SET 
            [it61i130]=(
              SELECT 
                SUM(REPLACE(REPLACE(IFNULL([C].[it51i110],"0"),"None","0"),"","0")::NUMERIC::INTEGER) 
              FROM 
                [t_it51] AS [C]
              WHERE 
                [C].[it51d210]=[t_it61].[it61d210] AND 
                [C].[it51b21k] IN (
                  SELECT [A].[_KEY]::TEXT FROM [t_it50] AS [A] WHERE [A].[it50b21k]=[t_it61].[it61b21k] AND IFNULL([A].[it50t110],"0")="20"
                )
            ) 
          WHERE 
            [it61b21k]={}
        `.f(
          _d_vals.it60_key,
        )),
        // 休日客数
        _d_vals => bf.q(`
          UPDATE 
            [t_it61] 
          SET 
            [it61i140]=(
              SELECT 
                SUM(REPLACE(REPLACE(IFNULL([C].[it51i110],"0"),"None","0"),"","0")::NUMERIC::INTEGER) 
              FROM 
                [t_it51] AS [C]
              WHERE 
                [C].[it51d210]=[t_it61].[it61d210] AND 
                [C].[it51b21k] IN (
                  SELECT [A].[_KEY]::TEXT FROM [t_it50] AS [A] WHERE [A].[it50b21k]=[t_it61].[it61b21k] AND IFNULL([A].[it50t110],"0")="30"
                )
            ) 
          WHERE 
            [it61b21k]="{}"
        `.f(
          _d_vals.it60_key,
        )),
      ],
    },
    // 月別の時間帯別経過日数
    it61i210: {
      pfx: '月別 時間帯別経過日数',
      l_trgs: ['it60i310'],
      lo_qrys: [
        // 月別時間帯別 総経過日数の更新
        _d_vals => bf.q(`
          UPDATE 
            [t_it61] 
          SET 
            [it61i210]=(
              SELECT 
                REPLACE(IFNULL([A].[it60i310],"0"), "None", "0") 
              FROM 
                [t_it60] AS [A] 
              WHERE 
                [A].[_KEY]=[t_it61].[it61b21k]::NUMERIC::INTEGER
            )::TEXT
          WHERE 
            [it61b21k]="{}"
        `.f(
          _d_vals.it60_key,
        )),
        // 月別時間帯別 平日経過日数の更新
        _d_vals => bf.q(`
          UPDATE 
            [t_it61] 
          SET 
            [it61i220]=(
              SELECT 
                REPLACE(IFNULL([A].[it60i320],"0"), "None", "0") 
              FROM 
                [t_it60] AS [A] 
              WHERE 
                [A].[_KEY]=[t_it61].[it61b21k]::NUMERIC::INTEGER
            )::TEXT
          WHERE 
            [it61b21k]="{}"
        `.f(
          _d_vals.it60_key,
        )),
        // 月別時間帯別 休日前経過日数の更新
        _d_vals => bf.q(`
          UPDATE 
            [t_it61] 
          SET 
            [it61i230]=(
              SELECT 
                REPLACE(IFNULL([A].[it60i330],"0"), "None", "0") 
              FROM 
                [t_it60] AS [A] 
              WHERE 
                [A].[_KEY]=[t_it61].[it61b21k]::NUMERIC::INTEGER
            )::TEXT
          WHERE 
            [it61b21k]="{}"
        `.f(
          _d_vals.it60_key,
        )),
        // 月別時間帯別 休日経過日数の更新
        _d_vals => bf.q(`
          UPDATE 
            [t_it61] 
          SET 
            [it61i240]=(
              SELECT 
                REPLACE(IFNULL([A].[it60i340],"0"), "None", "0") 
              FROM 
                [t_it60] AS [A] 
              WHERE 
                [A].[_KEY]=[t_it61].[it61b21k]::NUMERIC::INTEGER
            )::TEXT
          WHERE 
            [it61b21k]="{}"
        `.f(
          _d_vals.it60_key,
        )),
      ],
    },
    // 月別の時間帯別平均客数
    it61i310: {
      pfx: '月別 時間帯別平均客数',
      l_trgs: ['it61i110', 'it61i210'],
      lo_qrys: [
        // 月別時間帯別 平均総入店客数の更新
        _d_vals => bf.q(`
          UPDATE 
            [t_it61] 
          SET 
            [it61i310]=(
              SELECT CASE
                WHEN
                  REPLACE(IFNULL([it61i210],"0"),"None","0")::NUMERIC::INTEGER = 0
                THEN
                  0.00
                ELSE
                  ROUND(REPLACE(IFNULL([it61i110],"0"),"None","0")::NUMERIC::REAL * 100.0 / REPLACE(IFNULL([it61i210],"0"),"None","0")::NUMERIC::REAL) / 100.0
                END
            )::TEXT
          WHERE 
            [it61b21k]="{}"
        `.f(
          _d_vals.it60_key,
        )),
        // 月別時間帯別 平均平日入店客数の更新
        _d_vals => bf.q(`
          UPDATE 
            [t_it61] 
          SET 
            [it61i320]=(
              SELECT CASE
                WHEN
                  REPLACE(IFNULL([it61i220],"0"),"None","0")::NUMERIC::INTEGER = 0
                THEN
                  0.00
                ELSE
                  ROUND(REPLACE(IFNULL([it61i120],"0"),"None","0")::NUMERIC::REAL * 100.0 / REPLACE(IFNULL([it61i220],"0"),"None","0")::NUMERIC::REAL) / 100.0
                END
            )::TEXT
          WHERE 
            [it61b21k]="{}"
        `.f(
          _d_vals.it60_key,
        )),
        // 月別時間帯別 平均休日前入店客数の更新
        _d_vals => bf.q(`
          UPDATE 
            [t_it61] 
          SET 
            [it61i330]=(
              SELECT CASE
                WHEN
                  REPLACE(IFNULL([it61i230],"0"),"None","0")::NUMERIC::INTEGER = 0
                THEN
                  0.00
                ELSE
                  ROUND(REPLACE(IFNULL([it61i130],"0"),"None","0")::NUMERIC::REAL * 100.0 / REPLACE(IFNULL([it61i230],"0"),"None","0")::NUMERIC::REAL) / 100.0
                END
            )::TEXT
          WHERE 
            [it61b21k]="{}"
        `.f(
          _d_vals.it60_key,
        )),
        // 月別時間帯別 平均休日入店客数の更新
        _d_vals => bf.q(`
          UPDATE 
            [t_it61] 
          SET 
            [it61i340]=(
              SELECT CASE
                WHEN
                  REPLACE(IFNULL([it61i240],"0"),"None","0")::NUMERIC::INTEGER = 0
                THEN
                  0.00
                ELSE
                  ROUND(REPLACE(IFNULL([it61i140],"0"),"None","0")::NUMERIC::REAL * 100.0 / REPLACE(IFNULL([it61i240],"0"),"None","0")::NUMERIC::REAL) / 100.0
                END
            )::TEXT
          WHERE 
            [it61b21k]="{}"
        `.f(
          _d_vals.it60_key,
        )),
      ],
    },

    // 日別の外販客数
    it50i910: {
      pfx: '日別 外販客数',
      l_trgs: ['it10i340'],
      lo_qrys: [
        // it50i910 日別情報 外販客数 ※出戻りを除く it10i340
        _d_vals => bf.q(`
          UPDATE 
            [t_it50] 
          SET 
            [it50i910]=(
              SELECT 
                SUM(IFNULL([it10i340], "0")::NUMERIC::INTEGER)::TEXT 
              FROM 
                [t_it10] 
              WHERE 
                [it10b31k]=[t_it50].[_KEY]::TEXT AND [it10t110]="10"
            )
          WHERE 
            [t_it50].[_KEY]={}
        `.f(
          _d_vals.it50_key,
        )),
      ],
    },

    // 月別の外販客数 it50i910
    it60i910: {
      pfx: '月別 外販客数',
      l_trgs: ['it50i910'],
      lo_qrys: [
        // it60i910 月別情報 外販客数 it50i910
        _d_vals => bf.q(`
          UPDATE [t_it60] SET 
            [it60i910]=(
              SELECT 
                SUM(IFNULL([it50i910],"0")::NUMERIC::INTEGER)::TEXT 
              FROM 
                [t_it50]
              WHERE 
                [it50b21k]=[t_it60].[_KEY]::TEXT
            )
          WHERE 
            [t_it60].[_KEY]={}
        `.f(
          _d_vals.it60_key,
        )),
      ],
    },

    // 日別情報 客数 ※出戻りは対象外
    it50i810: {
      pfx: '日別 客数',
      l_trgs: ['it10i330'],
      lo_qrys: [
        // 日別情報 客数 ※出戻りは対象外
        _d_vals => bf.q(`
          UPDATE 
            [t_it50] 
          SET 
            [it50i810]=(
              SELECT 
                SUM(IFNULL([it10i330], "0")::NUMERIC::INTEGER)::TEXT 
              FROM 
                [t_it10] 
              WHERE 
                [it10b31k]=[t_it50].[_KEY]::TEXT AND [it10s110] IN ("10","20") AND [it10t110] IN ("10")
            )
          WHERE 
            [t_it50].[_KEY]={}
        `.f(
          _d_vals.it50_key,
        )),
      ],
    },

    // 日別情報 客単価
    it50i820: {
      pfx: '日別 客単価',
      l_trgs: ['it50i210', 'it50i810'],
      lo_qrys: [
        // 日別情報 客単価
        _d_vals => bf.q(`
          UPDATE 
            [t_it50] 
          SET 
            [it50i820]=(
              SELECT CASE
                WHEN
                  REPLACE(IFNULL([it50i810],"0"),"None","0")::NUMERIC::INTEGER = 0
                THEN
                  0
                ELSE
                  REPLACE(IFNULL([it50i210],"0"),"None","0")::NUMERIC::INTEGER / REPLACE(IFNULL([it50i810],"0"),"None","0")::NUMERIC::INTEGER
                END
            )::TEXT
          WHERE 
            [t_it50].[_KEY]={}
        `.f(
          _d_vals.it50_key,
        )),
      ],
    },

    // 月別情報 客数
    it60i810: {
      pfx: '月別 客数合計',
      l_trgs: ['it50i810'],
      lo_qrys: [
        // 月別情報 客数
        _d_vals => bf.q(`
          UPDATE [t_it60] SET 
            [it60i810]=(
              SELECT 
                SUM(IFNULL([it50i810],"0")::NUMERIC::INTEGER)::TEXT 
              FROM 
                [t_it50]
              WHERE 
                [it50b21k]=[t_it60].[_KEY]::TEXT
            )
          WHERE 
            [t_it60].[_KEY]={}
        `.f(
          _d_vals.it60_key,
        )),
        // 月別情報 平日客数
        _d_vals => bf.q(`
          UPDATE 
            [t_it60] 
          SET 
            [it60i8c0]=(
              SELECT 
                SUM(IFNULL([it50i810],"0")::NUMERIC::INTEGER)::TEXT
              FROM 
                [t_it50] 
              WHERE 
                [it50b21k]=[t_it60].[_KEY]::TEXT AND IFNULL([it50t110],"0")="10"
            )::TEXT
          WHERE 
            [t_it60].[_KEY]={}
        `.f(
          _d_vals.it60_key,
        )),
        // 月別情報 休日前客数
        _d_vals => bf.q(`
          UPDATE 
            [t_it60] 
          SET 
            [it60i8d0]=(
              SELECT 
                SUM(IFNULL([it50i810],"0")::NUMERIC::INTEGER)::TEXT
              FROM 
                [t_it50] 
              WHERE 
                [it50b21k]=[t_it60].[_KEY]::TEXT AND IFNULL([it50t110],"0")="20"
            )::TEXT
          WHERE 
            [t_it60].[_KEY]={}
        `.f(
          _d_vals.it60_key,
        )),
        // 月別情報 休日客数
        _d_vals => bf.q(`
          UPDATE 
            [t_it60] 
          SET 
            [it60i8e0]=(
              SELECT 
                SUM(IFNULL([it50i810],"0")::NUMERIC::INTEGER)::TEXT
              FROM 
                [t_it50] 
              WHERE 
                [it50b21k]=[t_it60].[_KEY]::TEXT AND IFNULL([it50t110],"0")="30"
            )::TEXT
          WHERE 
            [t_it60].[_KEY]={}
        `.f(
          _d_vals.it60_key,
        )),
      ],
    },

    // 月別情報 客単価
    it60i820: {
      pfx: '月別 客単価',
      l_trgs: ['it60i210', 'it60i810'],
      lo_qrys: [
        // 月別情報 客単価
        _d_vals => bf.q(`
          UPDATE 
            [t_it60] 
          SET 
            [it60i820]=(
              SELECT CASE
                WHEN
                  REPLACE(IFNULL([it60i810],"0"),"None","0")::NUMERIC::INTEGER = 0
                THEN
                  0
                ELSE
                  REPLACE(IFNULL([it60i210],"0"),"None","0")::NUMERIC::INTEGER / REPLACE(IFNULL([it60i810],"0"),"None","0")::NUMERIC::INTEGER
                END
            )::TEXT
          WHERE 
            [t_it60].[_KEY]={}
        `.f(
          _d_vals.it60_key,
        )),
      ],
    },

    // 月別情報 平均客数
    it60i850: {
      pfx: '月別 平均客数',
      l_trgs: ['it60i810', 'it60i310'],
      lo_qrys: [
        // 月別情報 平均客数
        _d_vals => bf.q(`
          UPDATE 
            [t_it60] 
          SET 
            [it60i850]=(
              SELECT CASE
                WHEN
                  REPLACE(IFNULL([it60i310],"0"),"None","0")::NUMERIC::INTEGER = 0
                THEN
                  0.00
                ELSE
                  ROUND(REPLACE(IFNULL([it60i810],"0"),"None","0")::NUMERIC::REAL * 100.00 / REPLACE(IFNULL([it60i310],"0"),"None","0")::NUMERIC::REAL) / 100.00
                END
            )::TEXT
          WHERE 
            [t_it60].[_KEY]={}
        `.f(
          _d_vals.it60_key,
        )),
        // 月別情報 平均平日客数
        _d_vals => bf.q(`
          UPDATE 
            [t_it60] 
          SET 
            [it60i8f0]=(
              SELECT CASE
                WHEN
                  REPLACE(IFNULL([it60i320],"0"),"None","0")::NUMERIC::INTEGER = 0
                THEN
                  0
                ELSE
                  REPLACE(IFNULL([it60i8c0],"0"),"None","0")::NUMERIC::INTEGER / REPLACE(IFNULL([it60i320],"0"),"None","0")::NUMERIC::INTEGER
                END
            )::TEXT
          WHERE 
            [t_it60].[_KEY]={}
        `.f(
          _d_vals.it60_key,
        )),
        // 月別情報 平均休日前客数
        _d_vals => bf.q(`
          UPDATE 
            [t_it60] 
          SET 
            [it60i8g0]=(
              SELECT CASE
                WHEN
                  REPLACE(IFNULL([it60i330],"0"),"None","0")::NUMERIC::INTEGER = 0
                THEN
                  0
                ELSE
                  REPLACE(IFNULL([it60i8d0],"0"),"None","0")::NUMERIC::INTEGER / REPLACE(IFNULL([it60i330],"0"),"None","0")::NUMERIC::INTEGER
                END
            )::TEXT
          WHERE 
            [t_it60].[_KEY]={}
        `.f(
          _d_vals.it60_key,
        )),
        // 月別情報 平均休日客数
        _d_vals => bf.q(`
          UPDATE 
            [t_it60] 
          SET 
            [it60i8h0]=(
              SELECT CASE
                WHEN
                  REPLACE(IFNULL([it60i340],"0"),"None","0")::NUMERIC::INTEGER = 0
                THEN
                  0
                ELSE
                  REPLACE(IFNULL([it60i8e0],"0"),"None","0")::NUMERIC::INTEGER / REPLACE(IFNULL([it60i340],"0"),"None","0")::NUMERIC::INTEGER
                END
            )::TEXT
          WHERE 
            [t_it60].[_KEY]={}
        `.f(
          _d_vals.it60_key,
        )),
      ],
    },

    // 月別情報 客数予測 it60i860
    it60i860: {
      pfx: '月別 客数予測',
      l_trgs: ['it60i850', 'it60i510'],
      lo_qrys: [
        // 月別情報 客数予測 it60i860
        _d_vals => bf.q(`
          UPDATE 
            [t_it60] 
          SET 
            [it60i860]=(
              REPLACE(IFNULL([it60i850],"0"),"None","0")::NUMERIC::INTEGER * REPLACE(IFNULL([it60i510],"0"),"None","0")::NUMERIC::INTEGER
            )::TEXT
          WHERE 
            [t_it60].[_KEY]={}
        `.f(
          _d_vals.it60_key,
        )),
      ],
    },

    // it50i920 日別情報 新規客数 ※出戻りを除く
    it50i920: {
      pfx: '日別 新規客数合計',
      l_trgs: ['it10i330'], // 便宜的に it10i320 ではなく it10i330 をトリガとする
      lo_qrys: [
        // it50i920 日別情報 新規客数 ※出戻りを除く
        _d_vals => bf.q(`
          UPDATE 
            [t_it50] 
          SET 
            [it50i920]=(
              SELECT 
                SUM(IFNULL([it10i320], "0")::NUMERIC::INTEGER)::TEXT 
              FROM 
                [t_it10] 
              WHERE 
                [it10b31k]=[t_it50].[_KEY]::TEXT AND [it10t110]="10"
            )
          WHERE 
            [t_it50].[_KEY]={}
        `.f(
          _d_vals.it50_key,
        )),
        // it50i930 日別情報 反響率 it50i920, it50i810
/*
        _d_vals => bf.q(`
          UPDATE 
            [t_it50] 
          SET 
            [it50i930]=(
              SELECT CASE
                WHEN
                  REPLACE(IFNULL([it50i810],"0"),"None","0")::NUMERIC::INTEGER = 0
                THEN
                  0
                ELSE
                  REPLACE(IFNULL([it50i920],"0"),"None","0")::NUMERIC::INTEGER * 100 / REPLACE(IFNULL([it50i810],"0"),"None","0")::NUMERIC::INTEGER
                END
            )::TEXT
          WHERE 
            [t_it50].[_KEY]={}
        `.f(
          _d_vals.it50_key,
        )),
*/
        _d_vals => bf.q(`
          UPDATE 
            [t_it50] 
          SET 
            [it50i930]=(
              SELECT CASE
                WHEN
                  REPLACE(IFNULL([it50ia10],"0"),"None","0")::NUMERIC::INTEGER = 0
                THEN
                  0
                ELSE
                  REPLACE(IFNULL([it50i920],"0"),"None","0")::NUMERIC::INTEGER * 100 / REPLACE(IFNULL([it50ia10],"0"),"None","0")::NUMERIC::INTEGER
                END
            )::TEXT
          WHERE 
            [t_it50].[_KEY]={}
        `.f(
          _d_vals.it50_key,
        )),
      ],
    },

    // it60i880 月別情報 総新規客数 it50i920
    it60i880: {
      pfx: '月別 新規客数合計',
      l_trgs: ['it50i920'],
      lo_qrys: [
        // it60i880 月別情報 総新規客数 it50i920
        _d_vals => bf.q(`
          UPDATE [t_it60] SET 
            [it60i880]=(
              SELECT 
                SUM(IFNULL([it50i920],"0")::NUMERIC::INTEGER)::TEXT 
              FROM 
                [t_it50]
              WHERE 
                [it50b21k]=[t_it60].[_KEY]::TEXT
            )
          WHERE 
            [t_it60].[_KEY]={}
        `.f(
          _d_vals.it60_key,
        )),
        // it60i930 月別情報 反響率 it60i880, it60i810
/*
        _d_vals => bf.q(`
          UPDATE 
            [t_it60] 
          SET 
            [it60i930]=(
              SELECT CASE
                WHEN
                  REPLACE(IFNULL([it60i810],"0"),"None","0")::NUMERIC::INTEGER = 0
                THEN
                  0
                ELSE
                  REPLACE(IFNULL([it60i880],"0"),"None","0")::NUMERIC::INTEGER * 100 / REPLACE(IFNULL([it60i810],"0"),"None","0")::NUMERIC::INTEGER
                END
            )::TEXT
          WHERE 
            [t_it60].[_KEY]={}
        `.f(
          _d_vals.it60_key,
        )),
*/
        _d_vals => bf.q(`
          UPDATE 
            [t_it60] 
          SET 
            [it60i930]=(
              SELECT CASE
                WHEN
                  REPLACE(IFNULL([it60ia10],"0"),"None","0")::NUMERIC::INTEGER = 0
                THEN
                  0
                ELSE
                  REPLACE(IFNULL([it60i880],"0"),"None","0")::NUMERIC::INTEGER * 100 / REPLACE(IFNULL([it60ia10],"0"),"None","0")::NUMERIC::INTEGER
                END
            )::TEXT
          WHERE 
            [t_it60].[_KEY]={}
        `.f(
          _d_vals.it60_key,
        )),
      ],
    },

    // it60i890 月別情報 平均新規客数 it60i880, it60i310
    it60i890: {
      pfx: '月別 平均新規客数',
      l_trgs: ['it60i880', 'it60i310'],
      lo_qrys: [
        _d_vals => bf.q(`
          UPDATE 
            [t_it60] 
          SET 
            [it60i890]=(
              SELECT CASE
                WHEN
                  REPLACE(IFNULL([it60i310],"0"),"None","0")::NUMERIC::INTEGER = 0
                THEN
                  0.00
                ELSE
                  ROUND(REPLACE(IFNULL([it60i880],"0"),"None","0")::NUMERIC::REAL * 100.00 / REPLACE(IFNULL([it60i310],"0"),"None","0")::NUMERIC::REAL) / 100.00
                END
            )::TEXT
          WHERE 
            [t_it60].[_KEY]={}
        `.f(
          _d_vals.it60_key,
        )),
      ],
    },

    // it60i8a0 月別情報 新規客数予測 it60i890, ti60i510
    it60i8a0: {
      pfx: '月別 新規客数予測',
      l_trgs: ['it60i890', 'it60i510'],
      lo_qrys: [
        _d_vals => bf.q(`
          UPDATE 
            [t_it60] 
          SET 
            [it60i8a0]=(
              REPLACE(IFNULL([it60i890],"0"),"None","0")::NUMERIC::INTEGER * REPLACE(IFNULL([it60i510],"0"),"None","0")::NUMERIC::INTEGER
            )::TEXT
          WHERE 
            [t_it60].[_KEY]={}
        `.f(
          _d_vals.it60_key,
        )),
      ],
    },

    // 日別情報 延長客数
    it50i830: {
      pfx: '日別 延長客数',
      l_trgs: ['it10i350'],
      lo_qrys: [
        // 日別情報 延長客数
        _d_vals => bf.q(`
          UPDATE 
            [t_it50] 
          SET 
            [it50i830]=(
              SELECT 
                SUM(IFNULL([it10i350],"0")::NUMERIC::INTEGER)::TEXT 
              FROM 
                [t_it10] 
              WHERE 
                [it10b31k]=[t_it50].[_KEY]::TEXT
            )
          WHERE 
            [t_it50].[_KEY]={}
        `.f(
          _d_vals.it50_key,
        )),
        // 日別情報 延長率
        _d_vals => bf.q(`
          UPDATE 
            [t_it50] 
          SET 
            [it50i840]=(
              SELECT CASE
                WHEN
                  IFNULL([it50i810],"0")::NUMERIC = 0
                THEN
                  "0"
                ELSE
                  (IFNULL([it50i830],"0")::NUMERIC*100/[it50i810]::NUMERIC)::INTEGER::TEXT
                END
            )
          WHERE 
            [t_it50].[_KEY]={}
        `.f(
          _d_vals.it50_key,
        )),
      ],
    },

    // 月別情報 延長客数
    it60i830: {
      pfx: '月別 延長客数',
      l_trgs: ['it50i830'],
      lo_qrys: [
        // 月別情報 延長客数
        _d_vals => bf.q(`
          UPDATE 
            [t_it60] 
          SET 
            [it60i830]=(
              SELECT 
                SUM(IFNULL([it50i830],"0")::NUMERIC::INTEGER)::TEXT 
              FROM 
                [t_it50] 
              WHERE 
                [it50b21k]=[t_it60].[_KEY]::TEXT
            )
          WHERE 
            [t_it60].[_KEY]={}
        `.f(
          _d_vals.it60_key,
        )),
        // 月別情報 延長率
        _d_vals => bf.q(`
          UPDATE 
            [t_it60] 
          SET 
            [it60i840]=(
              SELECT CASE
                WHEN
                  IFNULL([it60i810],"0")::NUMERIC = 0
                THEN
                  "0"
                ELSE
                  (IFNULL([it60i830],"0")::NUMERIC*100/[it60i810]::NUMERIC)::INTEGER::TEXT
                END
            )
          WHERE 
            [t_it60].[_KEY]={}
        `.f(
          _d_vals.it60_key,
        )),
      ],
    },

    // it50i210 日別情報 売上
    it50i210: {
      pfx: '日別 売上',
      l_trgs: ['it10ia70'],
      lo_qrys: [
        // it50i210 日別情報 売上
        _d_vals => bf.q(`
          UPDATE 
            [t_it50] 
          SET 
            [it50i210]=(
              SELECT 
                SUM(IFNULL([it10ia70],"0")::NUMERIC::INTEGER)::TEXT
              FROM 
                [t_it10] 
              WHERE 
                [it10b31k]=[t_it50].[_KEY]::TEXT
            ),
            [it50cy10]="{}"
          WHERE 
            [t_it50].[_KEY]={}
        `.f(
          bf.myDT_get_now(),
          _d_vals.it50_key,
        )),
      ],
    },

    // it50i120 日別情報 大入差額
    it50i120: {
      pfx: '日別 大入差額',
      l_trgs: ['it50i210', 'it50i110'],
      lo_qrys: [
        // it50i120 日別情報 大入差額
        _d_vals => bf.q(`
          UPDATE 
            [t_it50] 
          SET 
            [it50i120]=(
              IFNULL([it50i210],"0")::NUMERIC::INTEGER - IFNULL([it50i110],"0")::NUMERIC::INTEGER
            )::TEXT
          WHERE 
            [t_it50].[_KEY]={}
        `.f(
          _d_vals.it50_key,
        )),
      ],
    },

    // it50i820 日別情報 客単価
    it50i820: {
      pfx: '日別 客単価',
      l_trgs: ['it50i210', 'it50i810'],
      lo_qrys: [
        // it50i820 日別情報 客単価
        _d_vals => bf.q(`
          UPDATE 
            [t_it50] 
          SET 
            [it50i820]=(
              SELECT CASE
                WHEN
                  REPLACE(IFNULL([it50i810],"0"),"None","0")::NUMERIC::INTEGER = 0
                THEN
                  0
                ELSE
                  REPLACE(IFNULL([it50i210],"0"),"None","0")::NUMERIC::INTEGER / REPLACE(IFNULL([it50i810],"0"),"None","0")::NUMERIC::INTEGER
                END
            )::TEXT
          WHERE 
            [t_it50].[_KEY]={}
        `.f(
          _d_vals.it50_key,
        )),
      ],
    },

    // it50ic10 日別情報 利益の更新
    it50ic10: {
      pfx: '日別 利益',
      l_trgs: ['it50i210', 'it50ib10'],
      lo_qrys: [
        // it50ic10 日別情報 利益の更新
        _d_vals => bf.q(`
          UPDATE 
            [t_it50] 
          SET 
            [it50ic10]=(
              REPLACE(IFNULL([it50i210],"0"),"None","0")::NUMERIC::INTEGER
              - REPLACE(IFNULL([it50ib10],"0"),"None","0")::NUMERIC::INTEGER
            )::TEXT
          WHERE 
            [t_it50].[_KEY]={}
        `.f(
          _d_vals.it50_key,
        )),
      ],
    },

    // it50i210 月別情報 総売り上げ it50i210
    it60i210: {
      pfx: '月別 売上合計',
      l_trgs: ['it50i210'],
      lo_qrys: [
        // it50i210 月別情報 総売り上げ it50i210
        _d_vals => bf.q(`
          UPDATE 
            [t_it60] 
          SET 
            [it60i210]=(
              SELECT 
                SUM(IFNULL([it50i210],"0")::NUMERIC::INTEGER)::TEXT
              FROM 
                [t_it50] 
              WHERE 
                [it50b21k]=[t_it60].[_KEY]::TEXT
            )::TEXT
          WHERE 
            [t_it60].[_KEY]={}
        `.f(
          _d_vals.it60_key,
        )),
        // it60i420 月別情報 平日売上 it50i210
        _d_vals => bf.q(`
          UPDATE 
            [t_it60] 
          SET 
            [it60i420]=(
              SELECT 
                SUM(IFNULL([it50i210],"0")::NUMERIC::INTEGER)::TEXT
              FROM 
                [t_it50] 
              WHERE 
                [it50b21k]=[t_it60].[_KEY]::TEXT AND IFNULL([it50t110],"0")="10"
            )::TEXT
          WHERE 
            [t_it60].[_KEY]={}
        `.f(
          _d_vals.it60_key,
        )),
        // it60i430 月別情報 休日前売上 it50i210
        _d_vals => bf.q(`
          UPDATE 
            [t_it60] 
          SET 
            [it60i430]=(
              SELECT 
                SUM(IFNULL([it50i210],"0")::NUMERIC::INTEGER)::TEXT
              FROM 
                [t_it50] 
              WHERE 
                [it50b21k]=[t_it60].[_KEY]::TEXT AND IFNULL([it50t110],"0")="20"
            )::TEXT
          WHERE 
            [t_it60].[_KEY]={}
        `.f(
          _d_vals.it60_key,
        )),
        // it60i440 月別情報 休日売上 it50i210
        _d_vals => bf.q(`
          UPDATE 
            [t_it60] 
          SET 
            [it60i440]=(
              SELECT 
                SUM(IFNULL([it50i210],"0")::NUMERIC::INTEGER)::TEXT
              FROM 
                [t_it50] 
              WHERE 
                [it50b21k]=[t_it60].[_KEY]::TEXT AND IFNULL([it50t110],"0")="30"
            )::TEXT
          WHERE 
            [t_it60].[_KEY]={}
        `.f(
          _d_vals.it60_key,
        )),
      ],
    },

    // it60i710: 月別情報 売上目標との差 it60i610, it60i110
    it60i710: {
      pfx: '月別 売上目標差額',
      l_trgs: ['it60i610', 'it60i110'],
      lo_qrys: [
        // it60i710: 月別情報 売上目標との差 it60i610, it60i110
        _d_vals => bf.q(`
          UPDATE 
            [t_it60] 
          SET 
            [it60i710]=(
              REPLACE(IFNULL([it60i610],"0"),"None","0")::NUMERIC::INTEGER - REPLACE(IFNULL([it60i110],"0"),"None","0")::NUMERIC::INTEGER
            )::TEXT
          WHERE 
            [t_it60].[_KEY]={}
        `.f(
          _d_vals.it60_key,
        )),
      ],
    },

    // it60i820 月別情報 客単価 it60i210, it60i810
    it60i820: {
      pfx: '月別 客単価',
      l_trgs: ['it60i210', 'it60i810'],
      lo_qrys: [
        // it60i820 月別情報 客単価 it60i210, it60i810
        _d_vals => bf.q(`
          UPDATE 
            [t_it60] 
          SET 
            [it60i820]=(
              SELECT CASE
                WHEN
                  REPLACE(IFNULL([it60i810],"0"),"None","0")::NUMERIC::INTEGER = 0
                THEN
                  0
                ELSE
                  REPLACE(IFNULL([it60i210],"0"),"None","0")::NUMERIC::INTEGER / REPLACE(IFNULL([it60i810],"0"),"None","0")::NUMERIC::INTEGER
                END
            )::TEXT
          WHERE 
            [t_it60].[_KEY]={}
        `.f(
          _d_vals.it60_key,
        )),
      ],
    },

    // it60ib10 月別情報 総利益 it50ic10
    it60ib10: {
      pfx: '月別 利益合計',
      l_trgs: ['it50ic10'],
      lo_qrys: [
        // it60ib10 月別情報 総利益 it50ic10
        _d_vals => bf.q(`
          UPDATE 
            [t_it60] 
          SET 
            [it60ib10]=(
              SELECT 
                SUM(IFNULL([it50ic10],"0")::NUMERIC::INTEGER)::TEXT
              FROM 
                [t_it50] 
              WHERE 
                [it50b21k]=[t_it60].[_KEY]::TEXT
            )::TEXT
          WHERE 
            [t_it60].[_KEY]={}
        `.f(
          _d_vals.it60_key,
        )),
        // it60ib20 月別情報 平日利益 it50ic10
        _d_vals => bf.q(`
          UPDATE 
            [t_it60] 
          SET 
            [it60ib20]=(
              SELECT 
                SUM(IFNULL([it50ic10],"0")::NUMERIC::INTEGER)::TEXT
              FROM 
                [t_it50] 
              WHERE 
                [it50b21k]=[t_it60].[_KEY]::TEXT AND IFNULL([it50t110],"0")="10"
            )::TEXT
          WHERE 
            [t_it60].[_KEY]={}
        `.f(
          _d_vals.it60_key,
        )),
        // it60ib30 月別情報 休日前利益 it50ic10
        _d_vals => bf.q(`
          UPDATE 
            [t_it60] 
          SET 
            [it60ib30]=(
              SELECT 
                SUM(IFNULL([it50ic10],"0")::NUMERIC::INTEGER)::TEXT
              FROM 
                [t_it50] 
              WHERE 
                [it50b21k]=[t_it60].[_KEY]::TEXT AND IFNULL([it50t110],"0")="20"
            )::TEXT
          WHERE 
            [t_it60].[_KEY]={}
        `.f(
          _d_vals.it60_key,
        )),
        // it60ib40: 月別情報 休日利益 it50ic10
        _d_vals => bf.q(`
          UPDATE 
            [t_it60] 
          SET 
            [it60ib40]=(
              SELECT 
                SUM(IFNULL([it50ic10],"0")::NUMERIC::INTEGER)::TEXT
              FROM 
                [t_it50] 
              WHERE 
                [it50b21k]=[t_it60].[_KEY]::TEXT AND IFNULL([it50t110],"0")="30"
            )::TEXT
          WHERE 
            [t_it60].[_KEY]={}
        `.f(
          _d_vals.it60_key,
        )),
      ],
    },

    // 月別 経過日数
    it60i310: {
      pfx: '月別 経過日数',
      l_trgs: ['it50t110'],
      lo_qrys: [
        // it60i310 月別情報 総経過日数
        _d_vals => bf.q(`
          UPDATE 
            [t_it60] 
          SET 
            [it60i310]=(
              SELECT 
                IFNULL(COUNT(*),0)
              FROM 
                [t_it50] 
              WHERE 
                [it50b21k]=[t_it60].[_KEY]::TEXT AND IFNULL([it50s110],"0") IN ("10", "20") AND IFNULL([it50t110],"0")<>"0"
            )::TEXT
          WHERE 
            [t_it60].[_KEY]={}
        `.f(
          _d_vals.it60_key,
        )),
        // it60i320 月別情報 平日経過日数
        _d_vals => bf.q(`
          UPDATE 
            [t_it60] 
          SET 
            [it60i320]=(
              SELECT 
                IFNULL(COUNT(*),0)
              FROM 
                [t_it50] 
              WHERE 
                [it50b21k]=[t_it60].[_KEY]::TEXT AND IFNULL([it50s110],"0") IN ("10", "20") AND IFNULL([it50t110],"0")="10"
            )::TEXT
          WHERE 
            [t_it60].[_KEY]={}
        `.f(
          _d_vals.it60_key,
        )),
        // it60i330 月別情報 休日前経過日数
        _d_vals => bf.q(`
          UPDATE 
            [t_it60] 
          SET 
            [it60i330]=(
              SELECT 
                IFNULL(COUNT(*),0)
              FROM 
                [t_it50] 
              WHERE 
                [it50b21k]=[t_it60].[_KEY]::TEXT AND IFNULL([it50s110],"0") IN ("10", "20") AND IFNULL([it50t110],"0")="20"
            )::TEXT
          WHERE 
            [t_it60].[_KEY]={}
        `.f(
          _d_vals.it60_key,
        )),
        // it60i340 月別情報 休日経過日数
        _d_vals => bf.q(`
          UPDATE 
            [t_it60] 
          SET 
            [it60i340]=(
              SELECT 
                IFNULL(COUNT(*),0)
              FROM 
                [t_it50] 
              WHERE 
                [it50b21k]=[t_it60].[_KEY]::TEXT AND IFNULL([it50s110],"0") IN ("10", "20") AND IFNULL([it50t110],"0")="30"
            )::TEXT
          WHERE 
            [t_it60].[_KEY]={}
        `.f(
          _d_vals.it60_key,
        )),
      ],
    },

    // it60i410: 月別情報 平均総売上 it60i210, it60i310
    it60i410: {
      pfx: '月別 平均売上',
      l_trgs: ['it60i210', 'it60i310'],
      lo_qrys: [
        // it60i410: 月別情報 平均総売上 it60i210, it60i310
        _d_vals => bf.q(`
          UPDATE 
            [t_it60] 
          SET 
            [it60i410]=(
              SELECT CASE
                WHEN
                  REPLACE(IFNULL([it60i310],"0"),"None","0")::NUMERIC::INTEGER = 0
                THEN
                  0
                ELSE
                  REPLACE(IFNULL([it60i210],"0"),"None","0")::NUMERIC::INTEGER / REPLACE(IFNULL([it60i310],"0"),"None","0")::NUMERIC::INTEGER
                END
            )::TEXT
          WHERE 
            [t_it60].[_KEY]={}
        `.f(
          _d_vals.it60_key,
        )),
        // it60i450 月別情報 平均平日売上 it60i420, it60i320
        _d_vals => bf.q(`
          UPDATE 
            [t_it60] 
          SET 
            [it60i450]=(
              SELECT CASE
                WHEN
                  REPLACE(IFNULL([it60i320],"0"),"None","0")::NUMERIC::INTEGER = 0
                THEN
                  0
                ELSE
                  REPLACE(IFNULL([it60i420],"0"),"None","0")::NUMERIC::INTEGER / REPLACE(IFNULL([it60i320],"0"),"None","0")::NUMERIC::INTEGER
                END
            )::TEXT
          WHERE 
            [t_it60].[_KEY]={}
        `.f(
          _d_vals.it60_key,
        )),
        // it60i460: 月別情報 平均休日前売上 it60i430, it50i330
        _d_vals => bf.q(`
          UPDATE 
            [t_it60] 
          SET 
            [it60i460]=(
              SELECT CASE
                WHEN
                  REPLACE(IFNULL([it60i330],"0"),"None","0")::NUMERIC::INTEGER = 0
                THEN
                  0
                ELSE
                  REPLACE(IFNULL([it60i430],"0"),"None","0")::NUMERIC::INTEGER / REPLACE(IFNULL([it60i330],"0"),"None","0")::NUMERIC::INTEGER
                END
            )::TEXT
          WHERE 
            [t_it60].[_KEY]={}
        `.f(
          _d_vals.it60_key,
        )),
        // it60i470: 月別情報 平均休日売上 it60i440, it60i340
        _d_vals => bf.q(`
          UPDATE 
            [t_it60] 
          SET 
            [it60i470]=(
              SELECT CASE
                WHEN
                  REPLACE(IFNULL([it60i340],"0"),"None","0")::NUMERIC::INTEGER = 0
                THEN
                  0
                ELSE
                  REPLACE(IFNULL([it60i440],"0"),"None","0")::NUMERIC::INTEGER / REPLACE(IFNULL([it60i340],"0"),"None","0")::NUMERIC::INTEGER
                END
            )::TEXT
          WHERE 
            [t_it60].[_KEY]={}
        `.f(
          _d_vals.it60_key,
        )),
      ],
    },

    // it60i610: 月別情報 売上予測 it60i410, it60i510
    it60i610: {
      pfx: '月別 売上予測',
      l_trgs: ['it60i410', 'it60i510'],
      lo_qrys: [
        // it60i610: 月別情報 売上予測 it60i410, it60i510
        _d_vals => bf.q(`
          UPDATE 
            [t_it60] 
          SET 
            [it60i610]=(
              REPLACE(IFNULL([it60i410],"0"),"None","0")::NUMERIC::INTEGER * REPLACE(IFNULL([it60i510],"0"),"None","0")::NUMERIC::INTEGER
            )::TEXT
          WHERE 
            [t_it60].[_KEY]={}
        `.f(
          _d_vals.it60_key,
        )),
      ],
    },

    // it60ic10: 月別情報 平均総利益 it60ib10, it60i310
    it60ic10: {
      pfx: '月別 平均利益',
      l_trgs: ['it60ib10', 'it60i310'],
      lo_qrys: [
        // it60ic10: 月別情報 平均総利益 it60ib10, it60i310
        _d_vals => bf.q(`
          UPDATE 
            [t_it60] 
          SET 
            [it60ic10]=(
              SELECT CASE
                WHEN
                  REPLACE(IFNULL([it60i310],"0"),"None","0")::NUMERIC::INTEGER = 0
                THEN
                  0
                ELSE
                  REPLACE(IFNULL([it60ib10],"0"),"None","0")::NUMERIC::INTEGER / REPLACE(IFNULL([it60i310],"0"),"None","0")::NUMERIC::INTEGER
                END
            )::TEXT
          WHERE 
            [t_it60].[_KEY]={}
        `.f(
          _d_vals.it60_key,
        )),
        // it60ic20 月別情報 平均平日利益 it60ib20, it60i320
        _d_vals => bf.q(`
          UPDATE 
            [t_it60] 
          SET 
            [it60ic20]=(
              SELECT CASE
                WHEN
                  REPLACE(IFNULL([it60i320],"0"),"None","0")::NUMERIC::INTEGER = 0
                THEN
                  0
                ELSE
                  REPLACE(IFNULL([it60ib20],"0"),"None","0")::NUMERIC::INTEGER / REPLACE(IFNULL([it60i320],"0"),"None","0")::NUMERIC::INTEGER
                END
            )::TEXT
          WHERE 
            [t_it60].[_KEY]={}
        `.f(
          _d_vals.it60_key,
        )),
        // it60ic30: 月別情報 平均休日前利益 it60ib30, it60i330
        _d_vals => bf.q(`
          UPDATE 
            [t_it60] 
          SET 
            [it60ic30]=(
              SELECT CASE
                WHEN
                  REPLACE(IFNULL([it60i330],"0"),"None","0")::NUMERIC::INTEGER = 0
                THEN
                  0
                ELSE
                  REPLACE(IFNULL([it60ib30],"0"),"None","0")::NUMERIC::INTEGER / REPLACE(IFNULL([it60i330],"0"),"None","0")::NUMERIC::INTEGER
                END
            )::TEXT
          WHERE 
            [t_it60].[_KEY]={}
        `.f(
          _d_vals.it60_key,
        )),
        // it60ic40: 月別情報 平均休日利益 it60ib40, it60i340
        _d_vals => bf.q(`
          UPDATE 
            [t_it60] 
          SET 
            [it60ic40]=(
              SELECT CASE
                WHEN
                  REPLACE(IFNULL([it60i340],"0"),"None","0")::NUMERIC::INTEGER = 0
                THEN
                  0
                ELSE
                  REPLACE(IFNULL([it60ib40],"0"),"None","0")::NUMERIC::INTEGER / REPLACE(IFNULL([it60i340],"0"),"None","0")::NUMERIC::INTEGER
                END
            )::TEXT
          WHERE 
            [t_it60].[_KEY]={}
        `.f(
          _d_vals.it60_key,
        )),
      ],
    },

    // it60id10: 月別情報 利益予測 it60ic10, it60i510
    it60id10: {
      pfx: '月別 利益予測',
      l_trgs: ['it60ic10', 'it60i510'],
      lo_qrys: [
        // it60id10: 月別情報 利益予測 it60ic10, it60i510
        _d_vals => bf.q(`
          UPDATE 
            [t_it60] 
          SET 
            [it60id10]=(
              REPLACE(IFNULL([it60ic10],"0"),"None","0")::NUMERIC::INTEGER * REPLACE(IFNULL([it60i510],"0"),"None","0")::NUMERIC::INTEGER
            )::TEXT
          WHERE 
            [t_it60].[_KEY]={}
        `.f(
          _d_vals.it60_key,
        )),
      ],
    },

    // 貢献度
    it31i130: {
      pfx: '注文 貢献度',
      l_trgs: ['it31i110'],
      lo_qrys: [
        _d_vals => bf.q(`
          UPDATE 
            [t_it31] 
          SET
            [it31i120]=(
              SELECT 
                IFNULL(SUM([B].[it31i110]::NUMERIC),"0.0")
              FROM
                [t_it31] AS [B]
              WHERE
                [B].[it31b11k]=[t_it31].[it31b11k] AND
                [B].[it31b21k]=[t_it31].[it31b21k] AND
                IFNULL([B].[it31cz10],"10")<>"0"
            )::TEXT
          WHERE
            [it31b11k]="{}" AND
            IFNULL([it31cz10],"10")<>"0"
        `.f(
          _d_vals.it10_key,
        )),
        _d_vals => bf.q(`
          UPDATE 
            [t_it31] 
          SET
            [it31i130]=(
              SELECT
                CASE
                  WHEN  
                    [it31i120]::NUMERIC::INTEGER = 0.0
                  THEN
                    0.0
                  ELSE
                    CEIL(IFNULL([it31i110],"0.0")::NUMERIC * 1000.0 / [it31i120]::NUMERIC) / 10.0
                  END
            )::TEXT
          WHERE
            [it31b11k]="{}" AND
            IFNULL([it31cz10],"10")<>"0"
        `.f(
          _d_vals.it10_key,
        )),
      ],
    },

    it10ia70: {
      pfx: '顧客情報 支払額',
      l_trgs: [],
      lo_qrys: [
        // 顧客情報 基本料金
        _d_vals => bf.q(`
          UPDATE 
            [t_it10] 
          SET 
            [it10i610]=(
              (
                SELECT 
                  IFNULL([cm50i110],"0")::NUMERIC::INTEGER 
                FROM 
                  [t_cm50] 
                WHERE 
                  [t_cm50].[_KEY]=[it10i110]::NUMERIC::INTEGER
              ) * IFNULL([it10i330],"0")::NUMERIC::INTEGER
            )::TEXT
          WHERE 
            [_KEY]={}
        `.f(
          _d_vals.it10_key,
        )),
/*
        // 注文情報 延長単価
        _d_vals => bf.q(`
          UPDATE 
            [t_it30] 
          SET 
            [it30i210]=(
              SELECT
                CASE
                  WHEN 
                    (
                      SELECT
                        COUNT(*)
                      FROM
                        [t_cm5i]
                      WHERE
                        [cm5ib11k]=[it30i110] AND
                        [cm5ii110]="30"
                    )>0
                  THEN
                    [cm5ii210]
                  WHEN 
                    (
                      SELECT
                        COUNT(*)
                      FROM
                        [t_cm5i]
                      WHERE
                        [cm5ib11k]=[it30i110] AND
                        [cm5ii110]="60"
                    )>0
                  THEN
                    [cm5ii220]                  
                  ELSE
                    "0"
                  END
              FROM
                [t_cm5i]
              WHERE
                [cm5ib11k]=(
                  SELECT
                    [it10i110]
                  FROM
                    [t_it10]
                  WHERE
                    [_KEY]={}
                )
            )
          WHERE 
            [it30b11k]="{}" AND
            [it30t110]="220"
        `.f(
          _d_vals.it10_key,
          _d_vals.it10_key,
        )),
        // 注文情報 延長料金
        _d_vals => bf.q(`
          UPDATE 
            [t_it30] 
          SET 
            [it30i230]=([it30i210]::NUMERIC::INTEGER * [it30i220]::NUMERIC::INTEGER)::TEXT
          WHERE 
            [it30b11k]="{}" AND
            [it30t110]="220"
        `.f(
          _d_vals.it10_key,
        )),
*/
        // 顧客情報 注文料金
        _d_vals => bf.q(`
          UPDATE 
            [t_it10] 
          SET 
            [it10i620]=(
              SELECT 
                IFNULL(SUM((
                  SELECT CASE 
                    WHEN 
                      [it30i230] IS NULL OR 
                      [it30i230]="" OR 
                      [it30i230]="None" 
                    THEN 
                      "0" 
                    ELSE 
                      [it30i230] 
                    END
                )::NUMERIC::INTEGER),0)::TEXT
              FROM 
                [t_it30] 
              WHERE 
                [it30b11k]=[t_it10].[_KEY]::TEXT
            )
          WHERE 
            [_KEY]={}
        `.f(
          _d_vals.it10_key,
        )),
        // 顧客情報 総コース料金の更新
        _d_vals => bf.q(`
          UPDATE 
            [t_it10] 
          SET 
            [it10i640]=(
              IFNULL([it10i610],"0")::NUMERIC::INTEGER+IFNULL([it10i620],"0")::NUMERIC::INTEGER
            )::TEXT
          WHERE 
            [t_it10].[_KEY]={}
        `.f(
          _d_vals.it10_key,
        )),
        // 顧客情報 チャージ料金
/*
        _d_vals => bf.q(`
          UPDATE 
            [t_it10] 
          SET 
            [it10ia10]=trunc(
              [it10i640]::NUMERIC::INTEGER * (SELECT [cm2ii310]::NUMERIC::REAL / 100.0 FROM [t_cm2i] WHERE [cm2ib11k]=[it10b11k])
            )::TEXT
          WHERE 
            [t_it10].[_KEY]={}
        `.f(
          _d_vals.it10_key,
        )),
        _d_vals => bf.q(`
          UPDATE 
            [t_it10] 
          SET 
            [it10ia10]=TRUNC(
              (
                SELECT CASE
                  WHEN
                    [it10i2a0]="10"
                  THEN
                    [it10i620]::NUMERIC::INTEGER
                  ELSE
                    [it10i640]::NUMERIC::INTEGER 
                  END
              ) * 
              (
                SELECT 
                  [cm2ii310]::NUMERIC::REAL / 100.0 
                FROM 
                  [t_cm2i] 
                WHERE 
                  [cm2ib11k]=[it10b11k]
              )
            )::TEXT
          WHERE 
            [t_it10].[_KEY]={}
        `.f(
          _d_vals.it10_key,
        )),
*/
        _d_vals => bf.q(`
          UPDATE 
            [t_it10] 
          SET 
            [it10ia10]=TRUNC(
              (
                [it10i640]::NUMERIC::INTEGER 
              ) * 
              (
                SELECT 
                  [cm2ii310]::NUMERIC::REAL / 100.0 
                FROM 
                  [t_cm2i] 
                WHERE 
                  [cm2ib11k]=[it10b11k]
              )
            )::TEXT
          WHERE 
            [t_it10].[_KEY]={}
        `.f(
          _d_vals.it10_key,
        )),
        // 顧客情報 消費税の更新
        _d_vals => bf.q(`
          UPDATE 
            [t_it10] 
          SET 
            [it10ia30]=trunc(
              ([it10i640]::NUMERIC::REAL + [it10ia10]::NUMERIC::REAL) * (SELECT [cm2ii320]::NUMERIC::REAL / 100 FROM [t_cm2i] WHERE [cm2ib11k]=[it10b11k])
            )::TEXT
          WHERE 
            [t_it10].[_KEY]={}
        `.f(
          _d_vals.it10_key,
        )),
        // ドリンクサービス　初期化
        _d_vals => bf.q(`
          UPDATE 
            [t_it30] 
          SET 
            [it30i210]=IFNULL(REPLACE([it30i210],"None","0"),"0"),
            [it30i220]=IFNULL(REPLACE([it30i220],"None","0"),"0"),
            [it30i310]=IFNULL(REPLACE([it30i310],"None","0"),"0"),
            [it30i320]=IFNULL(REPLACE([it30i320],"None","0"),"0"),
            [it30i330]=IFNULL(REPLACE([it30i330],"None","0"),"0"),
            [it30i340]=IFNULL(REPLACE([it30i340],"None","0"),"0")
          WHERE 
            [t_it30].[it30b11k]="{}"
        `.f(
            _d_vals.it10_key,
        )),
        // ドリンクサービス　前累計数量の更新
        _d_vals => bf.q(`
          UPDATE 
            [t_it30] 
          SET 
            [it30i310]=(
              SELECT 
                IFNULL(SUM([it30i220]::NUMERIC::INTEGER),0)::TEXT
              FROM 
                [t_it30] AS [A]
              WHERE 
                [A].[it30b11k]=[t_it30].[it30b11k] AND [A].[it30t110]=[t_it30].[it30t110] AND [A].[_KEY]<[t_it30].[_KEY]
            )::TEXT
          WHERE 
            [t_it30].[it30b11k]="{}"
        `.f(
            _d_vals.it10_key,
        )),
        // ドリンクサービス　全無料数量
        _d_vals => bf.q(`
          UPDATE 
            [t_it30] 
          SET 
            [it30i320]=(
              SELECT
                CASE
                  WHEN
                    [t_it30].[it30t110]="210"
                  THEN
                    (
                      SELECT
                        [it10i210]
                      FROM
                        [t_it10]
                      WHERE
                        [t_it10].[_KEY]=[t_it30].[it30b11k]::NUMERIC::INTEGER
                    )
                  ELSE
                    "0"
                END
            )::TEXT
          WHERE 
            [t_it30].[it30b11k]="{}"
        `.f(
            _d_vals.it10_key,
        )),
        // ドリンクサービス　当無料数量
        _d_vals => bf.q(`
          UPDATE 
            [t_it30] 
          SET 
            [it30i330]=(
              [t_it30].[it30i320]::NUMERIC::INTEGER-[t_it30].[it30i310]::NUMERIC::INTEGER 
            )::TEXT
          WHERE 
            [t_it30].[it30b11k]="{}"
        `.f(
            _d_vals.it10_key,
        )),
        _d_vals => bf.q(`
          UPDATE 
            [t_it30] 
          SET 
            [it30i330]="0"
          WHERE 
            [t_it30].[it30b11k]="{}" AND [t_it30].[it30i330]::NUMERIC::INTEGER<0
        `.f(
            _d_vals.it10_key,
        )),
        _d_vals => bf.q(`
          UPDATE 
            [t_it30] 
          SET 
            [it30i330]=[t_it30].[it30i220]
          WHERE 
            [t_it30].[it30b11k]="{}" AND [t_it30].[it30i330]::NUMERIC::INTEGER>[t_it30].[it30i220]::NUMERIC::INTEGER
        `.f(
            _d_vals.it10_key,
        )),
        // ドリンクサービス　当無料額
        _d_vals => bf.q(`
          UPDATE 
            [t_it30] 
          SET 
            [it30i340]=(
              [it30i330]::NUMERIC::INTEGER * [it30i210]::NUMERIC::INTEGER
            )::TEXT
          WHERE 
            [t_it30].[it30b11k]="{}"
        `.f(
            _d_vals.it10_key,
        )),
        // ドリンクサービス　割引対象額
        _d_vals => bf.q(`
          UPDATE 
            [t_it10] 
          SET 
            [it10ib10]=(
              SELECT
                IFNULL(SUM([it30i340]::NUMERIC::INTEGER),0)
              FROM
                [t_it30]
              WHERE
                [t_it30].[it30b11k]=[t_it10].[_KEY]::TEXT
            )::TEXT
          WHERE 
            [t_it10].[_KEY]={}
        `.f(
            _d_vals.it10_key,
        )),
        // ドリンクサービス　割引額（消費税考慮後）
/*
        _d_vals => bf.q(`
          UPDATE 
            [t_it10] 
          SET 
            [it10ib20]=TRUNC(
              [it10ib10]::NUMERIC::INTEGER * 
              (SELECT CASE 
                WHEN 
                  [t_it10].[it10i2a0]="10" 
                THEN 
                  1.0 
                ELSE 
                  (1.0 + [t_cm2i].[cm2ii310]::NUMERIC::REAL / 100) 
                END 
              FROM 
                [t_cm2i] 
              WHERE 
                [t_cm2i].[cm2ib11k]=[t_it10].[it10b11k]
              ) * 
              (SELECT CASE 
                WHEN 
                  [t_it10].[it10i2b0]="10" 
                THEN 
                  1.0 
                ELSE 
                  (1.0 + [t_cm2i].[cm2ii320]::NUMERIC::REAL / 100) 
                END 
              FROM 
                [t_cm2i] 
              WHERE 
                [t_cm2i].[cm2ib11k]=[t_it10].[it10b11k]
              ) 
            )::TEXT
          WHERE 
            [t_it10].[_KEY]={}
        `.f(
          _d_vals.it10_key,
        )),
*/
        _d_vals => bf.q(`
          UPDATE 
            [t_it10] 
          SET 
            [it10ib20]=TRUNC(
              [it10ib10]::NUMERIC::INTEGER * 
              (SELECT 
                (1.0 + [t_cm2i].[cm2ii310]::NUMERIC::REAL / 100.0) 
              FROM 
                [t_cm2i] 
              WHERE 
                [t_cm2i].[cm2ib11k]=[t_it10].[it10b11k]
              ) * 
              (SELECT CASE 
                WHEN 
                  [t_it10].[it10i2b0]="10" 
                THEN 
                  1.0 
                ELSE 
                  (1.0 + [t_cm2i].[cm2ii320]::NUMERIC::REAL / 100) 
                END 
              FROM 
                [t_cm2i] 
              WHERE 
                [t_cm2i].[cm2ib11k]=[t_it10].[it10b11k]
              ) 
            )::TEXT
          WHERE 
            [t_it10].[_KEY]={}
        `.f(
          _d_vals.it10_key,
        )),

        // it10ib30 顧客情報 サービス＃２割引対象額
        _d_vals => bf.q(`
          UPDATE 
            [t_it10] 
          SET 
            [it10ib30]=trunc(
              (SELECT CASE 
                WHEN 
                  [it10i220]="10" 
                THEN 
                  ([it10i330]::NUMERIC::INTEGER * (SELECT [cm2ii220]::NUMERIC::INTEGER FROM [t_cm2i] WHERE [cm2ib11k]=[it10b11k]) ) 
                ELSE 
                  0 
              END) 
            )::TEXT
          WHERE 
            [t_it10].[_KEY]={}
        `.f(
          _d_vals.it10_key,
        )),

        // it10ib40 顧客情報 サービス＃２割引額
/*
        _d_vals => bf.q(`
          UPDATE 
            [t_it10] 
          SET 
            [it10ib40]=trunc(
              [it10ib30]::NUMERIC::INTEGER *
              (SELECT CASE 
                WHEN 
                  [t_it10].[it10i2a0]="10" 
                THEN 
                  1.0 
                ELSE 
                  (1.0 + [t_cm2i].[cm2ii310]::NUMERIC::REAL / 100) 
                END 
              FROM 
                [t_cm2i] 
              WHERE 
                [t_cm2i].[cm2ib11k]=[t_it10].[it10b11k]
              ) * 
              (SELECT CASE 
                WHEN 
                  [t_it10].[it10i2b0]="10" 
                THEN 
                  1.0 
                ELSE 
                  (1.0 + [t_cm2i].[cm2ii320]::NUMERIC::REAL / 100) 
                END 
              FROM 
                [t_cm2i] 
              WHERE 
                [t_cm2i].[cm2ib11k]=[t_it10].[it10b11k]
              ) 
            )::TEXT
          WHERE 
            [t_it10].[_KEY]={}
        `.f(
          _d_vals.it10_key,
        )),
*/
        _d_vals => bf.q(`
          UPDATE 
            [t_it10] 
          SET 
            [it10ib40]=trunc(
              [it10ib30]::NUMERIC::INTEGER *
              (SELECT 
                (1.0 + [t_cm2i].[cm2ii310]::NUMERIC::REAL / 100.0) 
              FROM 
                [t_cm2i] 
              WHERE 
                [t_cm2i].[cm2ib11k]=[t_it10].[it10b11k]
              ) * 
              (SELECT CASE 
                WHEN 
                  [t_it10].[it10i2b0]="10" 
                THEN 
                  1.0 
                ELSE 
                  (1.0 + [t_cm2i].[cm2ii320]::NUMERIC::REAL / 100) 
                END 
              FROM 
                [t_cm2i] 
              WHERE 
                [t_cm2i].[cm2ib11k]=[t_it10].[it10b11k]
              ) 
            )::TEXT
          WHERE 
            [t_it10].[_KEY]={}
        `.f(
          _d_vals.it10_key,
        )),

        // it10ia40 顧客情報 その他割引額　ドリンクサービス・サービス＃２・チャージ料金・消費税
/*
        _d_vals => bf.q(`
          UPDATE 
            [t_it10] 
          SET 
            [it10ia40]=trunc(
              [it10ib20]::NUMERIC::INTEGER 
              + [it10ib40]::NUMERIC::INTEGER 
              + (SELECT CASE WHEN [it10i2a0]="10" THEN [it10ia10]::NUMERIC::INTEGER ELSE 0 END) 
              + (SELECT CASE WHEN [it10i2b0]="10" THEN [it10ia30]::NUMERIC::INTEGER ELSE 0 END) 
              - [it10ia50]::NUMERIC::INTEGER 
            )::TEXT
          WHERE 
            [t_it10].[_KEY]={}
        `.f(
          global.c?.state.sgcd_pageCmns?.it10_key,                        
        )),
        _d_vals => bf.q(`
          UPDATE 
            [t_it10] 
          SET 
            [it10ia40]=trunc(
              [it10ib20]::NUMERIC::INTEGER 
              + [it10ib40]::NUMERIC::INTEGER 
              + (SELECT CASE WHEN [it10i2b0]="10" THEN [it10ia30]::NUMERIC::INTEGER ELSE 0 END) 
              - [it10ia50]::NUMERIC::INTEGER 
            )::TEXT
          WHERE 
            [t_it10].[_KEY]={}
        `.f(
          global.c?.state.sgcd_pageCmns?.it10_key,                        
        )),
*/
        _d_vals => bf.q(`
          UPDATE 
            [t_it10] 
          SET 
            [it10ia40]=trunc(
              [it10ib20]::NUMERIC::INTEGER 
              + [it10ib40]::NUMERIC::INTEGER 
              + (
                  (
                    SELECT CASE 
                      WHEN [it10i2a0]="10" 
                      THEN (1 + ( SELECT [cm2ii310]::NUMERIC::REAL / 100.0 FROM [t_cm2i] WHERE [cm2ib11k]=[it10b11k])) 
                      ELSE 1 
                    END
                  ) * 
                  (
                    SELECT CASE 
                      WHEN [it10i2b0]="10" 
                      THEN (1 + ( SELECT [cm2ii320]::NUMERIC::REAL / 100.0 FROM [t_cm2i] WHERE [cm2ib11k]=[it10b11k])) 
                      ELSE 1 
                    END
                  )
                  - 1
                ) * [it10i610]::NUMERIC::INTEGER
              - [it10ia50]::NUMERIC::INTEGER 
            )::TEXT
          WHERE 
            [t_it10].[_KEY]={}
        `.f(
          global.c?.state.sgcd_pageCmns?.it10_key,                        
        )),
        // it10ia70 顧客情報 支払総額
        _d_vals => bf.q(`
          UPDATE 
            [t_it10] 
          SET 
            [it10ia70]=(
              ceil((
              [it10i640]::NUMERIC::REAL 
              + [it10ia10]::NUMERIC::REAL 
              + [it10ia30]::NUMERIC::REAL 
              - [it10ia40]::NUMERIC::REAL 
              ) / 100.0) * 100
            )::TEXT
          WHERE 
            [t_it10].[_KEY]={}
        `.f(
          _d_vals.it10_key,
        )),

      ],
    },

  };

/*
  static $ip_updIt10ia70 = () => new Promise( _o_end1 => { // 顧客情報 支払総額
    cf.myCB_call_iud({
      ctr: 'qrys', 
      elm: '--', 
      l_qrys: [

    ]})
    .then(() => {
//      ip.$ip_upd_it10d120() //サービス終了時刻
//      .then(() => {
        _o_end1();
//      });
    });
  });
*/

/*
  static $ip_updIt10ia70 = () => new Promise( _o_end1 => { // 顧客情報 総コース料金の更新
    cf.myCB_call_iud({
      ctr: 'qrys', 
      elm: '--', 
      l_qrys: [
      // 1. 顧客情報 基本料金の更新
      bf.q(`
        UPDATE 
          [t_it10] 
        SET 
          [it10i610]=(
            (
              SELECT 
                IFNULL([cm50i110],"0")::NUMERIC::INTEGER 
              FROM 
                [t_cm50] 
              WHERE 
                [t_cm50].[_KEY]=[it10i110]::NUMERIC::INTEGER
            ) * IFNULL([it10i330],"0")::NUMERIC::INTEGER
          )::TEXT
        WHERE [_KEY]={}
      `.f(
        global.c?.state.sgcd_pageCmns?.it10_key,               
      )),
      // 1. 顧客情報 注文料金の更新
      bf.q(`
        UPDATE 
          [t_it10] 
        SET 
          [it10i620]=(
            SELECT 
              IFNULL(SUM((SELECT CASE WHEN [it30i230] IS NULL OR [it30i230]="" OR [it30i230]="None" THEN "0" ELSE [it30i230] END)::NUMERIC::INTEGER),0)::TEXT
            FROM 
              [t_it30] 
            WHERE 
              [it30b11k]=[t_it10].[_KEY]::TEXT
          )
        WHERE [_KEY]={}
      `.f(
        global.c?.state.sgcd_pageCmns?.it10_key,               
      )),
      // 1. 顧客情報 総コース料金の更新
      bf.q(`
        UPDATE 
          [t_it10] 
        SET 
          [it10i640]=(
            IFNULL([it10i610],"0")::NUMERIC::INTEGER+IFNULL([it10i620],"0")::NUMERIC::INTEGER
          )::TEXT
        WHERE 
          [t_it10].[_KEY]={}
      `.f(
        global.c?.state.sgcd_pageCmns?.it10_key,                        
      )),
      // 1. 顧客情報 チャージ料金の更新
      bf.q(`
        UPDATE 
          [t_it10] 
        SET 
          [it10ia10]=trunc(
            [it10i640]::NUMERIC::INTEGER * (SELECT [cm2ii310]::NUMERIC::REAL / 100.0 FROM [t_cm2i] WHERE [cm2ib11k]=[it10b11k])
          )::TEXT
        WHERE 
          [t_it10].[_KEY]={}
      `.f(
        global.c?.state.sgcd_pageCmns?.it10_key,                        
      )),
      // 1. 顧客情報 消費税の更新
      bf.q(`
        UPDATE 
          [t_it10] 
        SET 
          [it10ia30]=trunc(
            ([it10i640]::NUMERIC::REAL + [it10ia10]::NUMERIC::REAL) * (SELECT [cm2ii320]::NUMERIC::REAL / 100 FROM [t_cm2i] WHERE [cm2ib11k]=[it10b11k])
          )::TEXT
        WHERE 
          [t_it10].[_KEY]={}
      `.f(
        global.c?.state.sgcd_pageCmns?.it10_key,                        
      )),
      // ドリンクサービス　初期化
      bf.q(`
        UPDATE 
          [t_it30] 
        SET 
          [it30i210]=IFNULL(REPLACE([it30i210],"None","0"),"0"),
          [it30i220]=IFNULL(REPLACE([it30i220],"None","0"),"0"),
          [it30i310]=IFNULL(REPLACE([it30i310],"None","0"),"0"),
          [it30i320]=IFNULL(REPLACE([it30i320],"None","0"),"0"),
          [it30i330]=IFNULL(REPLACE([it30i330],"None","0"),"0"),
          [it30i340]=IFNULL(REPLACE([it30i340],"None","0"),"0")
        WHERE 
          [t_it30].[it30b11k]="{}"
      `.f(
        global.c?.state.sgcd_pageCmns?.it10_key,
      )),
      // ドリンクサービス　前累計数量の更新
      bf.q(`
        UPDATE 
          [t_it30] 
        SET 
          [it30i310]=(
            SELECT 
              IFNULL(SUM([it30i220]::NUMERIC::INTEGER),0)::TEXT
            FROM 
              [t_it30] AS [A]
            WHERE 
              [A].[it30b11k]=[t_it30].[it30b11k] AND [A].[it30t110]=[t_it30].[it30t110] AND [A].[_KEY]<[t_it30].[_KEY]
          )::TEXT
        WHERE 
          [t_it30].[it30b11k]="{}"
      `.f(
        global.c?.state.sgcd_pageCmns?.it10_key,
      )),
      // ドリンクサービス　全無料数量
      bf.q(`
        UPDATE 
          [t_it30] 
        SET 
          [it30i320]=(
            SELECT
              CASE
                WHEN
                  [t_it30].[it30t110]="210"
                THEN
                  (
                    SELECT
                      [it10i210]
                    FROM
                      [t_it10]
                    WHERE
                      [t_it10].[_KEY]=[t_it30].[it30b11k]::NUMERIC::INTEGER
                  )
                ELSE
                  "0"
              END
          )::TEXT
        WHERE 
          [t_it30].[it30b11k]="{}"
      `.f(
        global.c?.state.sgcd_pageCmns?.it10_key,
      )),
      // ドリンクサービス　当無料数量
      bf.q(`
        UPDATE 
          [t_it30] 
        SET 
          [it30i330]=(
            [t_it30].[it30i320]::NUMERIC::INTEGER-[t_it30].[it30i310]::NUMERIC::INTEGER 
          )::TEXT
        WHERE 
          [t_it30].[it30b11k]="{}"
      `.f(
        global.c?.state.sgcd_pageCmns?.it10_key,
      )),
      bf.q(`
        UPDATE 
          [t_it30] 
        SET 
          [it30i330]="0"
        WHERE 
          [t_it30].[it30b11k]="{}" AND [t_it30].[it30i330]::NUMERIC::INTEGER<0
      `.f(
        global.c?.state.sgcd_pageCmns?.it10_key,
      )),
      bf.q(`
        UPDATE 
          [t_it30] 
        SET 
          [it30i330]=[t_it30].[it30i220]
        WHERE 
          [t_it30].[it30b11k]="{}" AND [t_it30].[it30i330]::NUMERIC::INTEGER>[t_it30].[it30i220]::NUMERIC::INTEGER
      `.f(
        global.c?.state.sgcd_pageCmns?.it10_key,
      )),
      // ドリンクサービス　当無料額
      bf.q(`
        UPDATE 
          [t_it30] 
        SET 
          [it30i340]=(
            [it30i330]::NUMERIC::INTEGER * [it30i210]::NUMERIC::INTEGER
          )::TEXT
        WHERE 
          [t_it30].[it30b11k]="{}"
      `.f(
        global.c?.state.sgcd_pageCmns?.it10_key,
      )),
      // ドリンクサービス　割引対象額
      bf.q(`
        UPDATE 
          [t_it10] 
        SET 
          [it10ib10]=(
            SELECT
              IFNULL(SUM([it30i340]::NUMERIC::INTEGER),0)
            FROM
              [t_it30]
            WHERE
              [t_it30].[it30b11k]=[t_it10].[_KEY]::TEXT
          )::TEXT
        WHERE 
          [t_it10].[_KEY]={}
      `.f(
        global.c?.state.sgcd_pageCmns?.it10_key,
      )),
      // ドリンクサービス　割引額（消費税考慮後）
      bf.q(`
        UPDATE 
          [t_it10] 
        SET 
          [it10ib20]=trunc(
            [it10ib10]::NUMERIC::INTEGER * 
            (SELECT CASE 
              WHEN 
                [t_it10].[it10i2a0]="10" 
              THEN 
                1.0 
              ELSE 
                (1.0 + [t_cm2i].[cm2ii310]::NUMERIC::REAL / 100) 
              END 
            FROM 
              [t_cm2i] 
            WHERE 
              [t_cm2i].[cm2ib11k]=[t_it10].[it10b11k]
            ) * 
            (SELECT CASE 
              WHEN 
                [t_it10].[it10i2b0]="10" 
              THEN 
                1.0 
              ELSE 
                (1.0 + [t_cm2i].[cm2ii320]::NUMERIC::REAL / 100) 
              END 
            FROM 
              [t_cm2i] 
            WHERE 
              [t_cm2i].[cm2ib11k]=[t_it10].[it10b11k]
            ) 
          )::TEXT
        WHERE 
          [t_it10].[_KEY]={}
      `.f(
        global.c?.state.sgcd_pageCmns?.it10_key,
      )),
      // 1. 顧客情報 サービス＃２割引対象額
      bf.q(`
        UPDATE 
          [t_it10] 
        SET 
          [it10ib30]=trunc(
            (SELECT CASE 
              WHEN 
                [it10i220]="10" 
              THEN 
                ([it10i330]::NUMERIC::INTEGER * (SELECT [cm2ii220]::NUMERIC::INTEGER FROM [t_cm2i] WHERE [cm2ib11k]=[it10b11k]) ) 
              ELSE 
                0 
            END) 
          )::TEXT
        WHERE 
          [t_it10].[_KEY]={}
      `.f(
        global.c?.state.sgcd_pageCmns?.it10_key,                        
      )),
      // 1. 顧客情報 サービス＃２割引額
      bf.q(`
        UPDATE 
          [t_it10] 
        SET 
          [it10ib40]=trunc(
            [it10ib30]::NUMERIC::INTEGER *
            (SELECT CASE 
              WHEN 
                [t_it10].[it10i2a0]="10" 
              THEN 
                1.0 
              ELSE 
                (1.0 + [t_cm2i].[cm2ii310]::NUMERIC::REAL / 100) 
              END 
            FROM 
              [t_cm2i] 
            WHERE 
              [t_cm2i].[cm2ib11k]=[t_it10].[it10b11k]
            ) * 
            (SELECT CASE 
              WHEN 
                [t_it10].[it10i2b0]="10" 
              THEN 
                1.0 
              ELSE 
                (1.0 + [t_cm2i].[cm2ii320]::NUMERIC::REAL / 100) 
              END 
            FROM 
              [t_cm2i] 
            WHERE 
              [t_cm2i].[cm2ib11k]=[t_it10].[it10b11k]
            ) 
          )::TEXT
        WHERE 
          [t_it10].[_KEY]={}
      `.f(
        global.c?.state.sgcd_pageCmns?.it10_key,                        
      )),
      // 1. 顧客情報 割引総額　ドリンクサービス・サービス＃２・チャージ料金・消費税
      bf.q(`
        UPDATE 
          [t_it10] 
        SET 
          [it10ia40]=trunc(
            [it10ib20]::NUMERIC::INTEGER 
            + [it10ib40]::NUMERIC::INTEGER 
            + (SELECT CASE WHEN [it10i2a0]="10" THEN [it10ia10]::NUMERIC::INTEGER ELSE 0 END) 
            + (SELECT CASE WHEN [it10i2b0]="10" THEN [it10ia30]::NUMERIC::INTEGER ELSE 0 END) 
            - [it10ia50]::NUMERIC::INTEGER 
          )::TEXT
        WHERE 
          [t_it10].[_KEY]={}
      `.f(
        global.c?.state.sgcd_pageCmns?.it10_key,                        
      )),
      // 1. 顧客情報 支払総額
      bf.q(`
        UPDATE 
          [t_it10] 
        SET 
          [it10ia70]=(
            ceil((
            [it10i640]::NUMERIC::REAL 
            + [it10ia10]::NUMERIC::REAL 
            + [it10ia30]::NUMERIC::REAL 
            - [it10ia40]::NUMERIC::REAL 
            ) / 100.0) * 100
          )::TEXT
        WHERE 
          [t_it10].[_KEY]={}
      `.f(
        global.c?.state.sgcd_pageCmns?.it10_key,                        
      )),
      // 2. 日別情報 売上の更新
      bf.q(`
        UPDATE 
          [t_it50] 
        SET 
          [it50i210]=(
            SELECT 
              SUM(IFNULL([it10ia70],"0")::NUMERIC::INTEGER)::TEXT
            FROM 
              [t_it10] 
            WHERE 
              [it10b31k]=[t_it50].[_KEY]::TEXT
          )
        WHERE 
          [t_it50].[_KEY]=(
            SELECT [it10b31k]::NUMERIC::INTEGER FROM [t_it10] WHERE [_KEY]={}
          )
      `.f(
        global.c?.state.sgcd_pageCmns?.it10_key,                        
      )),
      // 2. 日別情報 差額の更新
      bf.q(`
        UPDATE 
          [t_it50] 
        SET 
          [it50i120]=(
            IFNULL([it50i210],"0")::NUMERIC::INTEGER - IFNULL([it50i110],"0")::NUMERIC::INTEGER
          )::TEXT
        WHERE 
          [t_it50].[_KEY]=(
            SELECT [it10b31k]::NUMERIC::INTEGER FROM [t_it10] WHERE [_KEY]={}
          )
      `.f(
        global.c?.state.sgcd_pageCmns?.it10_key,                        
      )),
      // 2-1. 日別情報 客単価
      bf.q(`
        UPDATE 
          [t_it50] 
        SET 
          [it50i820]=(
            SELECT CASE
              WHEN
                REPLACE(IFNULL([it50i810],"0"),"None","0")::NUMERIC::INTEGER = 0
              THEN
                0
              ELSE
                REPLACE(IFNULL([it50i210],"0"),"None","0")::NUMERIC::INTEGER / REPLACE(IFNULL([it50i810],"0"),"None","0")::NUMERIC::INTEGER
              END
          )::TEXT
        WHERE 
          [t_it50].[_KEY]=(
            SELECT [it10b31k]::NUMERIC::INTEGER FROM [t_it10] WHERE [_KEY]={}
          )
      `.f(
        global.c?.state.sgcd_pageCmns?.it10_key,                        
      )),
      // 2-2. 日別情報 利益の更新
      bf.q(`
        UPDATE 
          [t_it50] 
        SET 
          [it50ic10]=(
            REPLACE(IFNULL([it50i210],"0"),"None","0")::NUMERIC::INTEGER
            - REPLACE(IFNULL([it50ib10],"0"),"None","0")::NUMERIC::INTEGER
          )::TEXT
        WHERE 
          [t_it50].[_KEY]=(
            SELECT [it10b31k]::NUMERIC::INTEGER FROM [t_it10] WHERE [_KEY]={}
          )
      `.f(
        global.c?.state.sgcd_pageCmns?.it10_key,                        
      )),
      // 3. 月別情報 総売り上げ
      bf.q(`
        UPDATE 
          [t_it60] 
        SET 
          [it60i210]=(
            SELECT 
              SUM(IFNULL([it50i210],"0")::NUMERIC::INTEGER)::TEXT
            FROM 
              [t_it50] 
            WHERE 
              [it50b21k]=[t_it60].[_KEY]::TEXT
          )::TEXT
        WHERE 
          [t_it60].[_KEY]=(
            SELECT [it50b21k]::NUMERIC::INTEGER FROM [t_it50] WHERE [t_it50].[_KEY]=(
              SELECT [it10b31k]::NUMERIC::INTEGER FROM [t_it10] WHERE [t_it10].[_KEY]={}
            )
          )
      `.f(
        global.c?.state.sgcd_pageCmns?.it10_key,               
      )),
      // 月別情報 平日売上
      bf.q(`
        UPDATE 
          [t_it60] 
        SET 
          [it60i420]=(
            SELECT 
              SUM(IFNULL([it50i210],"0")::NUMERIC::INTEGER)::TEXT
            FROM 
              [t_it50] 
            WHERE 
              [it50b21k]=[t_it60].[_KEY]::TEXT AND IFNULL([it50t110],"0")="10"
          )::TEXT
        WHERE 
          [t_it60].[_KEY]=(
            SELECT [it50b21k]::NUMERIC::INTEGER FROM [t_it50] WHERE [t_it50].[_KEY]=(
              SELECT [it10b31k]::NUMERIC::INTEGER FROM [t_it10] WHERE [t_it10].[_KEY]={}
            )
          )
      `.f(
        global.c?.state.sgcd_pageCmns?.it10_key,               
      )),
      // 月別情報 休日前売上
      bf.q(`
        UPDATE 
          [t_it60] 
        SET 
          [it60i430]=(
            SELECT 
              SUM(IFNULL([it50i210],"0")::NUMERIC::INTEGER)::TEXT
            FROM 
              [t_it50] 
            WHERE 
              [it50b21k]=[t_it60].[_KEY]::TEXT AND IFNULL([it50t110],"0")="20"
          )::TEXT
        WHERE 
          [t_it60].[_KEY]=(
            SELECT [it50b21k]::NUMERIC::INTEGER FROM [t_it50] WHERE [t_it50].[_KEY]=(
              SELECT [it10b31k]::NUMERIC::INTEGER FROM [t_it10] WHERE [t_it10].[_KEY]={}
            )
          )
      `.f(
        global.c?.state.sgcd_pageCmns?.it10_key,               
      )),
      // 月別情報 休日売上
      bf.q(`
        UPDATE 
          [t_it60] 
        SET 
          [it60i440]=(
            SELECT 
              SUM(IFNULL([it50i210],"0")::NUMERIC::INTEGER)::TEXT
            FROM 
              [t_it50] 
            WHERE 
              [it50b21k]=[t_it60].[_KEY]::TEXT AND IFNULL([it50t110],"0")="30"
          )::TEXT
        WHERE 
          [t_it60].[_KEY]=(
            SELECT [it50b21k]::NUMERIC::INTEGER FROM [t_it50] WHERE [t_it50].[_KEY]=(
              SELECT [it10b31k]::NUMERIC::INTEGER FROM [t_it10] WHERE [t_it10].[_KEY]={}
            )
          )
      `.f(
        global.c?.state.sgcd_pageCmns?.it10_key,               
      )),
      // 3. 月別情報 総利益
      bf.q(`
        UPDATE 
          [t_it60] 
        SET 
          [it60ib10]=(
            SELECT 
              SUM(IFNULL([it50ic10],"0")::NUMERIC::INTEGER)::TEXT
            FROM 
              [t_it50] 
            WHERE 
              [it50b21k]=[t_it60].[_KEY]::TEXT
          )::TEXT
        WHERE 
          [t_it60].[_KEY]=(
            SELECT [it50b21k]::NUMERIC::INTEGER FROM [t_it50] WHERE [t_it50].[_KEY]=(
              SELECT [it10b31k]::NUMERIC::INTEGER FROM [t_it10] WHERE [t_it10].[_KEY]={}
            )
          )
      `.f(
        global.c?.state.sgcd_pageCmns?.it10_key,               
      )),
      // 3. 月別情報 平日利益
      bf.q(`
        UPDATE 
          [t_it60] 
        SET 
          [it60ib20]=(
            SELECT 
              SUM(IFNULL([it50ic10],"0")::NUMERIC::INTEGER)::TEXT
            FROM 
              [t_it50] 
            WHERE 
              [it50b21k]=[t_it60].[_KEY]::TEXT AND IFNULL([it50t110],"0")="10"
          )::TEXT
        WHERE 
          [t_it60].[_KEY]=(
            SELECT [it50b21k]::NUMERIC::INTEGER FROM [t_it50] WHERE [t_it50].[_KEY]=(
              SELECT [it10b31k]::NUMERIC::INTEGER FROM [t_it10] WHERE [t_it10].[_KEY]={}
            )
          )
      `.f(
        global.c?.state.sgcd_pageCmns?.it10_key,               
      )),
      // 3. 月別情報 休日前利益
      bf.q(`
        UPDATE 
          [t_it60] 
        SET 
          [it60ib30]=(
            SELECT 
              SUM(IFNULL([it50ic10],"0")::NUMERIC::INTEGER)::TEXT
            FROM 
              [t_it50] 
            WHERE 
              [it50b21k]=[t_it60].[_KEY]::TEXT AND IFNULL([it50t110],"0")="20"
          )::TEXT
        WHERE 
          [t_it60].[_KEY]=(
            SELECT [it50b21k]::NUMERIC::INTEGER FROM [t_it50] WHERE [t_it50].[_KEY]=(
              SELECT [it10b31k]::NUMERIC::INTEGER FROM [t_it10] WHERE [t_it10].[_KEY]={}
            )
          )
      `.f(
        global.c?.state.sgcd_pageCmns?.it10_key,               
      )),
      // 3. 月別情報 休日利益
      bf.q(`
        UPDATE 
          [t_it60] 
        SET 
          [it60ib40]=(
            SELECT 
              SUM(IFNULL([it50ic10],"0")::NUMERIC::INTEGER)::TEXT
            FROM 
              [t_it50] 
            WHERE 
              [it50b21k]=[t_it60].[_KEY]::TEXT AND IFNULL([it50t110],"0")="30"
          )::TEXT
        WHERE 
          [t_it60].[_KEY]=(
            SELECT [it50b21k]::NUMERIC::INTEGER FROM [t_it50] WHERE [t_it50].[_KEY]=(
              SELECT [it10b31k]::NUMERIC::INTEGER FROM [t_it10] WHERE [t_it10].[_KEY]={}
            )
          )
      `.f(
        global.c?.state.sgcd_pageCmns?.it10_key,               
      )),
      // ４. 月別情報 客単価
      bf.q(`
        UPDATE 
          [t_it60] 
        SET 
          [it60i820]=(
            SELECT CASE
              WHEN
                REPLACE(IFNULL([it60i810],"0"),"None","0")::NUMERIC::INTEGER = 0
              THEN
                0
              ELSE
                REPLACE(IFNULL([it60i210],"0"),"None","0")::NUMERIC::INTEGER / REPLACE(IFNULL([it60i810],"0"),"None","0")::NUMERIC::INTEGER
              END
          )::TEXT
        WHERE 
          [t_it60].[_KEY]=(
            SELECT [it50b21k]::NUMERIC::INTEGER FROM [t_it50] WHERE [t_it50].[_KEY]=(
              SELECT [it10b31k]::NUMERIC::INTEGER FROM [t_it10] WHERE [t_it10].[_KEY]={}
            )
          )
      `.f(
        global.c?.state.sgcd_pageCmns?.it10_key,                        
      )),
      // 4. 月別情報 総経過日数
      bf.q(`
        UPDATE 
          [t_it60] 
        SET 
          [it60i310]=(
            SELECT 
              IFNULL(COUNT(*),0)
            FROM 
              [t_it50] 
            WHERE 
              [it50b21k]=[t_it60].[_KEY]::TEXT AND IFNULL([it50s110],"0") IN ("10", "20") AND IFNULL([it50t110],"0")<>"0"
          )::TEXT
        WHERE 
          [t_it60].[_KEY]=(
            SELECT [it50b21k]::NUMERIC::INTEGER FROM [t_it50] WHERE [t_it50].[_KEY]=(
              SELECT [it10b31k]::NUMERIC::INTEGER FROM [t_it10] WHERE [t_it10].[_KEY]={}
            )
          )
      `.f(
        global.c?.state.sgcd_pageCmns?.it10_key,               
      )),
      // 4. 月別情報 平日経過日数
      bf.q(`
        UPDATE 
          [t_it60] 
        SET 
          [it60i320]=(
            SELECT 
              IFNULL(COUNT(*),0)
            FROM 
              [t_it50] 
            WHERE 
              [it50b21k]=[t_it60].[_KEY]::TEXT AND IFNULL([it50s110],"0") IN ("10", "20") AND IFNULL([it50t110],"0")="10"
          )::TEXT
        WHERE 
          [t_it60].[_KEY]=(
            SELECT [it50b21k]::NUMERIC::INTEGER FROM [t_it50] WHERE [t_it50].[_KEY]=(
              SELECT [it10b31k]::NUMERIC::INTEGER FROM [t_it10] WHERE [t_it10].[_KEY]={}
            )
          )
      `.f(
        global.c?.state.sgcd_pageCmns?.it10_key,               
      )),
      // 4. 月別情報 休日前経過日数
      bf.q(`
        UPDATE 
          [t_it60] 
        SET 
          [it60i330]=(
            SELECT 
              IFNULL(COUNT(*),0)
            FROM 
              [t_it50] 
            WHERE 
              [it50b21k]=[t_it60].[_KEY]::TEXT AND IFNULL([it50s110],"0") IN ("10", "20") AND IFNULL([it50t110],"0")="20"
          )::TEXT
        WHERE 
          [t_it60].[_KEY]=(
            SELECT [it50b21k]::NUMERIC::INTEGER FROM [t_it50] WHERE [t_it50].[_KEY]=(
              SELECT [it10b31k]::NUMERIC::INTEGER FROM [t_it10] WHERE [t_it10].[_KEY]={}
            )
          )
      `.f(
        global.c?.state.sgcd_pageCmns?.it10_key,               
      )),
      // 4. 月別情報 休日経過日数
      bf.q(`
        UPDATE 
          [t_it60] 
        SET 
          [it60i340]=(
            SELECT 
              IFNULL(COUNT(*),0)
            FROM 
              [t_it50] 
            WHERE 
              [it50b21k]=[t_it60].[_KEY]::TEXT AND IFNULL([it50s110],"0") IN ("10", "20") AND IFNULL([it50t110],"0")="30"
          )::TEXT
        WHERE 
          [t_it60].[_KEY]=(
            SELECT [it50b21k]::NUMERIC::INTEGER FROM [t_it50] WHERE [t_it50].[_KEY]=(
              SELECT [it10b31k]::NUMERIC::INTEGER FROM [t_it10] WHERE [t_it10].[_KEY]={}
            )
          )
      `.f(
        global.c?.state.sgcd_pageCmns?.it10_key,               
      )),
      // 5. 月別情報 平均総売上
      bf.q(`
        UPDATE 
          [t_it60] 
        SET 
          [it60i410]=(
            SELECT CASE
              WHEN
                REPLACE(IFNULL([it60i310],"0"),"None","0")::NUMERIC::INTEGER = 0
              THEN
                0
              ELSE
                REPLACE(IFNULL([it60i210],"0"),"None","0")::NUMERIC::INTEGER / REPLACE(IFNULL([it60i310],"0"),"None","0")::NUMERIC::INTEGER
              END
          )::TEXT
        WHERE 
          [t_it60].[_KEY]=(
            SELECT [it50b21k]::NUMERIC::INTEGER FROM [t_it50] WHERE [t_it50].[_KEY]=(
              SELECT [it10b31k]::NUMERIC::INTEGER FROM [t_it10] WHERE [t_it10].[_KEY]={}
            )
          )
      `.f(
        global.c?.state.sgcd_pageCmns?.it10_key,               
      )),
      // 月別情報 平均平日売上
      bf.q(`
        UPDATE 
          [t_it60] 
        SET 
          [it60i450]=(
            SELECT CASE
              WHEN
                REPLACE(IFNULL([it60i320],"0"),"None","0")::NUMERIC::INTEGER = 0
              THEN
                0
              ELSE
                REPLACE(IFNULL([it60i420],"0"),"None","0")::NUMERIC::INTEGER / REPLACE(IFNULL([it60i320],"0"),"None","0")::NUMERIC::INTEGER
              END
          )::TEXT
        WHERE 
          [t_it60].[_KEY]=(
            SELECT [it50b21k]::NUMERIC::INTEGER FROM [t_it50] WHERE [t_it50].[_KEY]=(
              SELECT [it10b31k]::NUMERIC::INTEGER FROM [t_it10] WHERE [t_it10].[_KEY]={}
            )
          )
      `.f(
        global.c?.state.sgcd_pageCmns?.it10_key,               
      )),
      // 月別情報 平均休日前売上
      bf.q(`
        UPDATE 
          [t_it60] 
        SET 
          [it60i460]=(
            SELECT CASE
              WHEN
                REPLACE(IFNULL([it60i330],"0"),"None","0")::NUMERIC::INTEGER = 0
              THEN
                0
              ELSE
                REPLACE(IFNULL([it60i430],"0"),"None","0")::NUMERIC::INTEGER / REPLACE(IFNULL([it60i330],"0"),"None","0")::NUMERIC::INTEGER
              END
          )::TEXT
        WHERE 
          [t_it60].[_KEY]=(
            SELECT [it50b21k]::NUMERIC::INTEGER FROM [t_it50] WHERE [t_it50].[_KEY]=(
              SELECT [it10b31k]::NUMERIC::INTEGER FROM [t_it10] WHERE [t_it10].[_KEY]={}
            )
          )
      `.f(
        global.c?.state.sgcd_pageCmns?.it10_key,               
      )),
      // 月別情報 平均休日売上
      bf.q(`
        UPDATE 
          [t_it60] 
        SET 
          [it60i470]=(
            SELECT CASE
              WHEN
                REPLACE(IFNULL([it60i340],"0"),"None","0")::NUMERIC::INTEGER = 0
              THEN
                0
              ELSE
                REPLACE(IFNULL([it60i440],"0"),"None","0")::NUMERIC::INTEGER / REPLACE(IFNULL([it60i340],"0"),"None","0")::NUMERIC::INTEGER
              END
          )::TEXT
        WHERE 
          [t_it60].[_KEY]=(
            SELECT [it50b21k]::NUMERIC::INTEGER FROM [t_it50] WHERE [t_it50].[_KEY]=(
              SELECT [it10b31k]::NUMERIC::INTEGER FROM [t_it10] WHERE [t_it10].[_KEY]={}
            )
          )
      `.f(
        global.c?.state.sgcd_pageCmns?.it10_key,               
      )),
      // 5. 月別情報 平均総利益
      bf.q(`
        UPDATE 
          [t_it60] 
        SET 
          [it60ic10]=(
            SELECT CASE
              WHEN
                REPLACE(IFNULL([it60i310],"0"),"None","0")::NUMERIC::INTEGER = 0
              THEN
                0
              ELSE
                REPLACE(IFNULL([it60ib10],"0"),"None","0")::NUMERIC::INTEGER / REPLACE(IFNULL([it60i310],"0"),"None","0")::NUMERIC::INTEGER
              END
          )::TEXT
        WHERE 
          [t_it60].[_KEY]=(
            SELECT [it50b21k]::NUMERIC::INTEGER FROM [t_it50] WHERE [t_it50].[_KEY]=(
              SELECT [it10b31k]::NUMERIC::INTEGER FROM [t_it10] WHERE [t_it10].[_KEY]={}
            )
          )
      `.f(
        global.c?.state.sgcd_pageCmns?.it10_key,               
      )),
      // 5. 月別情報 平均平日利益
      bf.q(`
        UPDATE 
          [t_it60] 
        SET 
          [it60ic20]=(
            SELECT CASE
              WHEN
                REPLACE(IFNULL([it60i320],"0"),"None","0")::NUMERIC::INTEGER = 0
              THEN
                0
              ELSE
                REPLACE(IFNULL([it60ib20],"0"),"None","0")::NUMERIC::INTEGER / REPLACE(IFNULL([it60i320],"0"),"None","0")::NUMERIC::INTEGER
              END
          )::TEXT
        WHERE 
          [t_it60].[_KEY]=(
            SELECT [it50b21k]::NUMERIC::INTEGER FROM [t_it50] WHERE [t_it50].[_KEY]=(
              SELECT [it10b31k]::NUMERIC::INTEGER FROM [t_it10] WHERE [t_it10].[_KEY]={}
            )
          )
      `.f(
        global.c?.state.sgcd_pageCmns?.it10_key,               
      )),
      // 5. 月別情報 平均休日前利益
      bf.q(`
        UPDATE 
          [t_it60] 
        SET 
          [it60ic30]=(
            SELECT CASE
              WHEN
                REPLACE(IFNULL([it60i330],"0"),"None","0")::NUMERIC::INTEGER = 0
              THEN
                0
              ELSE
                REPLACE(IFNULL([it60ib30],"0"),"None","0")::NUMERIC::INTEGER / REPLACE(IFNULL([it60i330],"0"),"None","0")::NUMERIC::INTEGER
              END
          )::TEXT
        WHERE 
          [t_it60].[_KEY]=(
            SELECT [it50b21k]::NUMERIC::INTEGER FROM [t_it50] WHERE [t_it50].[_KEY]=(
              SELECT [it10b31k]::NUMERIC::INTEGER FROM [t_it10] WHERE [t_it10].[_KEY]={}
            )
          )
      `.f(
        global.c?.state.sgcd_pageCmns?.it10_key,               
      )),
      // 5. 月別情報 平均休日利益
      bf.q(`
        UPDATE 
          [t_it60] 
        SET 
          [it60ic40]=(
            SELECT CASE
              WHEN
                REPLACE(IFNULL([it60i340],"0"),"None","0")::NUMERIC::INTEGER = 0
              THEN
                0
              ELSE
                REPLACE(IFNULL([it60ib40],"0"),"None","0")::NUMERIC::INTEGER / REPLACE(IFNULL([it60i340],"0"),"None","0")::NUMERIC::INTEGER
              END
          )::TEXT
        WHERE 
          [t_it60].[_KEY]=(
            SELECT [it50b21k]::NUMERIC::INTEGER FROM [t_it50] WHERE [t_it50].[_KEY]=(
              SELECT [it10b31k]::NUMERIC::INTEGER FROM [t_it10] WHERE [t_it10].[_KEY]={}
            )
          )
      `.f(
        global.c?.state.sgcd_pageCmns?.it10_key,               
      )),
      // 7. 月別情報 売上予測
      bf.q(`
        UPDATE 
          [t_it60] 
        SET 
          [it60i610]=(
            REPLACE(IFNULL([it60i410],"0"),"None","0")::NUMERIC::INTEGER * REPLACE(IFNULL([it60i510],"0"),"None","0")::NUMERIC::INTEGER
          )::TEXT
        WHERE 
          [t_it60].[_KEY]=(
            SELECT [it50b21k]::NUMERIC::INTEGER FROM [t_it50] WHERE [t_it50].[_KEY]=(
              SELECT [it10b31k]::NUMERIC::INTEGER FROM [t_it10] WHERE [t_it10].[_KEY]={}
            )
          )
      `.f(
        global.c?.state.sgcd_pageCmns?.it10_key,               
      )),
      // 8. 月別情報 売上目標との差
      bf.q(`
        UPDATE 
          [t_it60] 
        SET 
          [it60i710]=(
            REPLACE(IFNULL([it60i610],"0"),"None","0")::NUMERIC::INTEGER - REPLACE(IFNULL([it60i110],"0"),"None","0")::NUMERIC::INTEGER
          )::TEXT
        WHERE 
          [t_it60].[_KEY]=(
            SELECT [it50b21k]::NUMERIC::INTEGER FROM [t_it50] WHERE [t_it50].[_KEY]=(
              SELECT [it10b31k]::NUMERIC::INTEGER FROM [t_it10] WHERE [t_it10].[_KEY]={}
            )
          )
      `.f(
        global.c?.state.sgcd_pageCmns?.it10_key,               
      )),
      // 5. 月別情報 利益予測
      bf.q(`
        UPDATE 
          [t_it60] 
        SET 
          [it60id10]=(
            REPLACE(IFNULL([it60ic10],"0"),"None","0")::NUMERIC::INTEGER * REPLACE(IFNULL([it60i510],"0"),"None","0")::NUMERIC::INTEGER
          )::TEXT
        WHERE 
          [t_it60].[_KEY]=(
            SELECT [it50b21k]::NUMERIC::INTEGER FROM [t_it50] WHERE [t_it50].[_KEY]=(
              SELECT [it10b31k]::NUMERIC::INTEGER FROM [t_it10] WHERE [t_it10].[_KEY]={}
            )
          )
      `.f(
        global.c?.state.sgcd_pageCmns?.it10_key,               
      )),
    ]})
    .then(() => {
//      _o_end1();
      ip.$ip_upd_it10d120() //サービス終了時刻
      .then(() => {
        _o_end1();
      });
    });
  });
*/


  static $ip_load_it11 = (pd={ // 外販担当者情報
    mode: '',
    state: 'sld_it11ss',
    ld_sortss: [],
  }) => new Promise( _o_end1 => { // 外販担当者情報

    let _cnd = ''
    
    if (bf.f(pd.cnd)) {
      _cnd = pd.cnd;    
    }
    else if (bf.f(pd.it10_key)) {
      _cnd = bf.q('[it11b11k]="{}"'.f(
        pd.it10_key,
      ));
    }

    if (pd.mode == 'clds') {
      if ( pd.b_clr == true ) {
        global.c?.setState({
          [pd.state]: [],
        }, () => {
          _o_end1();
        })
      }
      else {
        cf.myCB_set_clds({
          ctr: 'nlm', 
          elm: 'it11', 
          n_dms: 3, 
          state: pd.state, 
          cnd: _cnd,
          b_withCnd: true,
          ld_sortss: pd.ld_sortss,
        })
        .then( () => {
//bf.l('2898:{}, {}'.f(_cnd, global.c?.state[pd.state][0].it11b21k))
          _o_end1();
        });
      }
    };

  });

  static $ip_ups_it11 = () => new Promise( async _o_end1 => { // 外販担当者の更新
    for await (let [_idx, _d_it11s] of bf.e(global.c?.state.sld_it11ss)) {
      if (_d_it11s.b_dlt != true) { // 登録する場合
        let _d_vals = {
          it11b11k: global.c?.state.sgcd_pageCmns?.it10_key,
          it11b21k: _d_it11s.it11b21k,
        };
        let _cnd = bf.q('[it11b11k]="{}" AND [it11b21k]="{}"'.f(
          global.c?.state.sgcd_pageCmns?.it10_key,
          _d_it11s.it11b21k,
        ));
        cf.myCB_call_iud({
          ctr: 'ups', 
          elm: 'it11', 
          d_vals: _d_vals, 
          cnd: _cnd
        })
      }
      else { // 削除する場合
        let _qry = bf.q('DELETE FROM [t_it11] WHERE [it11b11k]="{}" AND [it11b21k]="{}"'.f(
          global.c?.state.sgcd_pageCmns?.it10_key,
          _d_it11s.it11b21k,
        ));
        cf.myCB_call_iud({
          ctr: 'qry', 
          elm: 'it11', 
          qry: _qry
        })
      };
    };
    _o_end1();
  });

  static $ip_load_it20 = (pd={ // 入席情報
    b_clr: false,
    mode: '',
    it20_key: '',
    it10_key: '',
    cm10_key: '',
  }) => new Promise( _o_end1 => {
    //
    let _cnd = '';
    if (pd.cnd) {
      _cnd = pd.cnd;
    }
    else {
      if (bf.f(pd.it20_key)) { // 入席情報が指定されている場合
        _cnd = bf.q('[_KEY]={}'.f(
          pd.it20_key,
        ));
      }
      else if (bf.f(pd.it10_key) && bf.f(pd.cm10_key)) { // 顧客情報とキャスト情報が指定されている場合
        _cnd = bf.q('[it20b11k]="{}" AND [it20b21k]="{}"'.f(
          pd.it10_key,
          pd.cm10_key,
        ));
      }
      else if (!bf.f(pd.it10_key) && bf.f(pd.cm10_key)) { // キャスト情報が指定されている場合
        _cnd = bf.q(`[it20b21k]="{}"`.f(
          pd.cm10_key,
        ));
      };
    };

    if (pd.mode == 'get') {
      if (pd.b_clr == true) {
        _o_end1(null);
      }
      else {
        cf.myCB_call_slc({
          ctr: 'nlm', 
          elm: 'it20', 
          n_dms: 2, 
          cnd: _cnd
        })
        .then( _d_it20s => {
          _o_end1(_d_it20s);
        });
      };
    }
    else if (pd.mode == 'set') {
      new Promise( _o_end2 => {
        if (pd.b_clr == true) {
          _o_end2(null);
        }
        else {
          cf.myCB_call_slc({
            ctr: 'nlm', 
            elm: 'it20', 
            n_dms: 2, 
            cnd: _cnd
          })
          .then( _d_it20s => {
            _o_end2(_d_it20s);
          });
        };
      })
      .then( _d_it20s => {
        if (bf.f(_d_it20s)) {
          global.c?.setState({
            s_it20_key: _d_it20s._KEY,
            s_it20b11k: _d_it20s.it20b11k,
            s_it20b21k: _d_it20s.it20b21k,
            s_it20b31k: _d_it20s.it20b31k,
            s_it20s110: _d_it20s.it20s110,
            s_it20d110: _d_it20s.it20d110,
            s_it20d120: _d_it20s.it20d120,
          }, () => {
            _o_end1(_d_it20s);
          });
        }
        else {
          global.c?.setState({
            s_it20_key: '',
            s_it20b11k: '',
            s_it20b21k: '',
            s_it20b31k: '',
            s_it20s110: '0',
            s_it20d110: '',
            s_it20d120: '',
          }, () => {
            _o_end1(null);
          });
        };
      })
    }
    else if (pd.mode == 'items') {
      cf.myCB_set_items({
        ctr: 'nlm',
        elm: 'it20', 
        n_dms: 3,
        state: pd.state, 
        cnd: _cnd,
        do_rfrs: {
            it10: (_d_vals) => {
              if (bf.f(_d_vals.it20b11k)) {
                return bf.q('[_KEY]={}'.f(_d_vals.it20b11k));
              }
              else {
                return null;
              };
            },
            im10: (_d_vals) => {
              if (bf.f(_d_vals.it20b11k)) {
                return bf.q(`[_KEY]=(SELECT [it10b21k]::NUMERIC::INTEGER FROM [t_it10] WHERE [_KEY]={})`.f(_d_vals.it20b11k));
              }
              else {
                return null;
              };
            },
        },
        dld_pcksss: {
          it20s110: [
            {key:'0', pfx: '未入席'},
            {key:'10', pfx: '入席中'},
            {key:'20', pfx: '退席済'},
          ]
        },
        o_fnc: _d_it20s => {
          return {
            pfx: '{}：{}'.f(
              _d_it20s.im10c310,
              _d_it20s.it20s110,
            ),
            spf: '{}円　{} 〜 {}'.f(
              bf.myCM_cnv('cmm', _d_it20s.it10ia70 || '0'),
              _d_it20s.it20d110?.substr(11, 5),
              _d_it20s.it20d120?.substr(11, 5),
            ),
          };
        },
      })
      .then( ()=>{
        _o_end1();
      });
    };
  });

  static $ip_ins_it20 = () => new Promise( _o_end1 => { // 入席情報の追加
    let _d_vals = {
      it20b11k: global.c?.state.sgcd_pageCmns?.it10_key, // 顧客情報
      it20b21k: global.c?.state.sgcd_pageCmns?.cm10_key, // キャスト情報
      it20b31k: global.c?.state.s_it10b21k, // バインド情報
    };
    cf.myCB_call_iud({
      ctr: 'ins', 
      elm: 'it20', 
      d_vals: _d_vals
    })
    .then( _d_it20s => {
      cf.myRN_setCmns({
        it20_key: _d_it20s._KEY,
      })
      .then(() => {
        _o_end1(_d_it20s);
      });
    });
  });

  static $ip_upd_it20 = () => new Promise( _o_end1 => { // 入席情報の上書き
    let _d_vals = {
      it20s110: global.c?.state.s_it20s110, // 入席状況
      it20d110: global.c?.state.s_it20d110, // 入席日時
      it20d120: global.c?.state.s_it20d120, // 退席日時
    };
    let _cnd = bf.q('[_KEY]={}'.f(
      global.c?.state.sgcd_pageCmns?.it20_key,
    ));
    cf.myCB_call_iud({
      ctr: 'upd', 
      elm: 'it20', 
      d_vals: _d_vals, 
      cnd: _cnd
    })
    .then( () => {
      _o_end1();
    });
  });

  static  $ip_load_it30 = pd => new Promise( _o_end1 => { // 注文情報

      let _cnd = '';

      if (bf.f(pd.cnd)) {
        _cnd = pd.cnd;
      }
      else if (bf.f(pd.it30_key)) {
        _cnd = bf.q('[_KEY]={}'.f(
          pd.it30_key
        ));
      }
      else if (bf.f(pd.it10_key)) { //  it10_key に紐づく 注文明細情報
        _cnd = bf.q('[it30b11k]="{}"'.f(
          pd.it10_key
        ));
      };

      if (pd.mode == 'set') {
        new Promise( _o_end2 => {
          if (pd.b_clr == true) {
            _o_end2(null);
          }
          else {
            cf.myCB_call_slc({
              ctr: 'nlm', 
              elm: 'it30', 
              n_dms: 2, 
              cnd: _cnd
            })
            .then( _d_it30s => {
              _o_end2(_d_it30s);
            });
          };
        })
        .then( _d_it30s => {
          if(bf.f(_d_it30s)) {
            global.c?.setState({
              s_it30_key: _d_it30s._KEY,
              s_it30t110: _d_it30s.it30t110,
              s_it30i110: _d_it30s.it30i110,
              s_it30i210: _d_it30s.it30i210 || '0',
              s_it30i220: _d_it30s.it30i220 || '0',
              s_it30i230: _d_it30s.it30i230 || '0',
              s_it30i310: _d_it30s.it30i310 || '0',
              s_it30i320: _d_it30s.it30i320 || '0',
              s_it30i330: _d_it30s.it30i330 || '0',
              s_it30i340: _d_it30s.it30i340 || '0',
              s_it30i410: _d_it30s.it30i410 || '0',
              s_it30i510: _d_it30s.it30i510 || '0',
              s_it30cy10: _d_it30s.it30cy10 || '',
              s_it30cy20: _d_it30s.it30cy20 || '',
            }, () => {
              _o_end1();
            })
          }
          else {
            global.c?.setState({
              s_it30_key: '',
              s_it30t110: '',
              s_it30i110: '',
              s_it30i210: '0',
              s_it30i220: '0',
              s_it30i230: '0',
              s_it30i310: '0',
              s_it30i320: '0',
              s_it30i330: '0',
              s_it30i340: '0',
              s_it30i410: '0',
              s_it30i510: '0',
              s_it30cy10: '',
              s_it30cy20: '',
            }, () => {
              _o_end1();
            })
          };
        });
      }
      else if (pd.mode == 'items') {
        cf.myCB_set_items({
          ctr: 'nlm', 
          elm: 'it30', 
          n_dms: 3, 
          state: pd.state, 
          cnd: _cnd,
          ld_sortss: pd.ld_sortss || [
            { fld: 'it30cy10', dtn: 'desc', mode: 'str' },
          ],
          do_rfrs: {
            cm10: (_d_vals) => {
              if (bf.f(_d_vals.it30b21k)) {
                return bf.q('[_KEY]={}'.f(_d_vals.it30b21k));
              }
              else {
                return null;
              };
            },
            cm50: (_d_vals) => {
              if (bf.f(_d_vals.it30i110)) {
                return bf.q('[_KEY]={}'.f(_d_vals.it30i110));
              }
              else {
                return null;
              };
            },
          },
          o_fnc: _d_it30s => {
            return {
              pfx: '{cm50c310} x{it30i220}'.f2(_d_it30s),
              spf: 
                (_d_it30s.it30b21k == global.c?.state.sgcd_pageCmns?.cm10_key) ? 
                  '{cm10c330}　小計：{it30i230}円'.f2(_d_it30s)
                :
                  '小計：{it30i230}円'.f2(_d_it30s),
            };
          }
        })
        .then(() => {
          _o_end1();
        });      
      }
      else if (pd.mode == 'clds') {
//bf.l('2873: {}'.f(_cnd))
        cf.myCB_set_clds({
          ctr: 'nlm', 
          elm: 'it30', 
          n_dms: 3, 
          state: 'sld_it30ss', 
          cnd: _cnd,
          b_withCnd: true,
          ld_sortss: pd.ld_sortss || [
            { fld: 'it30cy10', dtn: 'desc', mode: 'str' },
          ],
          do_rfrs: {
            cm50: _d_is => {
              let _cnd = bf.q('[_KEY]={}'.f(_d_is.it30i110 || -1));
//bf.l('2815: {}, {}'.f(_cnd, _d_is))
              return _cnd;
            },
            cm1i: _d_is => {
//              let _cnd = bf.q('[cm1ib11k]="{}"'.f(_d_is.it30cy20));
              let _cnd = bf.q('[cm1ib11k]="{}"'.f(_d_is.it30b21k));
//bf.l('2820: {}'.f(_cnd))
              return _cnd;
            },
          }
        })
        .then( () => {
          let _cnd = bf.q(`
            [it31b11k]="{}" AND
            IFNULL([it31cz10],"10")<>"0"
          `.f(
            global.c?.state.s_it10_key
          ));
//bf.l('2904: {}'.f(_cnd))
          cf.myCB_set_clds({
            ctr: 'nlm', 
            elm: 'it31', 
            n_dms: 3, 
            state: 'sld_it31ss', 
            cnd: _cnd,
            b_withCnd: true,
          })
          .then( () => {
//bf.l('3288: {}, {}'.f(pd.state, global.c?.state[pd.state]))
            _o_end1();
          });
//            _o_end1();
        });
      }
  });

/*
  static $ip_ups_it30 = (pd={
    cm10_key: '',
  }) => new Promise( async _o_end1 => {
    for await (let [_idx, _d_it30s] of bf.e(global.c?.state.sld_it30ss)) {
      let _key = '{}'.f(_d_it30s._KEY);
      if (_d_it30s.b_ups == true) { // 追加・更新されている場合
        if (_key.substr(0,3) == 'new') { // 新規登録
          let _d_vals = {
            it30b11k: global.c?.state.sgcd_pageCmns?.it10_key || '',
            it30b21k: pd.cm10_key || '',
            it30t110: _d_it30s.it30t110 || '',
            it30i110: _d_it30s.it30i110 || '',
            it30i210: bf.n(_d_it30s.it30i210) || '0',
            it30i220: bf.n(_d_it30s.it30i220) || '0',
            it30i230: bf.n(_d_it30s.it30i230) || '0',
            it30i310: _d_it30s.it30i310 || '0',
            it30i320: _d_it30s.it30i320 || '0',
            it30i330: _d_it30s.it30i330 || '0',
            it30i340: _d_it30s.it30i340 || '0',
            it30i410: _d_it30s.it30i410 || '0',
            it30i510: _d_it30s.it30i510 || '0',
            it30cy10: bf.myDT_get_now() || '',
            it30cy20: pd.cm10_key || '',
          };
          await cf.myCB_call_iud({
            ctr: 'ins', 
            elm: 'it30', 
            d_vals: _d_vals
          })
        }
        else { // 上書き
          let _d_vals = {
            it30t110: _d_it30s.it30t110 || '',
            it30i110: _d_it30s.it30i110 || '',
            it30i210: bf.n(_d_it30s.it30i210) || '0',
            it30i220: bf.n(_d_it30s.it30i220) || '0',
            it30i230: bf.n(_d_it30s.it30i230) || '0',
            it30i310: _d_it30s.it30i310 || '0',
            it30i320: _d_it30s.it30i320 || '0',
            it30i330: _d_it30s.it30i330 || '0',
            it30i340: _d_it30s.it30i340 || '0',
            it30i410: _d_it30s.it30i410 || '0',
            it30i510: _d_it30s.it30i510 || '0',
            it30cy10: bf.myDT_get_now() || '',
            it30cy20: ((_d_it30s.b_updIt30cy20 == true) ? pd.cm10_key : _d_it30s.it30cy20) || '',
          };
          let _cnd = bf.q('[_KEY]={}'.f(_d_it30s._KEY));
          await cf.myCB_call_iud({
            ctr: 'upd', 
            elm: 'it30', 
            d_vals: _d_vals,
            cnd: _cnd
          })
          .then(() => {
            global.c?.state.sld_it31ss
            .filter( _d_it31s => (_d_it31s.pntKey == _d_it30s._KEY) ? true : false)
            .map( _d_it31s => {
bf.l('2879: {}'.f(_d_it31s));
            });
          });
        }
      }
    };
    cf.myRN_pll([
      ip.$ip_updIt10ia70(), // コース注文の更新
    ])
    .then(() => {
      _o_end1();
    });
  });
*/
  static $ip_ups_it30 = (pd={
    cm10_key: '',
  }) => new Promise( async _o_end1 => {
    for await (let [_idx, _d_it30s] of bf.e(global.c?.state.sld_it30ss)) {
      let _key = String(_d_it30s._KEY);
      if (_key.substr(0,3) == 'new') { // 新規登録
        let _d_vals = {
          it30b11k: global.c?.state.sgcd_pageCmns?.it10_key || '',
//          it30b21k: pd.cm10_key || '',
          it30b21k: _d_it30s.it30b21k || '',
          it30t110: _d_it30s.it30t110 || '',
          it30i110: _d_it30s.it30i110 || '',
          it30i210: bf.n(_d_it30s.it30i210) || '0',
          it30i220: bf.n(_d_it30s.it30i220) || '0',
          it30i230: bf.n(_d_it30s.it30i230) || '0',
          it30i310: _d_it30s.it30i310 || '0',
          it30i320: _d_it30s.it30i320 || '0',
          it30i330: _d_it30s.it30i330 || '0',
          it30i340: _d_it30s.it30i340 || '0',
          it30i410: _d_it30s.it30i410 || '0',
          it30i510: _d_it30s.it30i510 || '0',
          it30cy10: bf.myDT_get_now() || '',
          it30cy20: pd.cm10_key || '',
        };
//bf.l('3018: {}'.f(_d_vals))
        await cf.myCB_call_iud({
          ctr: 'ins', 
          elm: 'it30', 
          d_vals: _d_vals
        })
        .then( _d_it30s2 => {
          global.c?.state.sld_it31ss
          .filter( _d_it31s => (_d_it31s.it31b21k == _key) ? true : false)
          .map( _d_it31s => {
            ip.$ip_ups_it31({
              d_it31s: bf.c(_d_it31s, {it31b21k: _d_it30s2._KEY}),
            });
          });
        })
      }
      else { // 上書き
        if (_d_it30s.b_ups == true) { // 追加・更新されている場合
          let _d_vals = {
            it30b21k: _d_it30s.it30b21k || '',
            it30t110: _d_it30s.it30t110 || '',
            it30i110: _d_it30s.it30i110 || '',
            it30i210: bf.n(_d_it30s.it30i210) || '0',
            it30i220: bf.n(_d_it30s.it30i220) || '0',
            it30i230: bf.n(_d_it30s.it30i230) || '0',
            it30i310: _d_it30s.it30i310 || '0',
            it30i320: _d_it30s.it30i320 || '0',
            it30i330: _d_it30s.it30i330 || '0',
            it30i340: _d_it30s.it30i340 || '0',
            it30i410: _d_it30s.it30i410 || '0',
            it30i510: _d_it30s.it30i510 || '0',
            it30cy10: bf.myDT_get_now() || '',
            it30cy20: ((_d_it30s.b_updIt30cy20 == true) ? pd.cm10_key : _d_it30s.it30cy20) || '',
          };
          let _cnd = bf.q('[_KEY]={}'.f(_d_it30s._KEY));
//bf.l('3053: {}, {}'.f(_cnd, _d_vals))
          await cf.myCB_call_iud({
            ctr: 'upd', 
            elm: 'it30', 
            d_vals: _d_vals,
            cnd: _cnd
          })
        };
        global.c?.state.sld_it31ss
        .filter( _d_it31s => (_d_it31s.it31b21k == _d_it30s._KEY) ? true : false)
        .map( _d_it31s => {
          ip.$ip_ups_it31({
            d_it31s: _d_it31s,
          });
        });
      }
    };

/*
    // 貢献度の更新
    let _l_qrys = [
      bf.q(`
        UPDATE 
          [t_it31] 
        SET
          [it31i120]=(
            SELECT 
              IFNULL(SUM([B].[it31i110]::NUMERIC),"0.0")
            FROM
              [t_it31] AS [B]
            WHERE
              [B].[it31b11k]=[t_it31].[it31b11k] AND
              [B].[it31b21k]=[t_it31].[it31b21k] AND
              IFNULL([B].[it31cz10],"10")<>"0"
          )::TEXT
        WHERE
          [it31b11k]="{}" AND
          IFNULL([it31cz10],"10")<>"0"
      `.f(
        global.c?.state.s_it10_key,
      )),
      bf.q(`
        UPDATE 
          [t_it31] 
        SET
          [it31i130]=(
            SELECT
              CASE
                WHEN  
                  [it31i120]::NUMERIC::INTEGER = 0.0
                THEN
                  0.0
                ELSE
                  CEIL(IFNULL([it31i110],"0.0")::NUMERIC * 1000.0 / [it31i120]::NUMERIC) / 10.0
                END
          )::TEXT
        WHERE
          [it31b11k]="{}" AND
          IFNULL([it31cz10],"10")<>"0"
      `.f(
        global.c?.state.s_it10_key,
      )),
    ];

    cf.myCB_call_iud({
      ctr: 'qrys',
      elm: 'it31',
      l_qrys: _l_qrys,
    })
    .then(() => {
      cf.myRN_pll([
        ip.$ip_updIt10ia70(), // コース注文の更新
      ])
      .then(() => {
        _o_end1();
      });
    });
*/
/*
    cf.myRN_pll([
      ip.$ip_updIt10ia70(), // コース注文の更新
    ])
    .then(() => {
      _o_end1();
    });
*/
      _o_end1();

  });

  static $ip_ups_it31 = (pd={
    d_it31: {},
  }) => new Promise( _o_end2 => {
    if (pd.d_it31s.b_dlt == true) { // 削除の場合
        if (String(pd.d_it31s._KEY).substr(0,3) == 'new') { // 追加の場合
          _o_end2();
        }
        else { // 上書の場合
          let _d = {
            it31cz10: '0',
          };
          let _cnd = bf.q(`
            [_KEY]={}
          `.f(
            pd.d_it31s._KEY,
          ));
//bf.l('3005: {}, {}'.f(_cnd, _d))
          cf.myCB_call_iud({
            ctr: 'upd',
            elm: 'it31',
            d_vals: _d,
            cnd: _cnd,
          })
          .then(() => {
            _o_end2();
          });
        };
    }
    else {
      if (pd.d_it31s.b_ups == true) {
        if (String(pd.d_it31s._KEY).substr(0,3) == 'new') { // 追加の場合
          let _d = {
            it31b11k: global.c?.state.s_it10_key,
            it31b21k: pd.d_it31s.it31b21k,
            it31b31k: pd.d_it31s.it31b31k,
            it31i110: pd.d_it31s.it31i110 || '1',
            it31cz10: '10',
          };
          let _cnd = bf.q(`
            (
              [it31b11k]="{}" AND
              [it31b21k]="{}" AND
              [it31b31k]="{}"
            )
          `.f(
            global.c?.state.s_it10_key,
            pd.d_it31s.it31b21k,
            pd.d_it31s.it31b31k,
          ));
//bf.l('3182: {}, {}'.f(_cnd, _d))
          cf.myCB_call_iud({
            ctr: 'ups',
            elm: 'it31',
            d_vals: _d,
            cnd: _cnd,
          })
          .then(() => {
            _o_end2();
          });
        }
        else { // 上書の場合
          let _d = {
            it31b31k: pd.d_it31s.it31b31k,
            it31i110: pd.d_it31s.it31i110 || '1',
          };
          let _cnd = bf.q(`
            [_KEY]={} OR 
            (
              [it31b11k]="{}" AND
              [it31b21k]="{}" AND
              [it31b31k]="{}"
            )
          `.f(
            pd.d_it31s._KEY,
            global.c?.state.s_it10_key,
            pd.d_it31s.it31b21k,
            pd.d_it31s.it31b31k,
          ));
//bf.l('3211: {}, {}'.f(_cnd, _d))
          cf.myCB_call_iud({
            ctr: 'ups',
            elm: 'it31',
            d_vals: _d,
            cnd: _cnd,
          })
          .then(() => {
            _o_end2();
          });
        };
      }
      else {
        _o_end2();
      }
    }
  });

  static chk_it50s110 = pd => new Promise( _o_end1 => { // レジの開設状況を確認
    let _cnd = bf.q(`
      [it50b11k]="{}" AND 
      ([it50d210]<="{}" AND [it50d220]>="{}") 
    `.f(
      pd.cm20_key,
      pd.dtm,
      pd.dtm,
    ));
    cf.myCB_call_slc({
      ctr: 'nlm', 
      elm: 'it50', 
      n_dms: 2, 
      cnd: _cnd
    })
    .then( _d_it50s => {
      if (bf.f(_d_it50s) && _d_it50s.it50s110 == '10') { // レジが開設中の場合
        _o_end1(_d_it50s);
      }
      else { // レジが締まっている場合
        _o_end1(null);
      };
    })
  });

  static $ip_hlr_it50 = (pd={
    mode: 'get/set/itemss/clds',
    b_clr: false, // get, set
    state: '', // items, clds
    d_vals: {}, // ins/upd
    cnd: '',    
    ld_sortss: [{fld:'_KEY', dtn:'asc/desc'}],
  }) => new Promise( async _o_end1 => {

    let _cnd = '';

    if (bf.f(pd.it50_key)) { // レジ情報が指定されている場合
      _cnd = bf.q(`[_KEY]={}`.f(
        pd.it50_key,
      ));
    }
    else if (bf.f(pd.it60_key)) { // 月次情報が指定されている場合
      _cnd = bf.q(`[it50b21k]="{}"`.f(
        pd.it60_key,
      ));
    }
    else if (bf.f(pd.it50s110) && bf.f(pd.cm20_key)) { // 営業状況が指定されている場合
      _cnd = bf.q(`[it50b11k]="{}" AND [it50s110]="{}"`.f(
        pd.cm20_key,
        pd.it50s110,
      ));
    };

    cf.myCB_hlr({
      elm: 'it50',
      mode: pd.mode,
      b_clr: pd.b_clr,
      state: pd.state,
      d_vals: pd.d_vals,
      cnd: _cnd,
      ld_sortss: pd.ld_sortss,
      b_withCnd: false,
      do_rfrs: {
      },
      dld_pcksss: {
        it50t110: [
          {key:'0', pfx: '休業'},
          {key:'10', pfx: '平日'},
          {key:'20', pfx: '金・土・祝前日'},
          {key:'30', pfx: '日・祝日'},
        ],
        it50s110: [
          {key:'0', pfx: '開設前'},
          {key:'10', pfx: '開設中'},
          {key:'20', pfx: '締切済'},
        ],
      },
    })
    .then( _a_rs => {
      _o_end1(_a_rs);
    })
  });

  static $ip_load_it50 = pd => new Promise( _o_end1 => {

    let _cnd = '';

    if (pd.cnd) {
      _cnd = pd.cnd;
    }
    else if (bf.f(pd.it50_key)) { // レジ情報が指定されている場合
      _cnd = bf.q(`[_KEY]={}`.f(
        pd.it50_key,
      ));
    }
    else if (bf.f(pd.it60_key)) { // 月次情報が指定されている場合
      _cnd = bf.q(`[it50b21k]="{}"`.f(
        pd.it60_key,
      ));
    }
    else if (bf.f(pd.it50s110)) { // 営業状況が指定されている場合
      if (bf.f(pd.cm20_key)) {
        _cnd = bf.q(`[it50b11k]="{}" AND [it50s110]="{}"`.f(
          pd.cm20_key,
          pd.it50s110,
        ));
      }
      else {
alert('2313:you have to set cm20_key at ip_load_it50.')
      };
    };

    if (pd.mode == 'get') {
      if (pd.b_clr == true) {
        _o_end1(null);
      }
      else {
        cf.myCB_call_slc({
          ctr: 'nlm', 
          elm: 'it50', 
          n_dms: 2, 
          cnd: _cnd
        })
        .then( _d_it50s => {
          _o_end1(_d_it50s);
        });
      };
    }
    else if (pd.mode == 'set') {
      new Promise( _o_end2 => {
        if (pd.b_clr == true) {
          _o_end2(null);
        }
        else {
          cf.myCB_call_slc({
            ctr: 'nlm', 
            elm: 'it50', 
            n_dms: 2, 
            cnd: _cnd
          })
          .then( _d_it50s => {
            _o_end2(_d_it50s);
          });
        };
      })
      .then( _d_it50s => {
        if (bf.f(_d_it50s)) {
          global.c?.setState({
            s_it50_key: _d_it50s._KEY,
            s_it50b11k: _d_it50s.it50b11k,
            s_it50b21k: _d_it50s.it50b21k || '',
            s_it50d110: _d_it50s.it50d110 || '',
            s_it50d210: _d_it50s.it50d210 || '',
            s_it50d220: _d_it50s.it50d220 || '',
            s_it50d310: _d_it50s.it50d310 || '9',
            s_it50t110: _d_it50s.it50t110 || '',
            s_it50s110: _d_it50s.it50s110 || '0',
            s_it50i110: _d_it50s.it50i110 || '0',
            s_it50i210: _d_it50s.it50i210 || '0',
            s_it50i220: _d_it50s.it50i220 || '0',
            s_it50i310: _d_it50s.it50i310 || '0',
            s_it50i320: _d_it50s.it50i320 || '0',
            s_it50i410: _d_it50s.it50i410 || '0',
            s_it50i510: _d_it50s.it50i510 || '0',
            s_it50i520: _d_it50s.it50i520 || '0',
            s_it50i710: _d_it50s.it50i710 || '',
            s_it50i810: _d_it50s.it50i810 || '0',
            s_it50i820: _d_it50s.it50i820 || '0',
            s_it50i830: _d_it50s.it50i830 || '0',
            s_it50i840: _d_it50s.it50i840 || '0',
            s_it50i850: _d_it50s.it50i850 ?? 0,
            s_it50i860: _d_it50s.it50i860 || '0',
            s_it50i870: _d_it50s.it50i870 || '0',
            s_it50i880: _d_it50s.it50i880 || '0',
            s_it50i910: _d_it50s.it50i910 || '0',
            s_it50i920: _d_it50s.it50i920 || '0',
            s_it50i930: _d_it50s.it50i930 || '0',
            s_it50ia10: _d_it50s.it50ia10 || '0',
            s_it50ib10: _d_it50s.it50ib10 || '0',
            s_it50ib20: _d_it50s.it50ib20 || '0',
            s_it50ib30: _d_it50s.it50ib30 || '0',
            s_it50ib40: _d_it50s.it50ib40 || '0',
            s_it50ib50: _d_it50s.it50ib50 || '0',
            s_it50ib60: _d_it50s.it50ib60 || '0',
            s_it50ib70: _d_it50s.it50ib70 || '0',
            s_it50ib80: _d_it50s.it50ib80 || '0',
            s_it50ic10: _d_it50s.it50ic10 || '0',
            s_it50id10: _d_it50s.it50id10 || '-1',
            s_it50id20: _d_it50s.it50id20 || '-1',
            s_it50cy10: _d_it50s.it50cy10 || '',
            s_it50cy50: _d_it50s.it50cy50 || '',
            s_it50cy60: _d_it50s.it50cy60 || '',
            s_it50cy70: _d_it50s.it50cy70 || '',
            s_it50cy80: _d_it50s.it50cy80 || '',
          }, ()=>{
            _o_end1(_d_it50s);
          });
        }
        else {
          global.c?.setState({
            s_it50_key: '',
            s_it50b11k: '',
            s_it50b21k: '',
            s_it50d110: '',
            s_it50d210: '',
            s_it50d220: '',
            s_it50d310: '',
            s_it50t110: '0',
            s_it50s110: '0',
            s_it50i110: '0',
            s_it50i210: '0',
            s_it50i220: '0',
            s_it50i310: '0',
            s_it50i320: '0',
            s_it50i410: '0',
            s_it50i510: '0',
            s_it50i520: '0',
            s_it50i710: '',
            s_it50i810: '0',
            s_it50i820: '0',
            s_it50i830: '0',
            s_it50i840: '0',
            s_it50i850: '0',
            s_it50i860: '0',
            s_it50i870: '0',
            s_it50i880: '0',
            s_it50i910: '0',
            s_it50i920: '0',
            s_it50i930: '0',
            s_it50ia10: '0',
            s_it50ib10: '0',
            s_it50ib20: '0',
            s_it50ib30: '0',
            s_it50ib40: '0',
            s_it50ib50: '0',
            s_it50ib60: '0',
            s_it50ib70: '0',
            s_it50ib80: '0',
            s_it50ic10: '0',
            s_it50id10: '-1',
            s_it50id20: '-1',
            s_it50cy10: '',
            s_it50cy50: '',
            s_it50cy60: '',
            s_it50cy70: '',
            s_it50cy80: '',
          }, ()=>{
            _o_end1(null);
          });
        };
      });
    }
    else if (pd.mode == 'items') {
      cf.myCB_set_items({
        ctr: 'nlm', 
        elm: 'it50', 
        n_dms: 3, 
        state: pd.state, 
        cnd: _cnd,
        dld_pcksss: {
          it50t110: [
            {key:'0', pfx: '休業'},
            {key:'10', pfx: '平日'},
            {key:'20', pfx: '金・土・祝前日'},
            {key:'30', pfx: '日・祝日'},
          ],
          it50s110: [
            {key:'0', pfx: '開設前'},
            {key:'10', pfx: '開設中'},
            {key:'20', pfx: '締切済'},
          ],
        },
        ld_sortss: [{fld:'it50d110', dtn:'asc'}],
        o_fnc: _d_it50s => {
          if (global.c?.state.sgc_pageName == 'iMthDtl') {
            return {
              pfx: '{} {}'.f(_d_it50s.it50d110, _d_it50s.it50s110),
              spf: '{} {}円'.f(_d_it50s.it50t110, bf.myCM_cnv('cmm', _d_it50s.it50i210)),
              backCcd: (_d_it50s.it50s110 == '開設中') ? ic.g_ccdGP : null,
            };
          }
          else if (global.c?.state.sgc_pageName == 'iDayList') {
            let _it50i110 = _d_it50s.it50i110 || '0';
            let _it50i210 = _d_it50s.it50i210 || '0';
            let _dff = bf.n(_it50i210) - bf.n(_it50i110);
            return {
              pfx: '{} {}'.f(_d_it50s.it50d110, _d_it50s.it50s110),
              spf: '大入設定額：{}円　実績額：{}円'.f(bf.myCM_cnv('cmm', _it50i110), bf.myCM_cnv('cmm', _it50i210)),
              backCcd: (_d_it50s.it50s110 == '開設中') ? ic.g_ccdGP : null,
            };
          }
          else {
            return {
              pfx: '未設定'
            };
          };
        }
      })
      .then( () => {
        _o_end1();
      });
    };
  });

/*
  static $ip_ins_it50s = (pd={
    d_it60s: {},
  }) => new Promise( async _o_end1 => { // 日別情報
    for await (let [_idx, _date] of bf.e(bf.myDT_get_dates(pd.d_it60s.it60d110))) { // 日別情報の新規登録
      let _d_vals = {
        it50b11k: global.c?.state.sgcd_pageCmns?.cm20_key,
        it50b21k: pd.d_it60s._KEY,
        it50d110: _date,
        it50d210: '',
        it50d220: '',
        it50t110: bf.i(bf.myDT_get_day(_date), [0]) ? '30' : (bf.i(bf.myDT_get_day(_date), [5, 6]) ? '20' : '10') ,
        it50s110: '0',
        it50i210: '0',
        it50cy50: '',
        it50cy60: '',
        it50cy70: '',
        it50cy80: '',
      };
      await cf.myCB_call_iud({
        ctr: 'ins', 
        elm: 'it50', 
        d_vals: _d_vals
      })
      .then( async _d_it50s => {
        ip.$ip_ins_it51s({
          d_it50s: _d_it50s,
        });
      });
    };
    _o_end1();
  });
*/

/*
  static $ip_ins_it50s = (pd={
    d_it60s: {},
  }) => new Promise( async _o_end1 => { // 日別情報
    Promise.all(
      bf.myDT_get_dates(pd.d_it60s.it60d110)
      .map( _date => new Promise( _o_end2 => {
        let _d_vals = {
          it50b11k: global.c?.state.sgcd_pageCmns?.cm20_key,
          it50b21k: pd.d_it60s._KEY,
          it50d110: _date,
          it50d210: '',
          it50d220: '',
          it50t110: bf.i(bf.myDT_get_day(_date), [0]) ? '30' : (bf.i(bf.myDT_get_day(_date), [5, 6]) ? '20' : '10') ,
          it50s110: '0',
          it50i210: '0',
          it50cy50: '',
          it50cy60: '',
          it50cy70: '',
          it50cy80: '',
        };
        cf.myCB_call_iud({
          ctr: 'ins', 
          elm: 'it50', 
          d_vals: _d_vals
        })
        .then( _d_it50s => { // 負荷分散のため、日別情報新規登録時に、日別時間帯別情報の新規登録は行わない
          _o_end2();
        });
      }))
    )
    .then(() => {
      _o_end1();
    });
  });
*/
  static $ip_ins_it50s = (pd={
    d_it60s: {},
  }) => new Promise( async _o_end1 => { // 日別情報
    for await (let [_idx, _date] of bf.e(bf.myDT_get_dates(pd.d_it60s.it60d110))) {
//bf.l('6449: {}'.f(_date));
      let _d_vals = {
        it50b11k: global.c?.state.sgcd_pageCmns?.cm20_key,
        it50b21k: pd.d_it60s._KEY,
        it50d110: _date,
        it50d210: '',
        it50d220: '',
        it50t110: bf.i(bf.myDT_get_day(_date), [0]) ? '30' : (bf.i(bf.myDT_get_day(_date), [5, 6]) ? '20' : '10') ,
        it50s110: '0',
        it50i210: '0',
        it50cy50: '',
        it50cy60: '',
        it50cy70: '',
        it50cy80: '',
      };
      let _cnd = bf.q(`
        it50b11k = "{}" AND
        it50b21k = "{}" AND
        it50d110 = "{}"
      `.f(
        global.c?.state.sgcd_pageCmns?.cm20_key,
        pd.d_it60s._KEY,
        _date,
      ));
//bf.l('6473: {}'.f(_date));
      await cf.myCB_call_iud({
        ctr: 'ins', 
        elm: 'it50', 
        d_vals: _d_vals,
        cnd: _cnd,
      })
//bf.l('6480: {}'.f(_date));
//      await bf.myCM_wait(100)
//bf.l('6482: {}'.f(_date));
    };
//bf.l('6484: here');
    _o_end1();
  });

  static $ip_upd_it50 = () => new Promise( _o_end1 => {
    let _d_vals = {
      it50d110: global.c?.state.s_it50d110 || '',
      it50d210: global.c?.state.s_it50d210 || '',
      it50d220: global.c?.state.s_it50d220 || '',
      it50t110: global.c?.state.s_it50t110 || '0',
      it50s110: global.c?.state.s_it50s110 || '0',
      it50i110: bf.n(global.c?.state.s_it50i110) || '0',
      it50i310: bf.n(global.c?.state.s_it50i310) || '0',
      it50i320: bf.n(global.c?.state.s_it50i320) || '0',
      it50i410: bf.n(global.c?.state.s_it50i410) || '0',
      it50i510: bf.n(global.c?.state.s_it50i510) || '0',
      it50i520: bf.n(global.c?.state.s_it50i520) || '0',
      it50i710: global.c?.state.s_it50i710 || '',
      it50ia10: bf.n(global.c?.state.s_it50ia10) || '0',
      it50ib10: bf.n(global.c?.state.s_it50ib10) || '0',
      it50ib20: bf.n(global.c?.state.s_it50ib20) || '0',
      it50ib30: bf.n(global.c?.state.s_it50ib30) || '0',
      it50ib40: bf.n(global.c?.state.s_it50ib40) || '0',
      it50ib50: bf.n(global.c?.state.s_it50ib50) || '0',
      it50ib60: bf.n(global.c?.state.s_it50ib60) || '0',
      it50ib70: bf.n(global.c?.state.s_it50ib70) || '0',
      it50ib80: bf.n(global.c?.state.s_it50ib80) || '0',
      it50ic10: bf.n(global.c?.state.s_it50ic10) || '0',
      it50id10: global.c?.state.s_it50id10 || '-1',
      it50id20: global.c?.state.s_it50id20 || '-1',
      it50cy50: global.c?.state.s_it50cy50 || '',
      it50cy60: global.c?.state.s_it50cy60 || '',
      it50cy70: global.c?.state.s_it50cy70 || '',
      it50cy80: global.c?.state.s_it50cy80 || '',
    };
    let _cnd = bf.q('[_KEY]={}'.f(
      global.c?.state.sgcd_pageCmns?.it50_key
    ));
//bf.l('6482: {}, {}'.f(_cnd, _d_vals.it50s110 ))
    cf.myCB_call_iud({
      ctr: 'upd', 
      elm: 'it50', 
      d_vals: _d_vals, 
      cnd: _cnd
    })
    .then( _res =>{ // 日別情報の更新
//bf.l('6490: {}'.f( _res ))
      let _qry = bf.q(`
        UPDATE 
          [t_it50]
        SET 
          [it50d310]=(
            SELECT 
              MAX([A].[it50d110]) 
            FROM 
              [t_it50] AS [A] 
            WHERE 
              [A].[it50b11k]=[t_it50].[it50b11k] AND [A].[it50d110]<[t_it50].[it50d110] AND [A].[it50s110]="20"
          )
        WHERE
          [t_it50].[_KEY]={}
      `.f(
        global.c?.state.sgcd_pageCmns?.it50_key
      ));
      cf.myCB_call_iud({
        ctr: 'qry', 
        elm: 'it50', 
        qry: _qry
      })
      .then(() => {
        // it50i510 前レジ金の更新
        let _qry = bf.q(`
          UPDATE 
            [t_it50]
          SET 
            [it50i510]=(
              SELECT 
                IFNULL([A].[it50i520],"0")
              FROM 
                [t_it50] AS [A] 
              WHERE 
                [A].[it50b11k]=[t_it50].[it50b11k] AND [A].[it50d110]=[t_it50].[it50d310]
            )
          WHERE
            [t_it50].[_KEY]={}
        `.f(
          global.c?.state.sgcd_pageCmns?.it50_key
        ));
        cf.myCB_call_iud({
          ctr: 'qry', 
          elm: 'it50', 
          qry: _qry
        })
        .then(() => {
//bf.l('6538: here')
          _o_end1();
        })
      })
    });
  });

  static $ip_load_it51 = pd => new Promise( _o_end1 => { // 日別時間帯別情報
    let _cnd = '';
    if (bf.f(pd.it50_key)) { // 日別情報が指定されている場合
      _cnd = bf.q(`[it51b21k]="{}"`.f(
        pd.it50_key,
      ));
    };

    if (pd.mode == 'clds') {
      cf.myCB_set_clds({
        ctr: 'nlm', 
        elm: 'it51', 
        n_dms: 3, 
        state: 'sld_it51ss',
        cnd: _cnd,
        b_withCnd: true,
        ld_sortss: pd.ld_sortss,
      })
      .then( () => {
        _o_end1();
      });
    };
  });

/*
  static $ip_ins_it51s = (pd={
    d_it50s: {},
  }) => new Promise( async _o_end1 => {
    for await (let [_idx, _timeZone] of bf.e(bf.myCM_get_rng(41, 17))) { // 日別時間帯別情報 同期不要のため await する
      let _d_vals = {
        it51b11k: global.c?.state.sgcd_pageCmns?.cm20_key,
        it51b21k: pd.d_it50s._KEY,
        it51d110: pd.d_it50s.it50d110,
        it51d210: _timeZone,
        it51d310: bf.myDT_add_mnt('{} 00:00:00'.f(pd.d_it50s.it50d110), _timeZone * 60),
        it51i110: '0',
      };
      await cf.myCB_call_iud({
        ctr: 'ins', 
        elm: 'it51', 
        d_vals: _d_vals
      })
    };
    _o_end1();
  });
*/

/*
  static $ip_ins_it51s = (pd={
    d_it50s: {},
  }) => new Promise( async _o_end1 => {
    Promise.all(
      bf.myCM_get_rng(41, 17)
      .map( _timeZone => new Promise( _o_end2 => { // 日別時間帯別情報 同期不要のため await する
        let _d_vals = {
          it51b11k: global.c?.state.sgcd_pageCmns?.cm20_key,
          it51b21k: pd.d_it50s._KEY,
          it51d110: pd.d_it50s.it50d110,
          it51d210: _timeZone,
          it51d310: bf.myDT_add_mnt('{} 00:00:00'.f(pd.d_it50s.it50d110), _timeZone * 60),
          it51i110: '0',
        };
        cf.myCB_call_iud({
          ctr: 'ins', 
          elm: 'it51', 
          d_vals: _d_vals
        })
        .then(() => {
          _o_end2();
        });
      }))
    )
    .then(() => {
      _o_end1();
    });
  });
*/

/*
  static $ip_ups_it51s = (pd={
    d_it50s: {},
  }) => new Promise( async _o_end1 => {
    Promise.all(
      bf.myCM_get_rng(41, 17)
      .map( _timeZone => new Promise( _o_end2 => { // 日別時間帯別情報 同期不要のため await する
        let _d_vals = {
          it51b11k: global.c?.state.sgcd_pageCmns?.cm20_key,
          it51b21k: pd.d_it50s._KEY,
          it51d110: pd.d_it50s.it50d110,
          it51d210: _timeZone,
          it51d310: bf.myDT_add_mnt('{} 00:00:00'.f(pd.d_it50s.it50d110), _timeZone * 60),
          it51i110: '0',
        };
        let _cnd = bf.q(`
          it51b11k="{}" AND
          it51b21k="{}" AND
          it51d110="{}" AND
          it51d210="{}"
        `.f(
          global.c?.state.sgcd_pageCmns?.cm20_key,
          pd.d_it50s._KEY,
          pd.d_it50s.it50d110,
          _timeZone,
        ));
        cf.myCB_call_iud({
          ctr: 'ups', 
          elm: 'it51', 
          d_vals: _d_vals,
          cnd: _cnd,
        })
        .then(() => {
          _o_end2();
        });
      }))
    )
    .then(() => {
      _o_end1();
    });
  });
*/
  static $ip_ups_it51s = (pd={
    d_it50s: {},
  }) => new Promise( async _o_end1 => {
    for await (let [_idx, _timeZone] of bf.e(bf.myCM_get_rng(41, 17))) {
//bf.l('6709: {}'.f(_timeZone))
      let _d_vals = {
        it51b11k: global.c?.state.sgcd_pageCmns?.cm20_key,
        it51b21k: pd.d_it50s._KEY,
        it51d110: pd.d_it50s.it50d110,
        it51d210: _timeZone,
        it51d310: bf.myDT_add_mnt('{} 00:00:00'.f(pd.d_it50s.it50d110), _timeZone * 60),
        it51i110: '0',
      };
      let _cnd = bf.q(`
        it51b11k="{}" AND
        it51b21k="{}" AND
        it51d110="{}" AND
        it51d210="{}"
      `.f(
        global.c?.state.sgcd_pageCmns?.cm20_key,
        pd.d_it50s._KEY,
        pd.d_it50s.it50d110,
        _timeZone,
      ));
      await cf.myCB_call_iud({
//        ctr: 'ups', 
        ctr: 'ins', 
        elm: 'it51', 
        d_vals: _d_vals,
        cnd: _cnd, // 強制 ins
      })
//bf.l('6736: {}'.f(_timeZone))
    }
//bf.l('6738: here')
    _o_end1();
  });

  static $ip_upd_it51 = () => new Promise( async _o_end1 => {
    await cf.myCB_call_iud({
      ctr: 'qrys', 
      elm: '--', 
      l_qrys: [
      // 月別情報 配布枚数
      bf.q(`
        UPDATE 
          [t_it60] 
        SET 
          [it60ia10]=(
            SELECT 
              SUM(REPLACE(REPLACE(IFNULL([it50ia10],"0"),"None","0"),"","0")::NUMERIC::INTEGER)::TEXT 
            FROM 
              [t_it50] 
            WHERE 
              [t_it50].[it50b21k]=[t_it60].[_KEY]::TEXT 
          )
        WHERE 
          [t_it60].[_KEY]={}
      `.f(
        global.c?.state.s_it50b21k
      )),
      // 月別情報 平均配布枚数
      bf.q(`
        UPDATE 
          [t_it60] 
        SET 
          [it60ia20]=(
            SELECT CASE
              WHEN
                REPLACE(IFNULL([it60i310],"0"),"None","0")::NUMERIC::INTEGER = 0
              THEN
                0.00
              ELSE
                ROUND(REPLACE(IFNULL([it60ia10],"0"),"None","0")::NUMERIC::REAL * 100.00 / REPLACE(IFNULL([it60i310],"0"),"None","0")::NUMERIC::REAL) / 100.00
              END
          )::TEXT
        WHERE 
          [t_it60].[_KEY]={}
      `.f(
        global.c?.state.s_it50b21k
      )),
      // 月別情報 配布枚数予測
      bf.q(`
        UPDATE 
          [t_it60] 
        SET 
          [it60ia30]=(
            REPLACE(IFNULL([it60ia20],"0"),"None","0")::NUMERIC::INTEGER * REPLACE(IFNULL([it60i510],"0"),"None","0")::NUMERIC::INTEGER
          )::TEXT
        WHERE 
          [t_it60].[_KEY]={}
      `.f(
        global.c?.state.s_it50b21k
      )),

    ]});
    _o_end1();
  });

  static $ip_hlr_it52 = (pd={
    mode: 'get/set/itemss/clds',
    b_clr: false, // get, set
    state: '', // items, clds
    d_vals: {}, // ins/upd
    cnd: '',    
    ld_sortss: [{fld:'_KEY', dtn:'asc/desc'}],
  }) => new Promise( async _o_end1 => {

    let _cnd = '';

    if (pd.cnd) {
      _cnd = pd.cnd;
    }
    else {
      if (bf.f(pd.it50_key)) { // 入店情報が指定されている場合
        _cnd = bf.q('[it52b21k]="{}"'.f(
          pd.it50_key,
        ));
      };
    };

    cf.myCB_hlr({
      elm: 'it52',
      mode: pd.mode,
      b_clr: pd.b_clr,
      state: pd.state,
      d_vals: pd.d_vals,
      cnd: _cnd,
      ld_sortss: pd.ld_sortss,
      b_withCnd: false,
      do_rfrs: {
      },
      dld_pcksss: {
        it52t110:[ // 入店区分
          {key:'10', pfx: '外販責任者'},
          {key:'20', pfx: '内販責任者'},
        ],
      },
      o_upsCldsDefs: (_d_is) => new Promise( _o_end1 => {
        if (_d_is.b_dlt != true) { // 登録する場合
          let _d_vals = {
            it52b11k: global.c?.state.sgcd_pageCmns?.it20_key,
            it52b21k: global.c?.state.sgcd_pageCmns?.it50_key,
            it52b31k: _d_is.it52b31k,
            it52t110: pd.it52t110 || '',
            it52cz10: '10',
          };
          let _cnd = bf.q('[it52b21k]="{}" AND [it52b31k]="{}" AND [it52t110]="{}"'.f(
            global.c?.state.sgcd_pageCmns?.it50_key,
            _d_is.it52b31k,
            pd.it52t110 || '',
          ));
          _o_end1({
            d_vals: _d_vals, 
            cnd: _cnd
          });
        };
        if (_d_is.b_dlt == true) { // 削除する場合
          if (String(_d_is._KEY).substr(0,3) != 'new') { // 新規登録でない場合
            let _d_vals = {
              it52cz10: '0',
            };
            let _cnd = bf.q('[_KEY]={}'.f(_d_is._KEY))
            _o_end1({
              d_vals: _d_vals, 
              cnd: _cnd
            });
          };
          if (String(_d_is._KEY).substr(0,3) == 'new') { // 新規登録の場合
            _o_end1(null);
            // 処理なし
          };
        };
      }),
    })
    .then( _a_rs => {
      _o_end1(_a_rs);
    })
  });

  static $ip_load_it60 = (pd={ // 月別情報の取得
    mode: 'slc/items',
    it60_key: '',
    cm20_key: '',
    mth: '',
  }) => new Promise( _o_end1 => {

    let _cnd = '';

    if (bf.f(pd.cnd)) { // key が指定されている場合
      _cnd = pd.cnd;
    }
    else if (bf.f(pd.it60_key)) { // key が指定されている場合
      _cnd = bf.q(`[_KEY]={}`.f(
        pd.it60_key,
      ));
    }
    else if (bf.f(pd.cm20_key) && !bf.f(pd.mth)) {
      _cnd = bf.q('[it60b11k]="{}"'.f(
        pd.cm20_key,
      ));
    }
    else if (bf.f(pd.cm20_key) && bf.f(pd.mth)) { // 営業月が指定されている場合
      _cnd = bf.q(`[it60b11k]="{}" AND [it60d110]="{}"`.f(
        pd.cm20_key,
        pd.mth,
      ));
    };

    if (pd.mode == 'set') {
      new Promise( _o_end2 => {
        if (pd.b_clr == true) {
          _o_end2(null);
        }
        else {
          cf.myCB_call_slc({
            ctr: 'nlm', 
            elm: 'it60', 
            n_dms: 2, 
            cnd: _cnd
          })
          .then( _d_it60s => {
            _o_end2(_d_it60s);
          });
        };
      })
      .then( _d_it60s => {
        if (bf.f(_d_it60s)) {
          global.c?.setState({ 
            s_it60_key: _d_it60s._KEY,
            s_it60d110: _d_it60s.it60d110,
            s_it60i110: _d_it60s.it60i110,
            s_it60i210: _d_it60s.it60i210,
            s_it60i310: _d_it60s.it60i310,
            s_it60i320: _d_it60s.it60i320,
            s_it60i330: _d_it60s.it60i330,
            s_it60i340: _d_it60s.it60i340,
            s_it60i410: _d_it60s.it60i410,
            s_it60i450: _d_it60s.it60i450 ?? 0,
            s_it60i460: _d_it60s.it60i460 ?? 0,
            s_it60i470: _d_it60s.it60i470 ?? 0,
            s_it60i510: _d_it60s.it60i510,
            s_it60i610: _d_it60s.it60i610,
            s_it60i710: _d_it60s.it60i710,
            s_it60i810: _d_it60s.it60i810,
            s_it60i820: _d_it60s.it60i820,
            s_it60i830: _d_it60s.it60i830,
            s_it60i840: _d_it60s.it60i840,
            s_it60i850: _d_it60s.it60i850,
            s_it60i860: _d_it60s.it60i860,
            s_it60i870: _d_it60s.it60i870,
            s_it60i8a0: _d_it60s.it60i8a0,
            s_it60i8b0: _d_it60s.it60i8b0 ?? 0,
            s_it60i8f0: _d_it60s.it60i8f0 ?? 0,
            s_it60i8g0: _d_it60s.it60i8g0 ?? 0,
            s_it60i8h0: _d_it60s.it60i8h0 ?? 0,
            s_it60i910: _d_it60s.it60i910,
            s_it60i880: _d_it60s.it60i880,
            s_it60i930: _d_it60s.it60i930,
            s_it60ia10: _d_it60s.it60ia10,
            s_it60ia30: _d_it60s.it60ia30,
            s_it60ib10: _d_it60s.it60ib10,
            s_it60ib20: _d_it60s.it60ib20,
            s_it60ib30: _d_it60s.it60ib30,
            s_it60ib40: _d_it60s.it60ib40,
            s_it60ic10: _d_it60s.it60ic10,
            s_it60ic20: _d_it60s.it60ic20 ?? 0,
            s_it60ic30: _d_it60s.it60ic30 ?? 0,
            s_it60ic40: _d_it60s.it60ic40 ?? 0,
            s_it60id10: _d_it60s.it60id10,
          }, ()=>{
            _o_end1(_d_it60s);
          });
        }
        else {
          global.c?.setState({ 
//            s_it60d110: bf.myDT_get_date('today', +1).substr(0,7),
            s_it60d110: bf.myDT_get_date('today').substr(0,7),
            s_it60i110: '0',
            s_it60i210: '0',
            s_it60i310: '0',
            s_it60i320: '0',
            s_it60i330: '0',
            s_it60i340: '0',
            s_it60i410: '0',
            s_it60i450: '0',
            s_it60i460: '0',
            s_it60i470: '0',
            s_it60i510: '0',
            s_it60i610: '0',
            s_it60i710: '0',
            s_it60i810: '0',
            s_it60i820: '0',
            s_it60i830: '0',
            s_it60i840: '0',
            s_it60i850: '0',
            s_it60i860: '0',
            s_it60i870: '0',
            s_it60i8a0: '0',
            s_it60i8b0: '0',
            s_it60i8f0: '0',
            s_it60i8g0: '0',
            s_it60i8h0: '0',
            s_it60i910: '0',
            s_it60i880: '0',
            s_it60i930: '0',
            s_it60ia10: '0',
            s_it60ia30: '0',
            s_it60ib10: '0',
            s_it60ib20: '0',
            s_it60ib30: '0',
            s_it60ib40: '0',
            s_it60ic10: '0',
            s_it60ic20: '0',
            s_it60ic30: '0',
            s_it60ic40: '0',
            s_it60id10: '0',
          }, ()=>{
            _o_end1(null);
          });
        };
      });
    }
    else if (pd.mode == 'items') {
      cf.myCB_set_items({
        ctr: 'nlm',
        elm: 'it60',
        n_dms: 3,
        state: pd.state, 
        cnd: _cnd,
        o_fnc: _d_it60s => {
          return {
            pfx: '{it60d110}'.f2(_d_it60s),
          }
        },
        ld_sortss: pd.ld_sortss,
      })
      .then( ()=>{
        _o_end1();
      });
    };

  });

  static $ip_load_it70 = (pd={ // 出勤情報
    mode: 'clds',
    it50_key: '',
  }) => new Promise( _o_end1 => { // 出勤情報

    let _cnd = '';

    if (bf.f(pd.it50_key)) { // 日別情報が指定されている場合
      _cnd = bf.q(`[it70b21k]="{}" AND IFNULL([it70cz10],"10")<>"0"`.f(
        pd.it50_key,
      ));
    };

    if (pd.mode == 'clds') {
      cf.myCB_set_clds({
        ctr: 'nlm', 
        elm: 'it70', 
        n_dms: 3, 
        state: pd.state, 
        cnd: _cnd,
        b_withCnd: true,
        do_rfrs: pd.do_rfrs,
        ld_sortss: pd.ld_sortss,
      })
      .then( () => {
        _o_end1();
      });
    }
  });

  static $ip_ups_it70 = () => new Promise( async _o_end1 => { // 出勤情報 pd: {it50_key: '', it70d110: ''}
    for await (let [_idx, _d_it70s] of bf.e(global.c?.state.sld_it70ss)) {
      if (String(_d_it70s._KEY).substr(0,3) == 'new') { // 新規登録の場合
        let _d_vals = {
          it70b11k: _d_it70s.it70b11k || '',
          it70b21k: global.c?.state.sgcd_pageCmns?.it50_key || '',
          it70d110: global.c?.state.s_it50d110 || '',
          it70d310: _d_it70s.it70d310 || '1900',
          it70d320: _d_it70s.it70d320 || '0500',
          it70i110: _d_it70s.it70i110 || '0',
          it70i120: _d_it70s.it70i120 || '',
          it70cz10: (_d_it70s.b_dlt) ? '0' : '10',
        };
        let _cnd = bf.q(`[it70b11k]="{}" AND [it70d110]="{}"`.f(
          _d_it70s.it70b11k,
          global.c?.state.s_it50d110,
        ));
        await cf.myCB_call_iud({
          ctr: 'ups', 
          elm: 'it70', 
          d_vals: _d_vals, 
          cnd: _cnd
        })
        .then(() => {
        })
      }
      else { // 既存更新の場合
        let _d_vals = {
          it70b11k: _d_it70s.it70b11k || '',
          it70b21k: global.c?.state.sgcd_pageCmns?.it50_key || '',
          it70d110: global.c?.state.s_it50d110 || '',
          it70d310: _d_it70s.it70d310 || '1900',
          it70d320: _d_it70s.it70d320 || '0500',
          it70i110: _d_it70s.it70i110 || '0',
          it70i120: _d_it70s.it70i120 || '',
          it70cz10: (_d_it70s.b_dlt) ? '0' : '10',
        };
        let _cnd = bf.q(`[_KEY]={} OR ([it70b11k]="{}" AND [it70d110]="{}")`.f(
          _d_it70s._KEY,
          _d_it70s.it70b11k,
          global.c?.state.s_it50d110,
        ));

        await cf.myCB_call_iud({
          ctr: 'ups', 
          elm: 'it70', 
          d_vals: _d_vals, 
          cnd: _cnd
        })
        .then(() => {
        })
      }
    };

    cf.myCB_call_iud({
      ctr: 'qrys', 
      elm: 'it70', 
      l_qrys: [
        // 2. 出勤者数
        bf.q(`
          UPDATE 
            [t_it50] 
          SET 
            [it50id30]=(
              SELECT COUNT(*) FROM [t_it70] AS [A] WHERE [A].[it70b21k]=[t_it50].[_KEY]::TEXT AND IFNULL([A].[it70cz10],"10")<>"0"
            )::TEXT
          WHERE 
            [t_it50].[_KEY]={}
        `.f(
          global.c?.state.sgcd_pageCmns?.it50_key,                        
        )),
      ],
    })
    _o_end1(); // 反映完了をまたない
  });

  static _updCm50 = () => cp.$cp_load_cm50({
    mode: 'set',
    cm50_key: global.c?.state.s_it10i110,
  });

  static _updCm5i = () => ip.$ip_load_cm5i({
    mode: 'set',
    cm50_key: global.c?.state.s_it10i110,
  });

  static _updIt10d110 = () => new Promise( _o_end1 => { // 開始時刻：　接客開始ボタンを押した場合
    global.c?.setState({
      s_it10d110:　bf.myDT_flr_mnt(bf.myDT_get_now(), 5), // 開始時刻
    }, () => {
      _o_end1();
    });
  });

  static _updIt10d120 = () => new Promise( _o_end1 => { // 終了時刻：　開始時刻・総時間が更新された場合
    global.c?.setState({
      s_it10d120: bf.myDT_add_mnt(global.c?.state.s_it10d110, bf.n(global.c?.state.s_it10i530)), // 終了時刻
    }, () => {
/*
bf.l('4089: {}, {}, {}'.f(
  global.c?.state.s_it10d120,
  global.c?.state.s_it10d110,
  global.c?.state.s_it10i530,
));
*/
      _o_end1();
    });
  });

  static _updIt10d130 = pd => new Promise( _o_end1 => { // 終了時刻（30分延長）：　終了時刻が更新された場合
    global.c?.setState({
      s_it10d130: bf.myDT_add_mnt(global.c?.state.s_it10d120, 30),
    }, () => {
/*
bf.l('4105: {}, {}'.f(
  global.c?.state.s_it10d130,
  global.c?.state.s_it10d120,
));
*/
      _o_end1();
    });
  });

  static _updIt10d140 = pd => new Promise( _o_end1 => { // 終了時刻（60分延長）：　終了時刻が更新された場合
    global.c?.setState({
      s_it10d140: bf.myDT_add_mnt(global.c?.state.s_it10d120, 60),
    }, () => {
      _o_end1();
    });
  });

  static _updIt10i330 = () => new Promise( _o_end1 => { // 入店時総客数：　客数（常連）・客数（新規）が更新された場合
//bf.l('3635:here')
    let _it10i330 = bf.n(global.c?.state.s_it10i310) + bf.n(global.c?.state.s_it10i320);
    global.c?.setState({
      s_it10i330: _it10i330,
//      s_it10i360: _it10i330, // 最終客数に総客数を初期設定（登録の都度、初期値を上書き）
    }, () => {
      _o_end1();
    });
  });

  static _updIt10i360 = () => new Promise( _o_end1 => { // 最終延長客数：　商品種別・数量が変更された場合
    //// コース延長の最小数量（増加分のみ）
    let _n_it10i360 = global.c?.state.sld_it30ss
    .filter( (_d_it30s, _idx) => ( _d_it30s.it30t110 == '220' && bf.n(_d_it30s.it30i410) > 0 ) ? true : false) // 増加分の延長のみ
    .reduce( (_prev, _d_it30s) => {
      return ( _prev == -1 || _prev > bf.n(_d_it30s.it30i220) ) ? bf.n(_d_it30s.it30i220) : _prev;
    }, -1);
//    if ( _n_it10i360 > -1 && _n_it10i360 < bf.n(global.c?.state.s_it10i360) ) { // 現在の最終延長客数よりも少ない場合
    if ( _n_it10i360 > 0 && _n_it10i360 < bf.n(global.c?.state.s_it10i360) ) { // 現在の最終延長客数よりも少ない場合
      let _d_vals = {
        it10i360: _n_it10i360,
      };
      let _cnd = bf.q('[_KEY]={}'.f(
        global.c?.state.sgcd_pageCmns?.it10_key,
      ));
      ip.$ip_hlr_it10({
        mode: 'upd',
        d_vals: _d_vals,
        cnd: _cnd,
      })
      .then( () => {
        global.c?.setState({
          s_it10i360: _n_it10i360,
        }, () => {
          _o_end1();
        })
      });
    }
    else {
      _o_end1();
    };
  });  

  static _updIt10i510 = () => new Promise( _o_end1 => { // 基本時間： 開始時刻・コースが指定された場合
    if (global.c?.state.s_cm50t110 == '110') { // 110 時間制コースの場合
      global.c?.setState({
        s_it10i510: global.c?.state.s_cm5ii110, // 基本時間
      }, () => {
        _o_end1();
      });
    };
    if (global.c?.state.s_cm50t110 == '120') { // 120 時刻制コースの場合
      let _from = global.c?.state.s_it10d110;
      let _to = '{} {}:{}:00'.f(
          global.c?.state.s_it10d110.substr(0,10), 
          global.c?.state.s_cm5ii110.substr(0,2), 
          global.c?.state.s_cm5ii110.substr(2,2)
        );
      let _n_it10i510 = bf.myDT_get_dff(
        'mnt', 
        _from, 
        _to
      );
      global.c?.setState({
        s_it10i510: _n_it10i510, // 基本時間
      }, () => {
        _o_end1();
      });
    };
  });

  static _updIt10i520 = () => new Promise( _o_end1 => { // 総延長時間： 商品種別が変更された場合
    let _it10i520 = global.c?.state.sld_it30ss
    .filter( _d_it30s => (bf.i(_d_it30s.it30t110, ['220'])) ? true : false)
    .filter( _d_it30s => (bf.n(_d_it30s.it30i220) != 0) ? true : false) // 数量 0 は除外
    .reduce( (_prev, _d_it30s) => {
      return _prev + bf.n(_d_it30s.it30i410);
    }, 0);
    _it10i520 = bf.myCM_cnv('floor', _it10i520 / 30) * 30; // 30分単位で端数切捨
    global.c?.setState({
      s_it10i520: _it10i520,
    }, () => {
      _o_end1();
    });
  });

  static _updIt10i530 = () => new Promise( _o_end1 => { // 総時間： 基本時間・延長時間が変更された場合
    global.c?.setState({
      s_it10i530: bf.n(global.c?.state.s_it10i510) + bf.n(global.c?.state.s_it10i520) // 総時間
    }, () => {
      _o_end1();
    });
  });

  static _updIt10i610 = () => new Promise( _o_end1 => { // 基本料金：　コース、入店時総客数が変更された場合
    let _it10i610 = bf.n(global.c?.state.s_cm50i110) * bf.n(global.c?.state.s_it10i330);
    global.c?.setState({
      s_it10i610: _it10i610, // 基本料金
    }, () => {
      _o_end1();
    });
  });

  static _updIt10i640 = () => new Promise( _o_end1 => { // サービス料金（割引前）： 基本料金・追加料金が更新された場合
    global.c?.setState({
      s_it10i640: bf.n(global.c?.state.s_it10i610) + bf.n(global.c?.state.s_it10i620), // 総サービス料金
    }, () => {
      _o_end1();
    });
  });

/*
  static _updIt10ia10 = () => new Promise( _o_end1 => { // チャージ料金（割引前）：　総サービス料金が更新された場合
    let _it10ia10 = 0;
    global.c?.setState({
      s_it10ia10: bf.myCM_cnv('floor', bf.n(global.c?.state.s_it10i640) * bf.n(global.c?.state.s_cm2ii310) / 100),
    }, () => {
      _o_end1();
    });
  });
*/
  static _updIt10ia10 = () => new Promise( _o_end1 => { // チャージ料金（割引前）：　総サービス料金が更新された場合
    let _it10ia10 = 0;
    _it10ia10 = 
      (global.c?.state.s_it10i2a0 == '10') ? 
        bf.myCM_cnv('floor', bf.n(global.c?.state.s_it10i620) * bf.n(global.c?.state.s_cm2ii310) / 100)
      :
        bf.myCM_cnv('floor', bf.n(global.c?.state.s_it10i640) * bf.n(global.c?.state.s_cm2ii310) / 100)
    ;
//bf.l('ip 7383: {}, {}, {}, {}'.f(global.c?.state.s_it10i2a0, global.c?.state.s_it10i620, global.c?.state.s_cm2ii310, global.c?.state.s_it10i640))
    global.c?.setState({
      s_it10ia10: _it10ia10,
    }, () => {
      _o_end1();
    });
  });

  static _updIt10ia30 = () => new Promise( _o_end1 => { // 消費税（割引前）：　サービス料金・チャージ料金が変更された場合
    let _it10ia30 = 0;
    _it10ia30 += bf.n(global.c?.state.s_it10i640) + bf.n(global.c?.state.s_it10ia10);
    _it10ia30 *= bf.n(global.c?.state.s_cm2ii320) / 100;
    _it10ia30 = bf.myCM_cnv('floor', _it10ia30);
    global.c?.setState({
      s_it10ia30: _it10ia30,
    }, () => {
      _o_end1();
    });
  });

  static _updIt10ia40 = () => new Promise( _o_end1 => { // 割引総額： サービス＃２・チャージ料金・消費税・その他割引額が変更された場合
    let _it10ia40 = 0
    _it10ia40 += bf.n(global.c?.state.s_it10ib10); // 無料ドリンク
    _it10ia40 += (global.c?.state.s_it10i220 == '10') ? bf.n(global.c?.state.s_cm2ii220) * bf.n(global.c?.state.s_it10i330) : 0; // サービス#2
    _it10ia40 *= (100 + bf.n(global.c?.state.s_cm2ii310)) / 100; // 無料ドリンク・サービス＃２のチャージ料金
    _it10ia40 *= (global.c?.state.s_it10i2b0 == '10') ? 1 : (100 + bf.n(global.c?.state.s_cm2ii320)) / 100; // 無料ドリンク・サービス＃２の消費税, cm2ii320 : 消費税率
//    _it10ia40 += (global.c?.state.s_it10i2b0 == '10') ? bf.n(global.c?.state.s_it10ia30) : 0; // 消費税
//    _it10ia40 += (global.c?.state.s_it10i2b0 == '10') ? (bf.n(global.c?.state.s_it10i610) * bf.n(global.c?.state.s_cm2ii320) / 100) : 0; // コース基本料金分の消費税
//bf.l('ip 7433: {}'.f(_it10ia40));
    const _r_cm2ii310 = (global.c?.state.s_it10i2a0 == '10') ? (1 + bf.n(global.c?.state.s_cm2ii310) / 100) : 1;
    const _r_cm2ii320 = (global.c?.state.s_it10i2b0 == '10') ? (1 + bf.n(global.c?.state.s_cm2ii320) / 100) : 1;
    const _r = _r_cm2ii310 * _r_cm2ii320 -1;
    _it10ia40 += _r * bf.n(global.c?.state.s_it10i610); // コース基本料金分の消費税
//bf.l('ip 7438: {}, {}, {}, {}, {}, {}'.f(global.c?.state.s_it10i2a0, global.c?.state.s_it10i2b0, _r_cm2ii310, _r_cm2ii320, _r, _it10ia40));
    _it10ia40 -= bf.n(global.c?.state.s_it10ia50); // その他割引額
    _it10ia40 = bf.myCM_cnv('floor', _it10ia40); // 端数切り捨て
    global.c?.setState({
      s_it10ia40: _it10ia40,
    }, () => {
      _o_end1();
    });
  });

  static _updIt10ia70 = () => new Promise( _o_end1 => { // 支払総額： サービス料金・チャージ料金・消費税・割引総額が変更された場合
    let _it10ia70 = 0;
    _it10ia70 += bf.n(global.c?.state.s_it10i640);
//bf.l('ip 7424: {}'.f(_it10ia70)); // 総コース料金 165000
    _it10ia70 += bf.n(global.c?.state.s_it10ia10);
//bf.l('ip 7426: {}'.f(_it10ia70)); // 198000 チャージ料金（割引前）+33000 = 165000 * 0.2
    _it10ia70 += bf.n(global.c?.state.s_it10ia30);
//bf.l('ip 7428: {}'.f(_it10ia70)); // 217800 消費税（割引前）+19800 = 198000 * 1.1
    _it10ia70 -= bf.n(global.c?.state.s_it10ia40);
//bf.l('ip 7430: {}'.f(_it10ia70)); // 179400 割引総額 - 38400 <-> 38400 (-18600) = 120000 * (1.2 * 1.1 - 1) = 144000
    _it10ia70 = bf.myCM_cnv('ceil', _it10ia70 / 100) * 100; // 100円未満切上げ
//bf.l('ip 7432: {}'.f(_it10ia70)); // 179400
//bf.l('7055: {}, {}, {}, {}, {}'.f(_it10ia70, global.c?.state.s_it10i640, global.c?.state.s_it10ia10, global.c?.state.s_it10ia30, global.c?.state.s_it10ia40));
    global.c?.setState({
      s_it10ia70: _it10ia70,
    }, () => {
      _o_end1();
    });
  });

  static _updIt10ia80 = () => new Promise( _o_end1 => { // 支払総額（30分延長）： ３０分延長料金・客数・支払総額が変更された場合
    let _it10ia80 = 0;
    _it10ia80 = bf.n(global.c?.state.s_cm5ii210) * bf.n(global.c?.state.s_it10i360);
//    _it10ia80 *= (1 + ((global.c?.state.s_it10i2a0 == '10') ? 0 : bf.n(global.c?.state.s_cm2ii310)/100));
//    _it10ia80 *= (1 + ((global.c?.state.s_it10i2b0 == '10') ? 0 : bf.n(global.c?.state.s_cm2ii320)/100));
    _it10ia80 *= (1 + (bf.n(global.c?.state.s_cm2ii310)/100));
    _it10ia80 *= (1 + (bf.n(global.c?.state.s_cm2ii320)/100));
    _it10ia80 += bf.n(global.c?.state.s_it10i640);
    _it10ia80 += bf.n(global.c?.state.s_it10ia10);
    _it10ia80 += bf.n(global.c?.state.s_it10ia30);
    _it10ia80 -= bf.n(global.c?.state.s_it10ia40);
    _it10ia80 = bf.myCM_cnv('ceil', _it10ia80 / 100) * 100;
    global.c?.setState({
      s_it10ia80: _it10ia80,
    }, () => {
      _o_end1();
    });
  });

  static _updIt10ia90 = () => new Promise( _o_end1 => { // 支払総額（60分延長）： ３０分延長料金・客数・支払総額が変更された場合
    let _it10ia90 = 0;
    _it10ia90 = bf.n(global.c?.state.s_cm5ii220) * bf.n(global.c?.state.s_it10i360);
//    _it10ia90 *= (1 + ((global.c?.state.s_it10i2a0 == '10') ? 0 : bf.n(global.c?.state.s_cm2ii310)/100));
//    _it10ia90 *= (1 + ((global.c?.state.s_it10i2b0 == '10') ? 0 : bf.n(global.c?.state.s_cm2ii320)/100));
    _it10ia90 *= (1 + (bf.n(global.c?.state.s_cm2ii310)/100));
    _it10ia90 *= (1 + (bf.n(global.c?.state.s_cm2ii320)/100));
    _it10ia90 += bf.n(global.c?.state.s_it10i640);
    _it10ia90 += bf.n(global.c?.state.s_it10ia10);
    _it10ia90 += bf.n(global.c?.state.s_it10ia30);
    _it10ia90 -= bf.n(global.c?.state.s_it10ia40);
    _it10ia90 = bf.myCM_cnv('ceil', _it10ia90 / 100) * 100;
    global.c?.setState({
      s_it10ia90: _it10ia90,
    }, () => {
      _o_end1();
    });
  });

  static _updIt10i720 = () => new Promise( _o_end1 => { // 現金払額：　支払総額・カード払額が変更された場合
    global.c?.setState({
      s_it10i720: bf.n(global.c?.state.s_it10ia70) - bf.n(global.c?.state.s_it10i730) ,
    }, () => {
      _o_end1();
    });
  });

  static _updDsp00 = () => new Promise( _o_end1 => {
    global.c?.setState({
      s_dsp00: '{}　{}'.f(
        String(global.c?.state.s_it10d120).substr(11,5),
        bf.myCM_cnv('cmm', bf.myCM_cnv('han', global.c?.state.s_it10ia70)),
      ),
    }, () => {
      _o_end1();
    });
  });

  static _updDsp30 = () => new Promise( _o_end1 => {
    global.c?.setState({
      s_dsp30: '{}　{}'.f(
        String(global.c?.state.s_it10d130).substr(11,5),
        bf.myCM_cnv('cmm', bf.myCM_cnv('han', global.c?.state.s_it10ia80)),
      ),
    }, () => {
      _o_end1();
    });
  });

  static _updDsp60 = () => new Promise( _o_end1 => {
    global.c?.setState({
      s_dsp60: '{}　{}'.f(
        String(global.c?.state.s_it10d140).substr(11,5),
        bf.myCM_cnv('cmm', bf.myCM_cnv('han', global.c?.state.s_it10ia90)),
      ),
    }, () => {
      _o_end1();
    });
  });

  //// 商品を変更した場合
  static _onChgIt30i110 = (pd_ids) => {
    if (!bf.f(pd_ids) && !bf.f(global.c?.state.sld_it30ss)) return;
    let _d_cm50s = global.c?.state.sdd_cm50ss[pd_ids.next];
    if ( bf.f(_d_cm50s) ) {
//      let _cm10_key = (global.c?.state.sgc_pageName == 'iCmrDtl') ? global.c?.state.sgcd_pageCmns.user_key : global.c?.state.sgcd_pageCmns.cm10_key;
      let _cm10_key = global.c?.state.sgcd_pageCmns.cm10_key;
//bf.l('4351: {}'.f(_cm10_key))
      global.c?.setState({
        sld_it30ss: bf.p(global.c?.state.sld_it30ss, _next => { // 商品種別・単価・延長時間・最大数量の更新
//          _next[pd_ids.idx].it30b21k = _cm10_key;
          _next[pd_ids.idx].it30t110 = _d_cm50s.cm50t110; // 商品種別
          _next[pd_ids.idx].it30i210 = bf.n(_d_cm50s.cm50i110); // 単価
          _next[pd_ids.idx].it30i220 = (_d_cm50s.cm50t110 == '220') ? bf.n(global.c?.state.s_it10i360) : 1; // 数量
          _next[pd_ids.idx].it30i410 = (_d_cm50s.cm50t110 == '220') ? bf.n(_d_cm50s.cm5ii110) : 0; // 延長時間
          _next[pd_ids.idx].it30i510 = bf.n(_d_cm50s.cm5ii310); // 最大数量
          _next[pd_ids.idx].it30cy10 = bf.maxDtm;
          _next[pd_ids.idx].it30cy20 = _cm10_key;
          _next[pd_ids.idx].b_ups = true; // 保存対象
          _next[pd_ids.idx].b_updIt30cy20 = true; // 数量変更フラグ、保存時の更新者の変更を商品・数量の変更者に限定
//bf.l('4439: {}, {}'.f(_next[pd_ids.idx].it30b21k, _next[pd_ids.idx].it30cy20));
        }),
        sld_it31ss: bf.p(global.c?.state.sld_it31ss, _next => { // 同時に更新しないと表示に反映されない
          let _n_cnt = ip.get_cntIt31User({it30_key: pd_ids.key});                    
          if ( _n_cnt == 0 ) {
            let _d = {
              '_KEY': 'new',
              b_dlt: false,
              b_ups: true,
              it31b11k: global.c?.state.sgcd_pageCmns.it10_key, 
              it31b21k: pd_ids.key, 
  //            it31b31k: global.c?.state.sgcd_pageCmns.cm10_key, 
              it31b31k: _cm10_key, 
              it31i110: '1', 
            };
            _next.push(_d);
          };
        }),
      }, () => {
        ip._updIt30i220(pd_ids) // 数量（整形・最大数量）
        .then( ip._updIt10i520 ) // 総延長時間
        .then( ip._updIt30i210 ) // （延長）単価
        .then( ip._updIt30i230 ) // 税抜金額
        .then( ip._updIt10i360 ) // 最小延長客数
      });
    };
  };


  static _updIt30i210 = () => new Promise( _o_end1 => { // （延長）単価： 総延長時間が変更された場合、商品種別の変更を考慮し全注文明細が処理対象
//bf.l('4006: here')
    let _n1 = bf.myCM_cnv('floor', (bf.n(global.c?.state.s_it10i520)) / 60);
    let _n2 = bf.myCM_cnv('floor', (bf.n(global.c?.state.s_it10i520) - _n1 * 60) / 30);
    let _lmt = _n1 * 60;
    global.c?.setState({ // map 中で immer を用いて要素ごとに setState とした場合、元の list を破壊し正しく動作しない模様
      sld_it30ss: bf.p(global.c?.state.sld_it30ss, _next => {
        if (_next) {
          let _ld_it30ss = _next.map( (_d_it30s, _idx) => ({idx: _idx, ..._d_it30s})) // deep copy

  /*
          _ld_it30ss.map(_d_it30s => {
  bf.l('4014: {}, {}'.f(_d_it30s.it30t110, _d_it30s.it30i220))
          });
  */
          _ld_it30ss = _ld_it30ss
          .filter( _d_it30s => (_d_it30s.it30t110 == '220') ? true : false)
          .filter( _d_it30s => (bf.n(_d_it30s.it30i220) != 0) ? true : false) // 数量 0 は除外
  //bf.l('4018: {}'.f(_ld_it30ss))

          _ld_it30ss = _ld_it30ss
          .sort( (_d_it30s1, _d_it30s2) => { // 数量が大きいものを上位、延長時間の絶対値が大きいものを上位、延長時間の相対値が大きいものを上位
            let _r = 0
            if ( bf.n(_d_it30s1.it30i220) > bf.n(_d_it30s2.it30i220) ) {
              _r = -3
            }
            else if ( bf.n(_d_it30s1.it30i220) < bf.n(_d_it30s2.it30i220) ) {
              _r = 3;
            }
            else if ( Math.abs(bf.n(_d_it30s1.it30i410)) > Math.abs(bf.n(_d_it30s2.it30i410)) ) {
              _r = -2;
            }
            else if ( Math.abs(bf.n(_d_it30s1.it30i410)) < Math.abs(bf.n(_d_it30s2.it30i410)) ) {
              _r = 2;
            }
            else if ( bf.n(_d_it30s1.it30i410) < bf.n(_d_it30s2.it30i410) ) {
              _r = -1;
            }
            else if ( bf.n(_d_it30s1.it30i410) > bf.n(_d_it30s2.it30i410) ) {
              _r = 1;
            }
            return _r;
          });

          _ld_it30ss
          .map( (_d_it30s1, _idx1) => { 
            // 延長単価の再計算
            let _it30i210 = (bf.myCM_cnv('floor', bf.n(_d_it30s1.it30i410) / 60) == 1) ? bf.n(global.c?.state.s_cm5ii220) : bf.myCM_cnv('floor', bf.n(global.c?.state.s_cm5ii220) / 2);
            if ( _n2 != 0 ){ // _n2 != 0 (30分の端数延長あり)
              let _sum = _ld_it30ss // 直前までの延長時間の合計
              .filter( (_d_it30s2, _idx2) => (_idx2 <= _idx1) ? true : false)
              .reduce( (_prev, _d_it30s2) => {
                return _prev + bf.n(_d_it30s2.it30i410 || '0');
              }, 0);
              if ( _sum > _lmt ) { // 末尾 30 分の場合
                _it30i210 = bf.n(global.c?.state.s_cm5ii210);
              };
            };
  //bf.l('4056: {}, {}'.f(_next[_d_it30s1.idx].it30i210, _it30i210))
            if (_next[_d_it30s1.idx].it30i210 != _it30i210) {
              _next[_d_it30s1.idx].it30i210 = _it30i210; // 延長単価
              _next[_d_it30s1.idx].b_ups = true;
            }
          });
        };
      }),
    }, () => {
      _o_end1();
    });
  });

  static _updIt30i220 = (pd_ids) => new Promise( async _o_end1 => { // 数量： 数量・商品種別が変更された場合
    global.c?.setState({
      sld_it30ss: bf.p(global.c?.state.sld_it30ss, _next => {
        if (!_next[pd_ids.idx]) _next[pd_ids.idx] = {};
        _next[pd_ids.idx].b_updIt30cy20 = true; // 数量変更フラグ、保存時の更新者の変更を商品・数量の変更者に限定
        let _it30i220 = bf.n(_next[pd_ids.idx].it30i220);
        let _maxCnt = bf.n(_next[pd_ids.idx].it30i510);
        if ( _maxCnt != 0 ) { // 最大数量が0の場合は評価対象外 ※ 複数ユーザが同時並行で同一商品を登録した場合のチェックには対応できていない
          let _crrCnt = _next
          .filter( _d_it30s => (_d_it30s.it30i110 == _next[pd_ids.idx].it30i110) ? true : false)
          .reduce( (_prev, _d_it30s) => {
            return _prev + bf.n(_d_it30s.it30i220);
          } ,0);
          if ( _crrCnt > _maxCnt ) { // 最大数量を超過している場合
            _it30i220 = _maxCnt - (_crrCnt - _it30i220);
            alert('最大（{}）以上の数量は登録できません。'.f(_maxCnt));
          }
        }
        if ( _next[pd_ids.idx].it30i220 != _it30i220 ) {
          _next[pd_ids.idx].it30i220 = _it30i220;
        }
      }),
    }, () => {
      _o_end1();
    });
  });

  //// 数量を変更した場合
  static _onBlurIt30i220 = (pd_ids) => {
    if (!bf.f(pd_ids) && !bf.f(global.c?.state.sld_it30ss)) return;
    ip._updIt30i220(pd_ids) // 数量（整形・最大数量）
    .then( ip._updIt30i230 ) // 税抜金額
    .then( ip._updIt10i360 ) // 最小延長客数
  };

/*
  _onPrsStt = () => { // 入席
    global.c?.setState({
      s_it20s110: '10', // 入席状況
      s_it20d110: bf.myDT_get_now(),
      s_it20d120: bf.maxDtm, // 入席終了日時
    }, () => {
      if (global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName] == 'new') { // 新規の場合
        global.c?.ins();
      }
      else { // 既存の場合
        global.c?.upd();
      }
    });    
  };
*/

  static _updIt30i230 = () => new Promise( async _o_end1 => { // 税抜金額： 数量・単価が変更された場合
    global.c?.setState({
      sld_it30ss: bf.p(global.c?.state.sld_it30ss, _next => {
//        _next[pd_ids.idx].it30i230 = bf.n(_next[pd_ids.idx].it30i210) * bf.n(_next[pd_ids.idx].it30i220);
        if (_next) {
          _next.map( _d_it30s => {
            if ( _d_it30s.b_ups == true) {
              _d_it30s.it30i230 = bf.n(_d_it30s.it30i210) * bf.n(_d_it30s.it30i220);
            };
          });
        };
      }),
    }, () => {
      _o_end1();
    });
  });

  static _updIt50i520 = () => new Promise( _o_end1 => { // 当日レジ金
    let _it50i520 = 
      bf.n(global.c?.state.s_it50i510)
      + bf.n(global.c?.state.s_it50i210)
      - bf.n(global.c?.state.s_it50i220)
      - bf.n(global.c?.state.s_it50i310)
      - bf.n(global.c?.state.s_it50i320)
      - bf.n(global.c?.state.s_it50i410)
    global.c?.setState({
      s_it50i520: _it50i520,
    }, () => {
      _o_end1();
    });
  });

  static _updIt50ib10 = () => new Promise( _o_end1 => { // 総経費：　各費用項目が変更された場合
    let _it50ib10 = 
      bf.n(global.c?.state.s_it50ib20)
      + bf.n(global.c?.state.s_it50ib30)
      + bf.n(global.c?.state.s_it50ib40)
      + bf.n(global.c?.state.s_it50ib50)
//      + bf.n(global.c?.state.s_it50ib60)
      + bf.n(global.c?.state.s_it50i310)
      + bf.n(global.c?.state.s_it50ib70)
      + bf.n(global.c?.state.s_it50ib80);
    global.c?.setState({
      s_it50ib10: _it50ib10,
    }, () => {
      _o_end1();
    });
  });

  static _updIt50ic10 = () => new Promise( _o_end1 => { // 利益： 売上・経費計が変更された場合
    global.c?.setState({
      s_it50ic10: bf.n(global.c?.state.s_it50i210) - bf.n(global.c?.state.s_it50ib10),
    }, () => {
      _o_end1();
    });
  });

  static _updIt60i710 = () => new Promise( _o_end1 => { // 売上差額： 目標売上・売上予測が変更された場合
    global.c?.setState({
      s_it60i710: bf.n(global.c?.state.s_it60i610) - bf.n(global.c?.state.s_it60i110),
    }, () => {
      _o_end1();
    });
  })

  static get_cntIt31User = (pd={
    it30_key: {}
  }) => {
//    let _cm10_key = (global.c?.state.sgc_pageName == 'iCmrDtl') ? global.c?.state.sgcd_pageCmns.user_key : global.c?.state.sgcd_pageCmns.cm10_key;
    let _cm10_key = global.c?.state.sgcd_pageCmns.cm10_key;
    let _n = global.c?.state.sld_it31ss
    .filter( _d_it31s => {
      let _b = true;
      if (_d_it31s.it31b21k != pd.it30_key) _b = false;
      if (_d_it31s.b_dlt == true) _b = false;
      if (_d_it31s.it31b31k != _cm10_key) _b = false;
      return _b;
    })
    .reduce( (_prev, _d_it31s) => {
      return _prev + 1;
    }, 0); // 自身の登録状況  };
//bf.l('4446:{}, {}'.f(_n, pd.it30_key))
    return _n;
  };

  static dd_rptss = {
    '月別一覧CSV': {
      pfx: '月別一覧 CSV出力',
      onPrs: () => {
        cf.myCB_call_slc({
          ctr: 'nlm',
          elm: 'it60',
          n_dms: 3,
          cnd: bf.q('[it60b11k]="{}"'.f(global.c?.state.sgcd_pageCmns?.cm20_key)),
          do_rfrs: {
            cm20: _d_is => bf.q('[_KEY]={}'.f(_d_is.it60b11k)),
          },
          dld_pcksss: {
          }, 
        })
        .then( _ld_iss => {
          let _csv = bf.myFL_csv({
            ld_iss: _ld_iss,
//            hdr: '"店舗","営業月","営業予定日数","売上目標","売上実績","経過日数","平日経過日数","休日前経過日数","休日経過日数","平均売上","売上予測","目標差異","平均客数","集客数予測","総利益","平日利益平均","金・土・祝前利益平均","日・祝利益平均","利益予測","配布枚数","外販客数","新規客数","反響率","組数","客数","客単価","延長客数","延長率"',
            hdr: '"店舗","営業月","営業予定日数","売上目標","売上実績","経過日数","平日経過日数","金・土・祝前経過日数","日・祝経過日数","平均売上","売上予測","目標差異","平均客数","集客数予測","総利益","平日利益平均","金・土・祝前利益平均","日・祝利益平均","利益予測","配布枚数","外販客数","新規客数","反響率","組数","客数","客単価","延長客数","延長率"',
            o_val: _d_is => {
              return '"{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}"'.f(
                _d_is.cm20c310 || '',
                _d_is.it60d110 || '',
                _d_is.it60i510 || '',
                _d_is.it60i110 || '',
                _d_is.it60i210 || '',
                _d_is.it60i310 || '',
                _d_is.it60i320 || '',
                _d_is.it60i330 || '',
                _d_is.it60i340 || '',
                _d_is.it60i410 || '',
                _d_is.it60i610 || '',
                _d_is.it60i710 || '',
                bf.n(_d_is.it60i850).toFixed(2) || '',
                _d_is.it60i860 || '',
                _d_is.it60ib10 || '',
                _d_is.it60ic20 || '',
                _d_is.it60ic30 || '',
                _d_is.it60ic40 || '',
                _d_is.it60id10 || '',
                _d_is.it60ia10 || '',
                _d_is.it60i910 || '',
                _d_is.it60i880 || '',
                _d_is.it60i930 || '',
                _d_is.it60i870 || '',
                _d_is.it60i810 || '',
                _d_is.it60i820 || '',
                _d_is.it60i830 || '',
                _d_is.it60i840 || '',
              );
            }
          })
          bf.myFL_ept({
            fileName: '月別一覧_{}.csv'.f(bf.myDT_get_now().replace(/ /g, '-').replace(/-/g, '').replace(/:/g, '').substr(0,12)),
            val: _csv
          });
        });
      },
    },
    '月別時間帯別一覧CSV': {
      pfx: '月別時間帯別一覧 CSV出力',
      onPrs: () => {
        cf.myCB_call_slc({
          ctr: 'nlm',
          elm: 'it61',
          n_dms: 3,
          cnd: bf.q('[it61b11k]="{}"'.f(global.c?.state.sgcd_pageCmns?.cm20_key)),
          do_rfrs: {
            cm20: _d_is => bf.q('[_KEY]={}'.f(_d_is.it61b11k)),
            it60: _d_is => bf.q('[_KEY]={}'.f(_d_is.it61b21k)),
          },
          dld_pcksss: {
          }, 
          ld_sortss: [
            {fld:'it60d110', dtn: 'asc', mode:'str'},
            {fld:'it60d210', dtn: 'asc', mode:'nmb'}
          ],
        })
        .then( _ld_iss => {
          let _csv = bf.myFL_csv({
            ld_iss: _ld_iss,
//            hdr: '"店舗","営業月","時間帯","総入店客数","平日入店客数平均","休日前入店客数平均","休日入店客数平均"',
            hdr: '"店舗","営業月","時間帯","総入店客数","平日入店客数平均","金・土・祝前入店客数平均","日・祝入店客数平均"',
            o_val: _d_is => {
              return '"{}","{}","{}","{}","{}","{}","{}"'.f(
                _d_is.cm20c310 || '',
                _d_is.it60d110 || '',
                _d_is.it61d210 || '0',
                _d_is.it61i110 || '0',
/*
                _d_is.it61i320 || '0',
                _d_is.it61i330 || '0',
                _d_is.it61i340 || '0',
*/
                bf.n(_d_is.it61i320).toFixed(2) || '0',
                bf.n(_d_is.it61i330).toFixed(2) || '0',
                bf.n(_d_is.it61i340).toFixed(2) || '0',
              );
            }
          })
          bf.myFL_ept({
            fileName: '月別時間帯別一覧_{}.csv'.f(bf.myDT_get_now().replace(/ /g, '-').replace(/-/g, '').replace(/:/g, '').substr(0,12)),
            val: _csv
          });
        });
      },
    },
    '日別一覧CSV': {
      pfx: '日別一覧 CSV出力',
      onPrs: () => {

        cf.myCB_call_slc({
          ctr: 'nlm',
          elm: 'cm10',
          n_dms: 3,
          cnd: bf.q(''),
          do_rfrs: {
          },
          dld_pcksss: {
          }, 
        })
        .then( _ld_cm10ss => {
          let _ld_mbrss = _ld_cm10ss.map( _d_cm10s => {
            return {
              key: _d_cm10s._KEY,
              pfx: _d_cm10s.cm10c330,
            };
          });
          cf.myCB_call_slc({
            ctr: 'nlm',
            elm: 'it50',
            n_dms: 3,
//                      cnd: bf.q('[it50b21k]="{}"'.f(global.c?.state.sgc_pageKey)),
            cnd: bf.q('[it50b21k]="{}"'.f(global.c?.state.sgcd_pageCmns?.it60_key)),
            do_rfrs: {
              cm20: _d_is => bf.q('[_KEY]={}'.f(_d_is.it50b11k)),
            },
            dld_pcksss: {
              it50id20: _ld_mbrss,
              it50id10: _ld_mbrss,
              it50cy60: _ld_mbrss,
              it50cy80: _ld_mbrss,
              it50t110: [
                {key:'0', pfx: '休業'},
                {key:'10', pfx: '平日'},
                {key:'20', pfx: '金・土・祝前日'},
                {key:'30', pfx: '日・祝日'},
              ],
              it50s110: [
                {key:'0', pfx: '開設前'}, // 未接客
                {key:'10', pfx: '開設中'}, // 接客中
                {key:'20', pfx: '締切済'}, // 接客済
              ],
            }, 
          })
          .then( _ld_iss => {
            let _csv = bf.myFL_csv({
              ld_iss: _ld_iss,
//              hdr: '"店舗","営業日","営業日区分","内販管理者","外販管理者","大入設定額","連絡事項","レジ状況","レジ開設日時","レジ締切日時","売上","内カード売上","雑費レシート","日払い領収書","中身","レジ金（前日）","レジ金（当日）","配布枚数","外販客数","新規客数","反響率","組数","客数","客単価","延長客数","延長率","男子給","女子給","ドリンク","大入手当","雑費","酒代","ランコス","経費","利益","レジ開設日時","レジ開設者","レジ締切日時","レジ締切者"',
              hdr: '"店舗","営業日","営業日区分","内販責任者","外販責任者","大入設定額","連絡事項","レジ状況","レジ開設日時","レジ締切日時","売上","内カード売上","雑費レシート","日払い領収書","中身","レジ金（前日）","レジ金（当日）","配布枚数","外販客数","新規客数","反響率","組数","客数","客単価","延長客数","延長率","男子給","女子給","ドリンク","大入手当","雑費","酒代","ランコス","経費","利益","レジ開設日時","レジ開設者","レジ締切日時","レジ締切者"',
              o_val: _d_is => {
                return '"{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}"'.f(
                  _d_is.cm20c310 || '',
                  _d_is.it50d110 || '',
                  _d_is.it50t110 || '',
                  _d_is.it50id20 || '',
                  _d_is.it50id10 || '',
                  _d_is.it50i110 || '',
                  _d_is.it50i710 || '',
                  _d_is.it50s110 || '',
                  _d_is.it50d210 || '',
                  _d_is.it50d220 || '',
                  _d_is.it50i210 || '',
                  _d_is.it50i220 || '',
                  _d_is.it50i310 || '',
                  _d_is.it50i320 || '',
                  _d_is.it50i410 || '',
                  _d_is.it50i510 || '',
                  _d_is.it50i520 || '',
                  _d_is.it50ia10 || '',
                  _d_is.it50i910 || '',
                  _d_is.it50i920 || '',
                  _d_is.it50i930 || '',
                  _d_is.it50i870 || '',
                  _d_is.it50i810 || '',
                  _d_is.it50i820 || '',
                  _d_is.it50i830 || '',
                  _d_is.it50i840 || '',
                  _d_is.it50ib20 || '',
                  _d_is.it50ib30 || '',
                  _d_is.it50ib40 || '',
                  _d_is.it50ib50 || '',
                  _d_is.it50ib60 || '',
                  _d_is.it50ib70 || '',
                  _d_is.it50ib80 || '',
                  _d_is.it50ib10 || '',
                  _d_is.it50ic10 || '',
                  _d_is.it50cy50 || '',
                  _d_is.it50cy60 || '',
                  _d_is.it50cy70 || '',
                  _d_is.it50cy80 || '',
                );
              }
            })
            bf.myFL_ept({
              fileName: '日別一覧_{}.csv'.f(bf.myDT_get_now().replace(/ /g, '-').replace(/-/g, '').replace(/:/g, '').substr(0,12)),
              val: _csv
            });
          });
        });
      },
    },
    '日別責任者一覧CSV': {
      pfx: '日別責任者一覧 CSV出力',
      onPrs: () => {
        let _cnd = bf.q('IFNULL([it52cz10],"10")<>"0" AND [it52b21k] IN (SELECT [_KEY]::TEXT FROM [t_it50] WHERE [t_it50].[it50b21k]="{}")'.f(
          global.c?.state.sgcd_pageCmns?.it60_key
        ));
        cf.myCB_call_slc({
          ctr: 'nlm',
          elm: 'it52',
          n_dms: 3,
          cnd: _cnd,
          do_rfrs: {
            cm10: _d_is => bf.q('[_KEY]={}'.f(_d_is.it52b31k)),
            cm20: _d_is => bf.q('[_KEY]=(SELECT [it50b11k]::NUMERIC::INTEGER FROM [t_it50] WHERE [t_it50].[_KEY]={})'.f(_d_is.it52b21k)),
            it50: _d_is => bf.q('[_KEY]={}'.f(_d_is.it52b21k)),
          },
          dld_pcksss: {
            it52t110: [
              {key: '10', pfx: '外販責任者'},
              {key: '20', pfx: '内販責任者'},
            ],
          }, 
        })
        .then( _ld_iss => {
          let _csv = bf.myFL_csv({
            ld_iss: _ld_iss,
            hdr: '"店舗","営業日","責任者区分","責任者"',
            o_val: _d_is => {
              let _r = '"{}","{}","{}","{}"'.f(
                _d_is.cm20c310 || '',
                _d_is.it50d110 || '',
                _d_is.it52t110 || '',
                _d_is.cm10c330 || '',
              );
              return _r;
            }
          })
          bf.myFL_ept({
            fileName: '日別責任者一覧_{}.csv'.f(bf.myDT_get_now().replace(/ /g, '-').replace(/-/g, '').replace(/:/g, '').substr(0,12)),
            val: _csv
          });
        });
      },
    },
    '日別時間帯別一覧CSV': {
      pfx: '日別時間帯別一覧 CSV出力',
      onPrs: () => {
        cf.myCB_call_slc({
          ctr: 'nlm',
          elm: 'it51',
          n_dms: 3,
          cnd: bf.q('[it51b21k] IN (SELECT [_KEY]::TEXT FROM [t_it50] WHERE [t_it50].[it50b21k]="{}")'.f(
            global.c?.state.sgcd_pageCmns?.it60_key
          )),
          do_rfrs: {
            cm20: _d_is => bf.q('[_KEY]={}'.f(_d_is.it51b11k)),
          },
          dld_pcksss: {
          }, 
          ld_sortss: [
            {fld:'it51d110', dtn: 'asc', mode:'str'},
            {fld:'it51d210', dtn: 'asc', mode:'nmb'}
          ],
        })
        .then( _ld_iss => {
          let _csv = bf.myFL_csv({
            ld_iss: _ld_iss,
            hdr: '"店舗","営業日","時間帯","総入店客数"',
            o_val: _d_is => {
              return '"{}","{}","{}","{}"'.f(
                _d_is.cm20c310 || '',
                _d_is.it51d110 || '',
                _d_is.it51d210 || '',
                _d_is.it51i110 || '0',
              );
            }
          })
          bf.myFL_ept({
            fileName: '日別時間帯別一覧_{}.csv'.f(bf.myDT_get_now().replace(/ /g, '-').replace(/-/g, '').replace(/:/g, '').substr(0,12)),
            val: _csv
          });
        });
      },
    },
    '出勤一覧CSV': {
      pfx: '出勤一覧 CSV出力',
      onPrs: () => {
        let _cnd = bf.q('[it70b21k] IN (SELECT [_KEY]::TEXT FROM [t_it50] WHERE [t_it50].[it50b21k]="{}") AND IFNULL([it70cz10],"10")<>"0"'.f(
          global.c?.state.sgcd_pageCmns?.it60_key
        ));
        cf.myCB_call_slc({
          ctr: 'nlm',
          elm: 'it70',
          n_dms: 3,
          cnd: _cnd,
          do_rfrs: {
            cm20: _d_is => bf.q('[_KEY]=(SELECT [cm10b21k]::NUMERIC::INTEGER FROM [t_cm10] WHERE [t_cm10].[_KEY]={})'.f(_d_is.it70b11k)),
            cm10: _d_is => bf.q('[_KEY]={}'.f(_d_is.it70b11k)),
          },
          dld_pcksss: {
            it70i110: [
              {key:'0', pfx: 'なし'},
              {key:'100', pfx: '遅刻'},
              {key:'910', pfx: '欠勤'},
              {key:'920', pfx: '無断欠勤'},
            ],
          }, 
        })
        .then( _ld_iss => {
          let _csv = bf.myFL_csv({
            ld_iss: _ld_iss,
            hdr: '"店舗","スタッフ","営業日","出勤時刻","退勤時刻","遅刻・欠勤・無断欠勤","備考"',
            o_val: _d_is => {
//              return '"{}","{}","{}","{}","{}","{}"'.f(
              return '"{}","{}","{}","{}","{}","{}","{}"'.f(
                _d_is.cm20c310 || '',
                _d_is.cm10c330 || '',
                _d_is.it70d110 || '',
                _d_is.it70d310 || '',
                _d_is.it70d320 || '',
                _d_is.it70i110 || '',
                _d_is.it70i120 ?? '',
              );
            }
          })
          bf.myFL_ept({
            fileName: '出勤一覧_{}.csv'.f(bf.myDT_get_now().replace(/ /g, '-').replace(/-/g, '').replace(/:/g, '').substr(0,12)),
            val: _csv
          });
        });
      },
    },
    '入店時刻一覧CSV': {
      pfx: '入店時刻一覧 CSV出力',
      onPrs: () => {
        cf.myCB_call_slc({
          ctr: 'nlm',
          elm: 'it10',
          n_dms: 3,
          cnd: bf.q('[it10b31k] IN (SELECT [_KEY]::TEXT FROM [t_it50] WHERE [t_it50].[it50b21k]="{}")'.f(
            global.c?.state.sgcd_pageCmns?.it60_key
          )),
          do_rfrs: {
            cm10: _d_is => bf.q('[_KEY]={}'.f(bf.f(_d_is.it10cy40) ? _d_is.it10cy40 : -1)),
            cm20: _d_is => bf.q('[_KEY]={}'.f(bf.f(_d_is.it10b11k) ? _d_is.it10b11k : -1)),
            cm50: _d_is => bf.q('[_KEY]={}'.f(bf.f(_d_is.it10i110) ? _d_is.it10i110 : -1)),
            im10: _d_is => bf.q('[_KEY]={}'.f(bf.f(_d_is.it10b21k) ? _d_is.it10b21k : -1)),
            it50: _d_is => bf.q('[_KEY]={}'.f(bf.f(_d_is.it10b31k) ? _d_is.it10b31k : -1)),
          },
          dld_pcksss: {
            it10t110:[
              {key:'10', pfx: '新規入店'},
              {key:'20', pfx: '出戻り'},
            ],
            it10i220:[
              {key:'0', pfx: 'なし'},
              {key:'10', pfx: 'あり'},
            ],
            it10i2a0:[
              {key:'0', pfx: 'チャージあり'}, // 割引なし
              {key:'10', pfx: 'チャージなし'}, // 割引あり
            ],
            it10i2b0:[
              {key:'0', pfx: '消費税あり'}, // 割引なし
              {key:'10', pfx: '消費税なし'}, // 割引あり
            ],
            it10s110:[
              {key:'0', pfx: '接客前'}, // 未サービス
              {key:'10', pfx: '接客中'}, // サービス中
              {key:'20', pfx: '接客済'}, // 支払済
            ],
          }, 
        })
        .then( _ld_iss => {
          let _csv = bf.myFL_csv({
            ld_iss: _ld_iss,
            hdr: '"店舗","営業日","入店ID","入店区分","顧客名","客数（常連）","客数（新規）","総客数","コース","基本時間","延長時間","総サービス時間","開始時刻","終了時刻","支払総額","基本料金","注文料金","総サービス料金","チャージ料金（割引前）","消費税（割引前）","ワンドリンクサービス数","サービス#2","チャージ割引","消費税割引","その他割引額","割引総額","備考","バインダ","接客状況","現金払額","カード払額","最終更新日時","最終更新者"',
            o_val: _d_is => {
              return '"{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}"'.f(
                _d_is.cm20c310 || '',
                _d_is.it50d110 || '',
                _d_is._KEY || '',
                _d_is.it10t110 || '',
                _d_is.it10i410 || '',
                _d_is.it10i310 || '',
                _d_is.it10i320 || '',
                _d_is.it10i330 || '',
                _d_is.cm50c310 || '',
                _d_is.it10i510 || '',
                _d_is.it10i520 || '',
                _d_is.it10i530 || '',
                _d_is.it10d110 || '',
                _d_is.it10d120 || '',
                _d_is.it10ia70 || '',
                _d_is.it10i610 || '',
                _d_is.it10i620 || '',
                _d_is.it10i640 || '',
                _d_is.it10ia10 || '',
                _d_is.it10ia30 || '',
                _d_is.it10i210 || '',
                _d_is.it10i220 || '',
                _d_is.it10i2a0 || '',
                _d_is.it10i2b0 || '',
                _d_is.it10ia50 || '',
                _d_is.it10ia40 || '',
                _d_is.it10c310.replace(/"/g, '“') || '',
                _d_is.im10c310 || '',
                _d_is.it10s110 || '',
                _d_is.it10i720 || '',
                _d_is.it10i730 || '',
                _d_is.it10cy30 || '',
                _d_is.cm10c330 || '',
              );
            }
          })
          bf.myFL_ept({
            fileName: '入店時刻一覧_{}.csv'.f(bf.myDT_get_now().replace(/ /g, '-').replace(/-/g, '').replace(/:/g, '').substr(0,12)),
            val: _csv
          });
        });
      },
    },
    '外販担当者一覧CSV': {
      pfx: '外販担当者一覧 CSV出力',
      onPrs: () => {
        cf.myCB_call_slc({
          ctr: 'nlm',
          elm: 'it11',
          n_dms: 3,
          cnd: bf.q('IFNULL([it11cz10],"10")<>"0" AND [it11b11k] IN (SELECT [_KEY]::TEXT FROM [t_it10] WHERE [t_it10].[it10b31k] IN (SELECT [_KEY]::TEXT FROM [t_it50] WHERE [t_it50].[it50b21k]="{}"))'.f(
            global.c?.state.sgcd_pageCmns?.it60_key
          )),
          do_rfrs: {
            cm10: _d_is => bf.q('[_KEY]={}'.f(_d_is.it11b21k)),
            cm1i: _d_is => bf.q('[cm1ib11k]="{}"'.f(_d_is.it11b21k)),
            cm20: _d_is => bf.q('[_KEY]=(SELECT [it10b11k]::NUMERIC::INTEGER FROM [t_it10] WHERE [t_it10].[_KEY]={})'.f(_d_is.it11b11k)),
            it10: _d_is => bf.q('[_KEY]={}'.f(_d_is.it11b11k)),
            it50: _d_is => bf.q('[_KEY]=(SELECT [it10b31k]::NUMERIC::INTEGER FROM [t_it10] WHERE [t_it10].[_KEY]={})'.f(_d_is.it11b11k)),
          },
          dld_pcksss: {
          }, 
        })
        .then( _ld_iss => {
          let _csv = bf.myFL_csv({
            ld_iss: _ld_iss,
            hdr: '"店舗","営業日","入店ID","顧客名","客数（常連）","客数（新規）","総客数","外販担当者ドリンク番号","外販担当者"',
            o_val: _d_is => {
              return '"{}","{}","{}","{}","{}","{}","{}","{}","{}"'.f(
                _d_is.cm20c310 || '',
                _d_is.it50d110 || '',
                _d_is.it10_key || '',
                _d_is.it10i410 || '',
                _d_is.it10i310 || '0',
                _d_is.it10i320 || '0',
                _d_is.it10i330 || '0',
                _d_is.cm1ii110 || '',
                _d_is.cm10c330 || '',
              );
            }
          })
          bf.myFL_ept({
            fileName: '外販担当者一覧_{}.csv'.f(bf.myDT_get_now().replace(/ /g, '-').replace(/-/g, '').replace(/:/g, '').substr(0,12)),
            val: _csv
          });
        });
      },
    },
    '入席一覧CSV': {
      pfx: '入席一覧 CSV出力',
      onPrs: () => {
        cf.myCB_call_slc({
          ctr: 'nlm',
          elm: 'it20',
          n_dms: 3,
          cnd: bf.q('[it20b11k] IN (SELECT [_KEY]::TEXT FROM [t_it10] WHERE [t_it10].[it10b31k] IN (SELECT [_KEY]::TEXT FROM [t_it50] WHERE [t_it50].[it50b21k]="{}"))'.f(
            global.c?.state.sgcd_pageCmns?.it60_key
          )),
          do_rfrs: {
            cm10: _d_is => bf.q('[_KEY]={}'.f(_d_is.it20b21k)),
            cm20: _d_is => bf.q('[_KEY]=(SELECT [it10b11k]::NUMERIC::INTEGER FROM [t_it10] WHERE [t_it10].[_KEY]={})'.f(_d_is.it20b11k)),
            it10: _d_is => bf.q('[_KEY]={}'.f(_d_is.it20b11k)),
            it50: _d_is => bf.q('[_KEY]=(SELECT [it10b31k]::NUMERIC::INTEGER FROM [t_it10] WHERE [t_it10].[_KEY]={})'.f(_d_is.it20b11k)),
          },
          dld_pcksss: {
            it20s110: [
              {key:'-1', pfx: '顧客情報未確認'}, // 未接客
              {key:'0', pfx: '入席前'}, // 未接客
              {key:'10', pfx: '入席中'}, // 接客中
              {key:'20', pfx: '退席済'}, // 接客済
            ],
          }, 
        })
        .then( _ld_iss => {
          let _csv = bf.myFL_csv({
            ld_iss: _ld_iss,
            hdr: '"店舗","営業日","入店ID","スタッフ","入席状況","入席日時","退席日時"',
            o_val: _d_is => {
              return '"{}","{}","{}","{}","{}","{}","{}"'.f(
                _d_is.cm20c310 || '',
                _d_is.it50d110 || '',
                _d_is.it10_key || '',
                _d_is.cm10c330 || '',
                _d_is.it20s110 || '',
                _d_is.it20d110 || '',
                _d_is.it20d120 || '',
              );
            }
          })
          bf.myFL_ept({
            fileName: '入席一覧_{}.csv'.f(bf.myDT_get_now().replace(/ /g, '-').replace(/-/g, '').replace(/:/g, '').substr(0,12)),
            val: _csv
          });
        });
      },
    },
    '注文一覧CSV': {
      pfx: '注文一覧 CSV出力',
      onPrs: () => {
//bf.l('4949: here')
        cf.myCB_call_slc({
          ctr: 'nlm',
          elm: 'it30',
          n_dms: 3,
          cnd: bf.q(`
            [it30b11k] IN (
              SELECT 
                [_KEY]::TEXT 
              FROM 
                [t_it10] 
              WHERE 
                [t_it10].[it10b31k] IN (
                  SELECT 
                    [_KEY]::TEXT 
                  FROM 
                    [t_it50] 
                  WHERE 
                    [t_it50].[it50b21k]="{}"
                )
            )
          `.f(
            global.c?.state.sgcd_pageCmns?.it60_key
          )),
/*
          do_rfrs: {
            cm10: _d_is => bf.q('[_KEY]={}'.f(_d_is.it30b21k || '0')),
            cm1i: _d_is => bf.q('[cm1ib11k]="{}"'.f(_d_is.it30b21k || '0')),
            cm20: _d_is => bf.q('[_KEY]=(SELECT [it10b11k]::NUMERIC::INTEGER FROM [t_it10] WHERE [t_it10].[_KEY]={})'.f(_d_is.it30b11k)),
            cm50: _d_is => bf.q('[_KEY]={}'.f(_d_is.it30i110)),
            it10: _d_is => bf.q('[_KEY]={}'.f(_d_is.it30b11k)),
            it50: _d_is => bf.q('[_KEY]=(SELECT [it10b31k]::NUMERIC::INTEGER FROM [t_it10] WHERE [t_it10].[_KEY]={})'.f(_d_is.it30b11k)),
          },
*/
          ddo_rfrss: {
            cm10a: {
              elm: 'cm10',
              o_cnd: _d_is => bf.q('[_KEY]={}'.f(_d_is.it30b21k || '0')),
            },
            cm1ia: {
              elm: 'cm1i',
              o_cnd: _d_is => bf.q('[cm1ib11k]="{}"'.f(_d_is.it30b21k || '0'))
            },
            cm10b: {
              elm: 'cm10',
              o_cnd: _d_is => bf.q('[_KEY]={}'.f(_d_is.it30cy20 || '0')),
            },
            cm1ib: {
              elm: 'cm1i',
              o_cnd: _d_is => bf.q('[cm1ib11k]="{}"'.f(_d_is.it30cy20 || '0'))
            },
            cm20: {
              elm: 'cm20',
              o_cnd: _d_is => bf.q('[_KEY]=(SELECT [it10b11k]::NUMERIC::INTEGER FROM [t_it10] WHERE [t_it10].[_KEY]={})'.f(_d_is.it30b11k))
            },
            cm50: {
              elm: 'cm50',
              o_cnd: _d_is => bf.q('[_KEY]={}'.f(!_d_is.it30i110 || _d_is.it30i110 == '' ? -1 : _d_is.it30i110)) // it30i110: 商品 
            },
            it10: {
              elm: 'it10',
              o_cnd: _d_is => bf.q('[_KEY]={}'.f(_d_is.it30b11k))
            },
            it50: {
              elm: 'it50',
              o_cnd: _d_is => bf.q('[_KEY]=(SELECT [it10b31k]::NUMERIC::INTEGER FROM [t_it10] WHERE [t_it10].[_KEY]={})'.f(_d_is.it30b11k))
            },
          },
          dld_pcksss: {
          },
          ld_sortss: [
            { fld: 'it30b11k', dtn: 'asc', mode: 'nmb'}
          ], 
        })
        .then( _ld_iss => {
          //bf.l(`8441: ${JSON.stringify(_ld_iss)}`)
          let _csv = bf.myFL_csv({
            ld_iss: _ld_iss,
            hdr: '"店舗","営業日","入店ID","商品","単価","数量","金額","サービス数量","サービス金額","担当者ドリンク番号","担当者","更新者","更新日時"',
            o_val: _d_is => {
//              return '"{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}"'.f(
              return '"{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}"'.f(
                _d_is.cm20.cm20c310 || '',
                _d_is.it50.it50d110 || '',
                _d_is.it10.it10_key || '',
                _d_is.cm50?.cm50c310 || '',
                _d_is.it30i210 || '0',
                _d_is.it30i220 || '0',
                _d_is.it30i230 || '0',
                _d_is.it30i330 || '0',
                _d_is.it30i340 || '0',
                _d_is.cm1ia.cm1ii110 || '',
                _d_is.cm10a.cm10c330 || '',
                _d_is.cm10b.cm10c330 || '',
                _d_is.it30cy10 || '',
              );
            }
          })
          bf.myFL_ept({
            fileName: '注文一覧_{}.csv'.f(bf.myDT_get_now().replace(/ /g, '-').replace(/-/g, '').replace(/:/g, '').substr(0,12)),
            val: _csv
          });
        });
      },
    },
    '関与者一覧CSV': {
      pfx: '関与者一覧 CSV出力',
      onPrs: () => {
	cf.myCB_call_slc({
          ctr: 'nlm',
          elm: 'it31',
          n_dms: 3,
          cnd: bf.q(`
            [it31b11k] IN (
              SELECT 
                [_KEY]::TEXT 
              FROM 
                [t_it10] 
              WHERE 
                [t_it10].[it10b31k] IN (
                  SELECT 
                    [_KEY]::TEXT 
                  FROM 
                    [t_it50] 
                  WHERE 
                    [t_it50].[it50b21k]="{}"
                )
            ) AND
            EXISTS(
              SELECT
                *
              FROM
                [t_it30]
              WHERE
                [t_it30].[_KEY]=[it31b21k]::NUMERIC::INTEGER AND
                [it30t110] IN ("230")
            ) AND
            IFNULL([it31cz10],"10")<>"0"
          `.f(
            global.c?.state.sgcd_pageCmns?.it60_key
          )),
          do_rfrs: {
            cm10: _d_is => bf.q('[_KEY]={}'.f(_d_is.it31b31k || '0')),
            cm1i: _d_is => bf.q('[cm1ib11k]="{}"'.f(_d_is.it31b31k || '0')),
            cm20: _d_is => bf.q('[_KEY]=(SELECT [it10b11k]::NUMERIC::INTEGER FROM [t_it10] WHERE [t_it10].[_KEY]={})'.f(_d_is.it31b11k)),
            cm50: _d_is => bf.q('[_KEY]=(SELECT [it30i110]::NUMERIC::INTEGER FROM [t_it30] WHERE [t_it30].[_KEY]={})'.f(_d_is.it31b21k)),
            it10: _d_is => bf.q('[_KEY]={}'.f(_d_is.it31b11k)),
            it30: _d_is => bf.q('[_KEY]={}'.f(_d_is.it31b21k || '')),
            it50: _d_is => bf.q('[_KEY]=(SELECT [it10b31k]::NUMERIC::INTEGER FROM [t_it10] WHERE [t_it10].[_KEY]={})'.f(_d_is.it31b11k)),
          },
          dld_pcksss: {
          }, 
        })
        .then( _ld_iss => {
          let _csv = bf.myFL_csv({
            ld_iss: _ld_iss,
            hdr: '"店舗","営業日","入店ID","注文明細ID","商品","単価","数量","金額","関与者ドリンク番号","関与者","関与度","関与度比"',
            o_val: _d_is => {
              return '"{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}"'.f(
                _d_is.cm20c310 || '',
                _d_is.it50d110 || '',
                _d_is.it10_key || '',
                _d_is.it30_key || '',
                _d_is.cm50c310 || '',
                _d_is.it30i210 || '0',
                _d_is.it30i220 || '0',
                _d_is.it30i230 || '0',
                _d_is.cm1ii110 || '',
                _d_is.cm10c330 || '',
                _d_is.it31i110 || '',
                bf.n(_d_is.it31i130) || '',
              );
            }
          })
          bf.myFL_ept({
            fileName: '関与者一覧_{}.csv'.f(bf.myDT_get_now().replace(/ /g, '-').replace(/-/g, '').replace(/:/g, '').substr(0,12)),
            val: _csv
          });
        });
      },
    },
    'スタッフ一覧CSV': {
      pfx: 'スタッフ一覧 CSV出力',
      onPrs: () => {
        cf.myCB_call_slc({
          ctr: 'nlm',
          elm: 'cm10',
          n_dms: 3,
          cnd: bf.q('[cm10b21k]="{}"'.f(global.c?.state.sgcd_pageCmns?.cm20_key)),
          do_rfrs: {
            cm20: _d_is => bf.q('[_KEY]={}'.f(_d_is.cm10b21k)),
            cm11: _d_is => bf.q('[cm11b11k]="{}"'.f(_d_is._KEY)),
            cm1i: _d_is => bf.q('[cm1ib11k]="{}"'.f(_d_is._KEY)),
          },
          dld_pcksss: {
            cm10c410: [
              {key:'10', pfx: 'キャスト'},
              {key:'90', pfx: '店舗運営者'},
              {key:'80', pfx: '事務担当者'},
            ],
            cm10cz10: [
              {key:'10', pfx: '表示する'},
              {key:'0', pfx: '表示しない'},
            ],
          }, 
        })
        .then( _ld_iss => {
          let _csv = bf.myFL_csv({
            ld_iss: _ld_iss,
            hdr: '"店舗","メール","本名","源氏名","生年月日","住所","ドリンク番号","利用者区分","表示の有無"',
            o_val: _d_is => {
              return '"{}","{}","{}","{}","{}","{}","{}","{}","{}"'.f(
                _d_is.cm20c310 || '',
                _d_is.cm10i110 || '',
                _d_is.cm10c310 || '',
                _d_is.cm10c330 || '',
                _d_is.cm11i210 || '',
                _d_is.cm11i120 || '',
                _d_is.cm1ii110 || '',
                _d_is.cm10c410 || '',
                _d_is.cm10cz10 || '',
              );
            }
          })
          bf.myFL_ept({
            fileName: 'スタッフ一覧_{}.csv'.f(bf.myDT_get_now().replace(/ /g, '-').replace(/-/g, '').replace(/:/g, '').substr(0,12)),
            val: _csv
          });
        });
      },
    },
    'バインダ一覧CSV': {
      pfx: 'バインダ一覧 CSV出力',
      onPrs: () => {
        cf.myCB_call_slc({
          ctr: 'nlm',
          elm: 'im10',
          n_dms: 3,
          cnd: bf.q('[im10b11k]="{}"'.f(global.c?.state.sgcd_pageCmns?.cm20_key)),
          do_rfrs: {
            cm20: _d_is => bf.q('[_KEY]={}'.f(_d_is.im10b11k)),
          },
          dld_pcksss: {
            im10cz10: [
              {key:'10', pfx: '表示する'},
              {key:'0', pfx: '表示しない'},
            ],
          }, 
        })
        .then( _ld_iss => {
          let _csv = bf.myFL_csv({
            ld_iss: _ld_iss,
            hdr: '"店舗","バインダ名","表示の有無"',
            o_val: _d_is => {
              return '"{}","{}","{}"'.f(
                _d_is.cm20c310 || '',
                _d_is.im10c310 || '',
                _d_is.im10cz10 || '',
              );
            }
          })
          bf.myFL_ept({
            fileName: 'バインダ一覧_{}.csv'.f(bf.myDT_get_now().replace(/ /g, '-').replace(/-/g, '').replace(/:/g, '').substr(0,12)),
            val: _csv
          });
        });
      },
    },
    '商品分類一覧CSV': {
      pfx: '商品分類一覧 CSV出力',
      onPrs: () => {
        cf.myCB_call_slc({
          ctr: 'nlm',
          elm: 'cm5t',
          n_dms: 3,
          cnd: bf.q('[cm5tb11k]="{}"'.f(global.c?.state.sgcd_pageCmns?.cm20_key)),
          do_rfrs: {
            cm20: _d_is => bf.q('[_KEY]={}'.f(_d_is.cm5tb11k)),
          },
          dld_pcksss: {
            cm5tcz10: [
              {key:'10', pfx: '表示する'},
              {key:'0', pfx: '表示しない'},
            ],
          }, 
        })
        .then( _ld_iss => {
          let _csv = bf.myFL_csv({
            ld_iss: _ld_iss,
            hdr: '"店舗","商品分類名","表示順","表示の有無"',
            o_val: _d_is => {
              return '"{}","{}","{}","{}"'.f(
                _d_is.cm20c310 || '',
                _d_is.cm5tc310 || '',
                _d_is.cm5tcx10 || '',
                _d_is.cm5tcz10 || '',
              );
            }
          })
          bf.myFL_ept({
            fileName: '商品分類一覧_{}.csv'.f(bf.myDT_get_now().replace(/ /g, '-').replace(/-/g, '').replace(/:/g, '').substr(0,12)),
            val: _csv
          });
        });
      },
    },
    '商品一覧CSV': {
      pfx: '商品一覧 CSV出力',
      onPrs: () => {
        cf.myCB_call_slc({
          ctr: 'nlm',
          elm: 'cm50',
          n_dms: 3,
          cnd: bf.q('[cm50b11k]="{}"'.f(global.c?.state.sgcd_pageCmns?.cm20_key)),
          do_rfrs: {
            cm20: _d_is => bf.q('[_KEY]={}'.f(_d_is.cm50b11k)),
            cm5i: _d_is => bf.q('[cm5ib11k]="{}"'.f(_d_is._KEY)),
          },
          dld_pcksss: {
            cm50t110: [
              {key:'0', pfx: '未選択'},
              {key:'110', pfx: 'コース（時間指定）'},
              {key:'120', pfx: 'コース（時刻指定）'},
              {key:'230', pfx: 'シャンパンドリンク'},
              {key:'220', pfx: 'コース延長'},
              {key:'210', pfx: 'ポイント付ドリンク'},
              {key:'290', pfx: 'その他'},
            ],
            cm50cz10: [
              {key:'10', pfx: '表示する'},
              {key:'0', pfx: '表示しない'},
            ],
          }, 
        })
        .then( _ld_iss => {
          let _csv = bf.myFL_csv({
            ld_iss: _ld_iss,
            hdr: '"店舗","商品種別","商品名","コース時間","コース終了時刻","延長時間","基本料金","３０分延長料金","６０分延長料金","最大数量","表示順","表示の有無"',
            o_val: _d_is => {
              return '"{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}","{}"'.f(
                _d_is.cm20c310 || '',
                _d_is.cm50t110 || '',
                _d_is.cm50c310 || '',
                (_d_is.cm50t110 == '110') ? (_d_is.cm5ii110 || '0') : '0',
                _d_is.cm5ii410 || '',
                (_d_is.cm50t110 == '220') ? (_d_is.cm5ii110 || '0') : '0',
                _d_is.cm50i110 || '',
                _d_is.cm5ii210 || '',
                _d_is.cm5ii220 || '',
                _d_is.cm5ii310 || '',
                _d_is.cm50cx10 || '',
                _d_is.cm50cz10 || '',
              );
            }
          })
          bf.myFL_ept({
            fileName: '商品一覧_{}.csv'.f(bf.myDT_get_now().replace(/ /g, '-').replace(/-/g, '').replace(/:/g, '').substr(0,12)),
            val: _csv
          });
        });
      },
    },
  };

  static ild_onChgss = () => [ // onChgss for individual app
  ];

}
